import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"fetchPolicy":"cache-and-network"} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _uuid: { input: any; output: any; }
  bigint: { input: any; output: any; }
  float8: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  time: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** columns and relationships of "activitePreferentielle" */
export type ActivitePreferentielle = {
  __typename?: 'ActivitePreferentielle';
  distanceMax: Scalars['numeric']['output'];
  distanceMin: Scalars['numeric']['output'];
  id: Scalars['uuid']['output'];
  nom: Scalars['String']['output'];
  /** An object relationship */
  patient: Patient;
  patientId: Scalars['uuid']['output'];
};

/** aggregated selection of "activitePreferentielle" */
export type ActivitePreferentielleAggregate = {
  __typename?: 'ActivitePreferentielleAggregate';
  aggregate?: Maybe<ActivitePreferentielleAggregateFields>;
  nodes: Array<ActivitePreferentielle>;
};

export type ActivitePreferentielleAggregateBoolExp = {
  count?: InputMaybe<ActivitePreferentielleAggregateBoolExpCount>;
};

/** aggregate fields of "activitePreferentielle" */
export type ActivitePreferentielleAggregateFields = {
  __typename?: 'ActivitePreferentielleAggregateFields';
  avg?: Maybe<ActivitePreferentielleAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActivitePreferentielleMaxFields>;
  min?: Maybe<ActivitePreferentielleMinFields>;
  stddev?: Maybe<ActivitePreferentielleStddevFields>;
  stddevPop?: Maybe<ActivitePreferentielleStddevPopFields>;
  stddevSamp?: Maybe<ActivitePreferentielleStddevSampFields>;
  sum?: Maybe<ActivitePreferentielleSumFields>;
  varPop?: Maybe<ActivitePreferentielleVarPopFields>;
  varSamp?: Maybe<ActivitePreferentielleVarSampFields>;
  variance?: Maybe<ActivitePreferentielleVarianceFields>;
};


/** aggregate fields of "activitePreferentielle" */
export type ActivitePreferentielleAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activitePreferentielle" */
export type ActivitePreferentielleAggregateOrderBy = {
  avg?: InputMaybe<ActivitePreferentielleAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ActivitePreferentielleMaxOrderBy>;
  min?: InputMaybe<ActivitePreferentielleMinOrderBy>;
  stddev?: InputMaybe<ActivitePreferentielleStddevOrderBy>;
  stddevPop?: InputMaybe<ActivitePreferentielleStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ActivitePreferentielleStddevSampOrderBy>;
  sum?: InputMaybe<ActivitePreferentielleSumOrderBy>;
  varPop?: InputMaybe<ActivitePreferentielleVarPopOrderBy>;
  varSamp?: InputMaybe<ActivitePreferentielleVarSampOrderBy>;
  variance?: InputMaybe<ActivitePreferentielleVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "activitePreferentielle" */
export type ActivitePreferentielleArrRelInsertInput = {
  data: Array<ActivitePreferentielleInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ActivitePreferentielleOnConflict>;
};

/** aggregate avg on columns */
export type ActivitePreferentielleAvgFields = {
  __typename?: 'ActivitePreferentielleAvgFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleAvgOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "activitePreferentielle". All fields are combined with a logical 'AND'. */
export type ActivitePreferentielleBoolExp = {
  _and?: InputMaybe<Array<ActivitePreferentielleBoolExp>>;
  _not?: InputMaybe<ActivitePreferentielleBoolExp>;
  _or?: InputMaybe<Array<ActivitePreferentielleBoolExp>>;
  distanceMax?: InputMaybe<NumericComparisonExp>;
  distanceMin?: InputMaybe<NumericComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  nom?: InputMaybe<StringComparisonExp>;
  patient?: InputMaybe<PatientBoolExp>;
  patientId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "activitePreferentielle" */
export type ActivitePreferentielleConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'activitePreferentielle_pkey';

/** input type for incrementing numeric columns in table "activitePreferentielle" */
export type ActivitePreferentielleIncInput = {
  distanceMax?: InputMaybe<Scalars['numeric']['input']>;
  distanceMin?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "activitePreferentielle" */
export type ActivitePreferentielleInsertInput = {
  distanceMax?: InputMaybe<Scalars['numeric']['input']>;
  distanceMin?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<PatientObjRelInsertInput>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ActivitePreferentielleMaxFields = {
  __typename?: 'ActivitePreferentielleMaxFields';
  distanceMax?: Maybe<Scalars['numeric']['output']>;
  distanceMin?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleMaxOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ActivitePreferentielleMinFields = {
  __typename?: 'ActivitePreferentielleMinFields';
  distanceMax?: Maybe<Scalars['numeric']['output']>;
  distanceMin?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleMinOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "activitePreferentielle" */
export type ActivitePreferentielleMutationResponse = {
  __typename?: 'ActivitePreferentielleMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivitePreferentielle>;
};

/** on_conflict condition type for table "activitePreferentielle" */
export type ActivitePreferentielleOnConflict = {
  constraint: ActivitePreferentielleConstraint;
  updateColumns?: Array<ActivitePreferentielleUpdateColumn>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};

/** Ordering options when selecting data from "activitePreferentielle". */
export type ActivitePreferentielleOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  patient?: InputMaybe<PatientOrderBy>;
  patientId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: activitePreferentielle */
export type ActivitePreferentiellePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activitePreferentielle" */
export type ActivitePreferentielleSelectColumn =
  /** column name */
  | 'distanceMax'
  /** column name */
  | 'distanceMin'
  /** column name */
  | 'id'
  /** column name */
  | 'nom'
  /** column name */
  | 'patientId';

/** input type for updating data in table "activitePreferentielle" */
export type ActivitePreferentielleSetInput = {
  distanceMax?: InputMaybe<Scalars['numeric']['input']>;
  distanceMin?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type ActivitePreferentielleStddevFields = {
  __typename?: 'ActivitePreferentielleStddevFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleStddevOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ActivitePreferentielleStddevPopFields = {
  __typename?: 'ActivitePreferentielleStddevPopFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleStddevPopOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ActivitePreferentielleStddevSampFields = {
  __typename?: 'ActivitePreferentielleStddevSampFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleStddevSampOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "activitePreferentielle" */
export type ActivitePreferentielleStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ActivitePreferentielleStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ActivitePreferentielleStreamCursorValueInput = {
  distanceMax?: InputMaybe<Scalars['numeric']['input']>;
  distanceMin?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type ActivitePreferentielleSumFields = {
  __typename?: 'ActivitePreferentielleSumFields';
  distanceMax?: Maybe<Scalars['numeric']['output']>;
  distanceMin?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleSumOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** update columns of table "activitePreferentielle" */
export type ActivitePreferentielleUpdateColumn =
  /** column name */
  | 'distanceMax'
  /** column name */
  | 'distanceMin'
  /** column name */
  | 'id'
  /** column name */
  | 'nom'
  /** column name */
  | 'patientId';

export type ActivitePreferentielleUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivitePreferentielleIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivitePreferentielleSetInput>;
  /** filter the rows which have to be updated */
  where: ActivitePreferentielleBoolExp;
};

/** aggregate varPop on columns */
export type ActivitePreferentielleVarPopFields = {
  __typename?: 'ActivitePreferentielleVarPopFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleVarPopOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ActivitePreferentielleVarSampFields = {
  __typename?: 'ActivitePreferentielleVarSampFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleVarSampOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ActivitePreferentielleVarianceFields = {
  __typename?: 'ActivitePreferentielleVarianceFields';
  distanceMax?: Maybe<Scalars['Float']['output']>;
  distanceMin?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "activitePreferentielle" */
export type ActivitePreferentielleVarianceOrderBy = {
  distanceMax?: InputMaybe<OrderBy>;
  distanceMin?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type BigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** columns and relationships of "chirurgien" */
export type Chirurgien = {
  __typename?: 'Chirurgien';
  adresse?: Maybe<Scalars['String']['output']>;
  clinique?: Maybe<Scalars['String']['output']>;
  codePostal?: Maybe<Scalars['String']['output']>;
  cognitoToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  favoris: Array<Favoris>;
  /** An aggregate relationship */
  favorisAggregate: FavorisAggregate;
  /** An array relationship */
  helpTexts: Array<HelpTexts>;
  /** An aggregate relationship */
  helpTextsAggregate: HelpTextsAggregate;
  id: Scalars['uuid']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  nom: Scalars['String']['output'];
  /** An array relationship */
  patients: Array<Patient>;
  /** An aggregate relationship */
  patientsAggregate: PatientAggregate;
  prenom: Scalars['String']['output'];
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn: Scalars['String']['output'];
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr: Scalars['String']['output'];
  ville?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienFavorisArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienFavorisAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienHelpTextsArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienHelpTextsAggregateArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienPatientsArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};


/** columns and relationships of "chirurgien" */
export type ChirurgienPatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};

/** aggregated selection of "chirurgien" */
export type ChirurgienAggregate = {
  __typename?: 'ChirurgienAggregate';
  aggregate?: Maybe<ChirurgienAggregateFields>;
  nodes: Array<Chirurgien>;
};

/** aggregate fields of "chirurgien" */
export type ChirurgienAggregateFields = {
  __typename?: 'ChirurgienAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChirurgienMaxFields>;
  min?: Maybe<ChirurgienMinFields>;
};


/** aggregate fields of "chirurgien" */
export type ChirurgienAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChirurgienSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "chirurgien". All fields are combined with a logical 'AND'. */
export type ChirurgienBoolExp = {
  _and?: InputMaybe<Array<ChirurgienBoolExp>>;
  _not?: InputMaybe<ChirurgienBoolExp>;
  _or?: InputMaybe<Array<ChirurgienBoolExp>>;
  adresse?: InputMaybe<StringComparisonExp>;
  clinique?: InputMaybe<StringComparisonExp>;
  codePostal?: InputMaybe<StringComparisonExp>;
  cognitoToken?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  favoris?: InputMaybe<FavorisBoolExp>;
  favorisAggregate?: InputMaybe<FavorisAggregateBoolExp>;
  helpTexts?: InputMaybe<HelpTextsBoolExp>;
  helpTextsAggregate?: InputMaybe<HelpTextsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  logo?: InputMaybe<StringComparisonExp>;
  nom?: InputMaybe<StringComparisonExp>;
  patients?: InputMaybe<PatientBoolExp>;
  patientsAggregate?: InputMaybe<PatientAggregateBoolExp>;
  prenom?: InputMaybe<StringComparisonExp>;
  titreEn?: InputMaybe<StringComparisonExp>;
  titreFr?: InputMaybe<StringComparisonExp>;
  ville?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "chirurgien" */
export type ChirurgienConstraint =
  /** unique or primary key constraint on columns "cognito_token" */
  | 'chirurgien_cognito_token_key'
  /** unique or primary key constraint on columns "id" */
  | 'chirurgien_pkey';

/** input type for inserting data into table "chirurgien" */
export type ChirurgienInsertInput = {
  adresse?: InputMaybe<Scalars['String']['input']>;
  clinique?: InputMaybe<Scalars['String']['input']>;
  codePostal?: InputMaybe<Scalars['String']['input']>;
  cognitoToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  favoris?: InputMaybe<FavorisArrRelInsertInput>;
  helpTexts?: InputMaybe<HelpTextsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  patients?: InputMaybe<PatientArrRelInsertInput>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr?: InputMaybe<Scalars['String']['input']>;
  ville?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ChirurgienMaxFields = {
  __typename?: 'ChirurgienMaxFields';
  adresse?: Maybe<Scalars['String']['output']>;
  clinique?: Maybe<Scalars['String']['output']>;
  codePostal?: Maybe<Scalars['String']['output']>;
  cognitoToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn?: Maybe<Scalars['String']['output']>;
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr?: Maybe<Scalars['String']['output']>;
  ville?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ChirurgienMinFields = {
  __typename?: 'ChirurgienMinFields';
  adresse?: Maybe<Scalars['String']['output']>;
  clinique?: Maybe<Scalars['String']['output']>;
  codePostal?: Maybe<Scalars['String']['output']>;
  cognitoToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn?: Maybe<Scalars['String']['output']>;
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr?: Maybe<Scalars['String']['output']>;
  ville?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "chirurgien" */
export type ChirurgienMutationResponse = {
  __typename?: 'ChirurgienMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Chirurgien>;
};

/** input type for inserting object relation for remote table "chirurgien" */
export type ChirurgienObjRelInsertInput = {
  data: ChirurgienInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChirurgienOnConflict>;
};

/** on_conflict condition type for table "chirurgien" */
export type ChirurgienOnConflict = {
  constraint: ChirurgienConstraint;
  updateColumns?: Array<ChirurgienUpdateColumn>;
  where?: InputMaybe<ChirurgienBoolExp>;
};

/** Ordering options when selecting data from "chirurgien". */
export type ChirurgienOrderBy = {
  adresse?: InputMaybe<OrderBy>;
  clinique?: InputMaybe<OrderBy>;
  codePostal?: InputMaybe<OrderBy>;
  cognitoToken?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  favorisAggregate?: InputMaybe<FavorisAggregateOrderBy>;
  helpTextsAggregate?: InputMaybe<HelpTextsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  logo?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  patientsAggregate?: InputMaybe<PatientAggregateOrderBy>;
  prenom?: InputMaybe<OrderBy>;
  titreEn?: InputMaybe<OrderBy>;
  titreFr?: InputMaybe<OrderBy>;
  ville?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: chirurgien */
export type ChirurgienPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "chirurgien" */
export type ChirurgienSelectColumn =
  /** column name */
  | 'adresse'
  /** column name */
  | 'clinique'
  /** column name */
  | 'codePostal'
  /** column name */
  | 'cognitoToken'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'logo'
  /** column name */
  | 'nom'
  /** column name */
  | 'prenom'
  /** column name */
  | 'titreEn'
  /** column name */
  | 'titreFr'
  /** column name */
  | 'ville';

/** input type for updating data in table "chirurgien" */
export type ChirurgienSetInput = {
  adresse?: InputMaybe<Scalars['String']['input']>;
  clinique?: InputMaybe<Scalars['String']['input']>;
  codePostal?: InputMaybe<Scalars['String']['input']>;
  cognitoToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr?: InputMaybe<Scalars['String']['input']>;
  ville?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "chirurgien" */
export type ChirurgienStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChirurgienStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChirurgienStreamCursorValueInput = {
  adresse?: InputMaybe<Scalars['String']['input']>;
  clinique?: InputMaybe<Scalars['String']['input']>;
  codePostal?: InputMaybe<Scalars['String']['input']>;
  cognitoToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché après le nom en anglais (ex : MD) */
  titreEn?: InputMaybe<Scalars['String']['input']>;
  /** Titre affiché devant le nom en français (ex : Dr.) */
  titreFr?: InputMaybe<Scalars['String']['input']>;
  ville?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "chirurgien" */
export type ChirurgienUpdateColumn =
  /** column name */
  | 'adresse'
  /** column name */
  | 'clinique'
  /** column name */
  | 'codePostal'
  /** column name */
  | 'cognitoToken'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'id'
  /** column name */
  | 'logo'
  /** column name */
  | 'nom'
  /** column name */
  | 'prenom'
  /** column name */
  | 'titreEn'
  /** column name */
  | 'titreFr'
  /** column name */
  | 'ville';

export type ChirurgienUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChirurgienSetInput>;
  /** filter the rows which have to be updated */
  where: ChirurgienBoolExp;
};

/** columns and relationships of "choix" */
export type Choix = {
  __typename?: 'Choix';
  affichageDefocus?: Maybe<Scalars['numeric']['output']>;
  decalage: Scalars['numeric']['output'];
  decalageCourbeExistante: Scalars['numeric']['output'];
  final?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  implant?: Maybe<Implant>;
  implantId?: Maybe<Scalars['uuid']['output']>;
  laboratoireId?: Maybe<Scalars['uuid']['output']>;
  materiau?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  oeil: Oeil;
  oeilId: Scalars['uuid']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "choix" */
export type ChoixAggregate = {
  __typename?: 'ChoixAggregate';
  aggregate?: Maybe<ChoixAggregateFields>;
  nodes: Array<Choix>;
};

export type ChoixAggregateBoolExp = {
  bool_and?: InputMaybe<ChoixAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ChoixAggregateBoolExpBool_Or>;
  count?: InputMaybe<ChoixAggregateBoolExpCount>;
};

/** aggregate fields of "choix" */
export type ChoixAggregateFields = {
  __typename?: 'ChoixAggregateFields';
  avg?: Maybe<ChoixAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ChoixMaxFields>;
  min?: Maybe<ChoixMinFields>;
  stddev?: Maybe<ChoixStddevFields>;
  stddevPop?: Maybe<ChoixStddevPopFields>;
  stddevSamp?: Maybe<ChoixStddevSampFields>;
  sum?: Maybe<ChoixSumFields>;
  varPop?: Maybe<ChoixVarPopFields>;
  varSamp?: Maybe<ChoixVarSampFields>;
  variance?: Maybe<ChoixVarianceFields>;
};


/** aggregate fields of "choix" */
export type ChoixAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChoixSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "choix" */
export type ChoixAggregateOrderBy = {
  avg?: InputMaybe<ChoixAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChoixMaxOrderBy>;
  min?: InputMaybe<ChoixMinOrderBy>;
  stddev?: InputMaybe<ChoixStddevOrderBy>;
  stddevPop?: InputMaybe<ChoixStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ChoixStddevSampOrderBy>;
  sum?: InputMaybe<ChoixSumOrderBy>;
  varPop?: InputMaybe<ChoixVarPopOrderBy>;
  varSamp?: InputMaybe<ChoixVarSampOrderBy>;
  variance?: InputMaybe<ChoixVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "choix" */
export type ChoixArrRelInsertInput = {
  data: Array<ChoixInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChoixOnConflict>;
};

/** aggregate avg on columns */
export type ChoixAvgFields = {
  __typename?: 'ChoixAvgFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "choix" */
export type ChoixAvgOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "choix". All fields are combined with a logical 'AND'. */
export type ChoixBoolExp = {
  _and?: InputMaybe<Array<ChoixBoolExp>>;
  _not?: InputMaybe<ChoixBoolExp>;
  _or?: InputMaybe<Array<ChoixBoolExp>>;
  affichageDefocus?: InputMaybe<NumericComparisonExp>;
  decalage?: InputMaybe<NumericComparisonExp>;
  decalageCourbeExistante?: InputMaybe<NumericComparisonExp>;
  final?: InputMaybe<BooleanComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  implant?: InputMaybe<ImplantBoolExp>;
  implantId?: InputMaybe<UuidComparisonExp>;
  laboratoireId?: InputMaybe<UuidComparisonExp>;
  materiau?: InputMaybe<StringComparisonExp>;
  oeil?: InputMaybe<OeilBoolExp>;
  oeilId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "choix" */
export type ChoixConstraint =
  /** unique or primary key constraint on columns "oeil_id" */
  | 'choix_oeil_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'choix_pkey';

/** input type for incrementing numeric columns in table "choix" */
export type ChoixIncInput = {
  affichageDefocus?: InputMaybe<Scalars['numeric']['input']>;
  decalage?: InputMaybe<Scalars['numeric']['input']>;
  decalageCourbeExistante?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "choix" */
export type ChoixInsertInput = {
  affichageDefocus?: InputMaybe<Scalars['numeric']['input']>;
  decalage?: InputMaybe<Scalars['numeric']['input']>;
  decalageCourbeExistante?: InputMaybe<Scalars['numeric']['input']>;
  final?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implant?: InputMaybe<ImplantObjRelInsertInput>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  oeil?: InputMaybe<OeilObjRelInsertInput>;
  oeilId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ChoixMaxFields = {
  __typename?: 'ChoixMaxFields';
  affichageDefocus?: Maybe<Scalars['numeric']['output']>;
  decalage?: Maybe<Scalars['numeric']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  implantId?: Maybe<Scalars['uuid']['output']>;
  laboratoireId?: Maybe<Scalars['uuid']['output']>;
  materiau?: Maybe<Scalars['String']['output']>;
  oeilId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "choix" */
export type ChoixMaxOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implantId?: InputMaybe<OrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  oeilId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChoixMinFields = {
  __typename?: 'ChoixMinFields';
  affichageDefocus?: Maybe<Scalars['numeric']['output']>;
  decalage?: Maybe<Scalars['numeric']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  implantId?: Maybe<Scalars['uuid']['output']>;
  laboratoireId?: Maybe<Scalars['uuid']['output']>;
  materiau?: Maybe<Scalars['String']['output']>;
  oeilId?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "choix" */
export type ChoixMinOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implantId?: InputMaybe<OrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  oeilId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "choix" */
export type ChoixMutationResponse = {
  __typename?: 'ChoixMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Choix>;
};

/** on_conflict condition type for table "choix" */
export type ChoixOnConflict = {
  constraint: ChoixConstraint;
  updateColumns?: Array<ChoixUpdateColumn>;
  where?: InputMaybe<ChoixBoolExp>;
};

/** Ordering options when selecting data from "choix". */
export type ChoixOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
  final?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implant?: InputMaybe<ImplantOrderBy>;
  implantId?: InputMaybe<OrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  oeil?: InputMaybe<OeilOrderBy>;
  oeilId?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: choix */
export type ChoixPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "choix" */
export type ChoixSelectColumn =
  /** column name */
  | 'affichageDefocus'
  /** column name */
  | 'decalage'
  /** column name */
  | 'decalageCourbeExistante'
  /** column name */
  | 'final'
  /** column name */
  | 'id'
  /** column name */
  | 'implantId'
  /** column name */
  | 'laboratoireId'
  /** column name */
  | 'materiau'
  /** column name */
  | 'oeilId'
  /** column name */
  | 'type';

/** select "choixAggregateBoolExpBool_andArgumentsColumns" columns of table "choix" */
export type ChoixSelectColumnChoixAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'final';

/** select "choixAggregateBoolExpBool_orArgumentsColumns" columns of table "choix" */
export type ChoixSelectColumnChoixAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'final';

/** input type for updating data in table "choix" */
export type ChoixSetInput = {
  affichageDefocus?: InputMaybe<Scalars['numeric']['input']>;
  decalage?: InputMaybe<Scalars['numeric']['input']>;
  decalageCourbeExistante?: InputMaybe<Scalars['numeric']['input']>;
  final?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  oeilId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ChoixStddevFields = {
  __typename?: 'ChoixStddevFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "choix" */
export type ChoixStddevOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ChoixStddevPopFields = {
  __typename?: 'ChoixStddevPopFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "choix" */
export type ChoixStddevPopOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ChoixStddevSampFields = {
  __typename?: 'ChoixStddevSampFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "choix" */
export type ChoixStddevSampOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "choix" */
export type ChoixStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChoixStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChoixStreamCursorValueInput = {
  affichageDefocus?: InputMaybe<Scalars['numeric']['input']>;
  decalage?: InputMaybe<Scalars['numeric']['input']>;
  decalageCourbeExistante?: InputMaybe<Scalars['numeric']['input']>;
  final?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  oeilId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ChoixSumFields = {
  __typename?: 'ChoixSumFields';
  affichageDefocus?: Maybe<Scalars['numeric']['output']>;
  decalage?: Maybe<Scalars['numeric']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "choix" */
export type ChoixSumOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** update columns of table "choix" */
export type ChoixUpdateColumn =
  /** column name */
  | 'affichageDefocus'
  /** column name */
  | 'decalage'
  /** column name */
  | 'decalageCourbeExistante'
  /** column name */
  | 'final'
  /** column name */
  | 'id'
  /** column name */
  | 'implantId'
  /** column name */
  | 'laboratoireId'
  /** column name */
  | 'materiau'
  /** column name */
  | 'oeilId'
  /** column name */
  | 'type';

export type ChoixUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ChoixIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChoixSetInput>;
  /** filter the rows which have to be updated */
  where: ChoixBoolExp;
};

/** aggregate varPop on columns */
export type ChoixVarPopFields = {
  __typename?: 'ChoixVarPopFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "choix" */
export type ChoixVarPopOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ChoixVarSampFields = {
  __typename?: 'ChoixVarSampFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "choix" */
export type ChoixVarSampOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ChoixVarianceFields = {
  __typename?: 'ChoixVarianceFields';
  affichageDefocus?: Maybe<Scalars['Float']['output']>;
  decalage?: Maybe<Scalars['Float']['output']>;
  decalageCourbeExistante?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "choix" */
export type ChoixVarianceOrderBy = {
  affichageDefocus?: InputMaybe<OrderBy>;
  decalage?: InputMaybe<OrderBy>;
  decalageCourbeExistante?: InputMaybe<OrderBy>;
};

/** ordering argument of a cursor */
export type CursorOrdering =
  /** ascending ordering of the cursor */
  | 'ASC'
  /** descending ordering of the cursor */
  | 'DESC';

/** columns and relationships of "distribution_age_patients" */
export type DistributionAgePatients = {
  __typename?: 'DistributionAgePatients';
  femmes?: Maybe<Scalars['bigint']['output']>;
  hommes?: Maybe<Scalars['bigint']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  nonPrecises?: Maybe<Scalars['bigint']['output']>;
  trancheAge?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "distribution_age_patients" */
export type DistributionAgePatientsAggregate = {
  __typename?: 'DistributionAgePatientsAggregate';
  aggregate?: Maybe<DistributionAgePatientsAggregateFields>;
  nodes: Array<DistributionAgePatients>;
};

/** aggregate fields of "distribution_age_patients" */
export type DistributionAgePatientsAggregateFields = {
  __typename?: 'DistributionAgePatientsAggregateFields';
  avg?: Maybe<DistributionAgePatientsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DistributionAgePatientsMaxFields>;
  min?: Maybe<DistributionAgePatientsMinFields>;
  stddev?: Maybe<DistributionAgePatientsStddevFields>;
  stddevPop?: Maybe<DistributionAgePatientsStddevPopFields>;
  stddevSamp?: Maybe<DistributionAgePatientsStddevSampFields>;
  sum?: Maybe<DistributionAgePatientsSumFields>;
  varPop?: Maybe<DistributionAgePatientsVarPopFields>;
  varSamp?: Maybe<DistributionAgePatientsVarSampFields>;
  variance?: Maybe<DistributionAgePatientsVarianceFields>;
};


/** aggregate fields of "distribution_age_patients" */
export type DistributionAgePatientsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DistributionAgePatientsAvgFields = {
  __typename?: 'DistributionAgePatientsAvgFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "distribution_age_patients". All fields are combined with a logical 'AND'. */
export type DistributionAgePatientsBoolExp = {
  _and?: InputMaybe<Array<DistributionAgePatientsBoolExp>>;
  _not?: InputMaybe<DistributionAgePatientsBoolExp>;
  _or?: InputMaybe<Array<DistributionAgePatientsBoolExp>>;
  femmes?: InputMaybe<BigintComparisonExp>;
  hommes?: InputMaybe<BigintComparisonExp>;
  nombrePatients?: InputMaybe<BigintComparisonExp>;
  nonPrecises?: InputMaybe<BigintComparisonExp>;
  trancheAge?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type DistributionAgePatientsMaxFields = {
  __typename?: 'DistributionAgePatientsMaxFields';
  femmes?: Maybe<Scalars['bigint']['output']>;
  hommes?: Maybe<Scalars['bigint']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  nonPrecises?: Maybe<Scalars['bigint']['output']>;
  trancheAge?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type DistributionAgePatientsMinFields = {
  __typename?: 'DistributionAgePatientsMinFields';
  femmes?: Maybe<Scalars['bigint']['output']>;
  hommes?: Maybe<Scalars['bigint']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  nonPrecises?: Maybe<Scalars['bigint']['output']>;
  trancheAge?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "distribution_age_patients". */
export type DistributionAgePatientsOrderBy = {
  femmes?: InputMaybe<OrderBy>;
  hommes?: InputMaybe<OrderBy>;
  nombrePatients?: InputMaybe<OrderBy>;
  nonPrecises?: InputMaybe<OrderBy>;
  trancheAge?: InputMaybe<OrderBy>;
};

/** select columns of table "distribution_age_patients" */
export type DistributionAgePatientsSelectColumn =
  /** column name */
  | 'femmes'
  /** column name */
  | 'hommes'
  /** column name */
  | 'nombrePatients'
  /** column name */
  | 'nonPrecises'
  /** column name */
  | 'trancheAge';

/** aggregate stddev on columns */
export type DistributionAgePatientsStddevFields = {
  __typename?: 'DistributionAgePatientsStddevFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type DistributionAgePatientsStddevPopFields = {
  __typename?: 'DistributionAgePatientsStddevPopFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type DistributionAgePatientsStddevSampFields = {
  __typename?: 'DistributionAgePatientsStddevSampFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "distribution_age_patients" */
export type DistributionAgePatientsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DistributionAgePatientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DistributionAgePatientsStreamCursorValueInput = {
  femmes?: InputMaybe<Scalars['bigint']['input']>;
  hommes?: InputMaybe<Scalars['bigint']['input']>;
  nombrePatients?: InputMaybe<Scalars['bigint']['input']>;
  nonPrecises?: InputMaybe<Scalars['bigint']['input']>;
  trancheAge?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type DistributionAgePatientsSumFields = {
  __typename?: 'DistributionAgePatientsSumFields';
  femmes?: Maybe<Scalars['bigint']['output']>;
  hommes?: Maybe<Scalars['bigint']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  nonPrecises?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate varPop on columns */
export type DistributionAgePatientsVarPopFields = {
  __typename?: 'DistributionAgePatientsVarPopFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type DistributionAgePatientsVarSampFields = {
  __typename?: 'DistributionAgePatientsVarSampFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DistributionAgePatientsVarianceFields = {
  __typename?: 'DistributionAgePatientsVarianceFields';
  femmes?: Maybe<Scalars['Float']['output']>;
  hommes?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  nonPrecises?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "evolution_chirurgiens" */
export type EvolutionChirurgiens = {
  __typename?: 'EvolutionChirurgiens';
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombreChirurgiens?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "evolution_chirurgiens" */
export type EvolutionChirurgiensAggregate = {
  __typename?: 'EvolutionChirurgiensAggregate';
  aggregate?: Maybe<EvolutionChirurgiensAggregateFields>;
  nodes: Array<EvolutionChirurgiens>;
};

/** aggregate fields of "evolution_chirurgiens" */
export type EvolutionChirurgiensAggregateFields = {
  __typename?: 'EvolutionChirurgiensAggregateFields';
  avg?: Maybe<EvolutionChirurgiensAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EvolutionChirurgiensMaxFields>;
  min?: Maybe<EvolutionChirurgiensMinFields>;
  stddev?: Maybe<EvolutionChirurgiensStddevFields>;
  stddevPop?: Maybe<EvolutionChirurgiensStddevPopFields>;
  stddevSamp?: Maybe<EvolutionChirurgiensStddevSampFields>;
  sum?: Maybe<EvolutionChirurgiensSumFields>;
  varPop?: Maybe<EvolutionChirurgiensVarPopFields>;
  varSamp?: Maybe<EvolutionChirurgiensVarSampFields>;
  variance?: Maybe<EvolutionChirurgiensVarianceFields>;
};


/** aggregate fields of "evolution_chirurgiens" */
export type EvolutionChirurgiensAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvolutionChirurgiensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EvolutionChirurgiensAvgFields = {
  __typename?: 'EvolutionChirurgiensAvgFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "evolution_chirurgiens". All fields are combined with a logical 'AND'. */
export type EvolutionChirurgiensBoolExp = {
  _and?: InputMaybe<Array<EvolutionChirurgiensBoolExp>>;
  _not?: InputMaybe<EvolutionChirurgiensBoolExp>;
  _or?: InputMaybe<Array<EvolutionChirurgiensBoolExp>>;
  mois?: InputMaybe<TimestamptzComparisonExp>;
  nombreChirurgiens?: InputMaybe<BigintComparisonExp>;
};

/** aggregate max on columns */
export type EvolutionChirurgiensMaxFields = {
  __typename?: 'EvolutionChirurgiensMaxFields';
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombreChirurgiens?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type EvolutionChirurgiensMinFields = {
  __typename?: 'EvolutionChirurgiensMinFields';
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombreChirurgiens?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "evolution_chirurgiens". */
export type EvolutionChirurgiensOrderBy = {
  mois?: InputMaybe<OrderBy>;
  nombreChirurgiens?: InputMaybe<OrderBy>;
};

/** select columns of table "evolution_chirurgiens" */
export type EvolutionChirurgiensSelectColumn =
  /** column name */
  | 'mois'
  /** column name */
  | 'nombreChirurgiens';

/** aggregate stddev on columns */
export type EvolutionChirurgiensStddevFields = {
  __typename?: 'EvolutionChirurgiensStddevFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type EvolutionChirurgiensStddevPopFields = {
  __typename?: 'EvolutionChirurgiensStddevPopFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type EvolutionChirurgiensStddevSampFields = {
  __typename?: 'EvolutionChirurgiensStddevSampFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "evolution_chirurgiens" */
export type EvolutionChirurgiensStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvolutionChirurgiensStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvolutionChirurgiensStreamCursorValueInput = {
  mois?: InputMaybe<Scalars['timestamptz']['input']>;
  nombreChirurgiens?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type EvolutionChirurgiensSumFields = {
  __typename?: 'EvolutionChirurgiensSumFields';
  nombreChirurgiens?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate varPop on columns */
export type EvolutionChirurgiensVarPopFields = {
  __typename?: 'EvolutionChirurgiensVarPopFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type EvolutionChirurgiensVarSampFields = {
  __typename?: 'EvolutionChirurgiensVarSampFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EvolutionChirurgiensVarianceFields = {
  __typename?: 'EvolutionChirurgiensVarianceFields';
  nombreChirurgiens?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "favoris" */
export type Favoris = {
  __typename?: 'Favoris';
  /** An object relationship */
  chirurgien: Chirurgien;
  chirurgienId: Scalars['uuid']['output'];
  /** An object relationship */
  implant: Implant;
  implantId: Scalars['uuid']['output'];
};

/** aggregated selection of "favoris" */
export type FavorisAggregate = {
  __typename?: 'FavorisAggregate';
  aggregate?: Maybe<FavorisAggregateFields>;
  nodes: Array<Favoris>;
};

export type FavorisAggregateBoolExp = {
  count?: InputMaybe<FavorisAggregateBoolExpCount>;
};

/** aggregate fields of "favoris" */
export type FavorisAggregateFields = {
  __typename?: 'FavorisAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<FavorisMaxFields>;
  min?: Maybe<FavorisMinFields>;
};


/** aggregate fields of "favoris" */
export type FavorisAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<FavorisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "favoris" */
export type FavorisAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<FavorisMaxOrderBy>;
  min?: InputMaybe<FavorisMinOrderBy>;
};

/** input type for inserting array relation for remote table "favoris" */
export type FavorisArrRelInsertInput = {
  data: Array<FavorisInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<FavorisOnConflict>;
};

/** Boolean expression to filter rows from the table "favoris". All fields are combined with a logical 'AND'. */
export type FavorisBoolExp = {
  _and?: InputMaybe<Array<FavorisBoolExp>>;
  _not?: InputMaybe<FavorisBoolExp>;
  _or?: InputMaybe<Array<FavorisBoolExp>>;
  chirurgien?: InputMaybe<ChirurgienBoolExp>;
  chirurgienId?: InputMaybe<UuidComparisonExp>;
  implant?: InputMaybe<ImplantBoolExp>;
  implantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "favoris" */
export type FavorisConstraint =
  /** unique or primary key constraint on columns "chirurgienId", "implantId" */
  | 'favoris_pkey';

/** input type for inserting data into table "favoris" */
export type FavorisInsertInput = {
  chirurgien?: InputMaybe<ChirurgienObjRelInsertInput>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  implant?: InputMaybe<ImplantObjRelInsertInput>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type FavorisMaxFields = {
  __typename?: 'FavorisMaxFields';
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  implantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "favoris" */
export type FavorisMaxOrderBy = {
  chirurgienId?: InputMaybe<OrderBy>;
  implantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type FavorisMinFields = {
  __typename?: 'FavorisMinFields';
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  implantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "favoris" */
export type FavorisMinOrderBy = {
  chirurgienId?: InputMaybe<OrderBy>;
  implantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "favoris" */
export type FavorisMutationResponse = {
  __typename?: 'FavorisMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Favoris>;
};

/** on_conflict condition type for table "favoris" */
export type FavorisOnConflict = {
  constraint: FavorisConstraint;
  updateColumns?: Array<FavorisUpdateColumn>;
  where?: InputMaybe<FavorisBoolExp>;
};

/** Ordering options when selecting data from "favoris". */
export type FavorisOrderBy = {
  chirurgien?: InputMaybe<ChirurgienOrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  implant?: InputMaybe<ImplantOrderBy>;
  implantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: favoris */
export type FavorisPkColumnsInput = {
  chirurgienId: Scalars['uuid']['input'];
  implantId: Scalars['uuid']['input'];
};

/** select columns of table "favoris" */
export type FavorisSelectColumn =
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'implantId';

/** input type for updating data in table "favoris" */
export type FavorisSetInput = {
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "favoris" */
export type FavorisStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: FavorisStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type FavorisStreamCursorValueInput = {
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "favoris" */
export type FavorisUpdateColumn =
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'implantId';

export type FavorisUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FavorisSetInput>;
  /** filter the rows which have to be updated */
  where: FavorisBoolExp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** columns and relationships of "habitudes" */
export type Habitudes = {
  __typename?: 'Habitudes';
  heureCoucher?: Maybe<Scalars['time']['output']>;
  heureReveil?: Maybe<Scalars['time']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  patient: Patient;
  patientId: Scalars['uuid']['output'];
  tempsAutreVisionPres?: Maybe<Scalars['time']['output']>;
  tempsConduite?: Maybe<Scalars['time']['output']>;
  tempsCuisine?: Maybe<Scalars['time']['output']>;
  tempsDiscussion?: Maybe<Scalars['time']['output']>;
  tempsJeuxSociete?: Maybe<Scalars['time']['output']>;
  tempsLecture?: Maybe<Scalars['time']['output']>;
  tempsOrdinateur?: Maybe<Scalars['time']['output']>;
  tempsSieste?: Maybe<Scalars['time']['output']>;
  tempsSmartphone?: Maybe<Scalars['time']['output']>;
  tempsTablette?: Maybe<Scalars['time']['output']>;
  tempsTelevision?: Maybe<Scalars['time']['output']>;
};

/** aggregated selection of "habitudes" */
export type HabitudesAggregate = {
  __typename?: 'HabitudesAggregate';
  aggregate?: Maybe<HabitudesAggregateFields>;
  nodes: Array<Habitudes>;
};

export type HabitudesAggregateBoolExp = {
  count?: InputMaybe<HabitudesAggregateBoolExpCount>;
};

/** aggregate fields of "habitudes" */
export type HabitudesAggregateFields = {
  __typename?: 'HabitudesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<HabitudesMaxFields>;
  min?: Maybe<HabitudesMinFields>;
};


/** aggregate fields of "habitudes" */
export type HabitudesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<HabitudesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "habitudes" */
export type HabitudesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<HabitudesMaxOrderBy>;
  min?: InputMaybe<HabitudesMinOrderBy>;
};

/** input type for inserting array relation for remote table "habitudes" */
export type HabitudesArrRelInsertInput = {
  data: Array<HabitudesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<HabitudesOnConflict>;
};

/** Boolean expression to filter rows from the table "habitudes". All fields are combined with a logical 'AND'. */
export type HabitudesBoolExp = {
  _and?: InputMaybe<Array<HabitudesBoolExp>>;
  _not?: InputMaybe<HabitudesBoolExp>;
  _or?: InputMaybe<Array<HabitudesBoolExp>>;
  heureCoucher?: InputMaybe<TimeComparisonExp>;
  heureReveil?: InputMaybe<TimeComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  patient?: InputMaybe<PatientBoolExp>;
  patientId?: InputMaybe<UuidComparisonExp>;
  tempsAutreVisionPres?: InputMaybe<TimeComparisonExp>;
  tempsConduite?: InputMaybe<TimeComparisonExp>;
  tempsCuisine?: InputMaybe<TimeComparisonExp>;
  tempsDiscussion?: InputMaybe<TimeComparisonExp>;
  tempsJeuxSociete?: InputMaybe<TimeComparisonExp>;
  tempsLecture?: InputMaybe<TimeComparisonExp>;
  tempsOrdinateur?: InputMaybe<TimeComparisonExp>;
  tempsSieste?: InputMaybe<TimeComparisonExp>;
  tempsSmartphone?: InputMaybe<TimeComparisonExp>;
  tempsTablette?: InputMaybe<TimeComparisonExp>;
  tempsTelevision?: InputMaybe<TimeComparisonExp>;
};

/** unique or primary key constraints on table "habitudes" */
export type HabitudesConstraint =
  /** unique or primary key constraint on columns "patient_id" */
  | 'habitudes_patient_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'habitudes_pkey';

/** input type for inserting data into table "habitudes" */
export type HabitudesInsertInput = {
  heureCoucher?: InputMaybe<Scalars['time']['input']>;
  heureReveil?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patient?: InputMaybe<PatientObjRelInsertInput>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  tempsAutreVisionPres?: InputMaybe<Scalars['time']['input']>;
  tempsConduite?: InputMaybe<Scalars['time']['input']>;
  tempsCuisine?: InputMaybe<Scalars['time']['input']>;
  tempsDiscussion?: InputMaybe<Scalars['time']['input']>;
  tempsJeuxSociete?: InputMaybe<Scalars['time']['input']>;
  tempsLecture?: InputMaybe<Scalars['time']['input']>;
  tempsOrdinateur?: InputMaybe<Scalars['time']['input']>;
  tempsSieste?: InputMaybe<Scalars['time']['input']>;
  tempsSmartphone?: InputMaybe<Scalars['time']['input']>;
  tempsTablette?: InputMaybe<Scalars['time']['input']>;
  tempsTelevision?: InputMaybe<Scalars['time']['input']>;
};

/** aggregate max on columns */
export type HabitudesMaxFields = {
  __typename?: 'HabitudesMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "habitudes" */
export type HabitudesMaxOrderBy = {
  id?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type HabitudesMinFields = {
  __typename?: 'HabitudesMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "habitudes" */
export type HabitudesMinOrderBy = {
  id?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "habitudes" */
export type HabitudesMutationResponse = {
  __typename?: 'HabitudesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Habitudes>;
};

/** on_conflict condition type for table "habitudes" */
export type HabitudesOnConflict = {
  constraint: HabitudesConstraint;
  updateColumns?: Array<HabitudesUpdateColumn>;
  where?: InputMaybe<HabitudesBoolExp>;
};

/** Ordering options when selecting data from "habitudes". */
export type HabitudesOrderBy = {
  heureCoucher?: InputMaybe<OrderBy>;
  heureReveil?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  patient?: InputMaybe<PatientOrderBy>;
  patientId?: InputMaybe<OrderBy>;
  tempsAutreVisionPres?: InputMaybe<OrderBy>;
  tempsConduite?: InputMaybe<OrderBy>;
  tempsCuisine?: InputMaybe<OrderBy>;
  tempsDiscussion?: InputMaybe<OrderBy>;
  tempsJeuxSociete?: InputMaybe<OrderBy>;
  tempsLecture?: InputMaybe<OrderBy>;
  tempsOrdinateur?: InputMaybe<OrderBy>;
  tempsSieste?: InputMaybe<OrderBy>;
  tempsSmartphone?: InputMaybe<OrderBy>;
  tempsTablette?: InputMaybe<OrderBy>;
  tempsTelevision?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: habitudes */
export type HabitudesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "habitudes" */
export type HabitudesSelectColumn =
  /** column name */
  | 'heureCoucher'
  /** column name */
  | 'heureReveil'
  /** column name */
  | 'id'
  /** column name */
  | 'patientId'
  /** column name */
  | 'tempsAutreVisionPres'
  /** column name */
  | 'tempsConduite'
  /** column name */
  | 'tempsCuisine'
  /** column name */
  | 'tempsDiscussion'
  /** column name */
  | 'tempsJeuxSociete'
  /** column name */
  | 'tempsLecture'
  /** column name */
  | 'tempsOrdinateur'
  /** column name */
  | 'tempsSieste'
  /** column name */
  | 'tempsSmartphone'
  /** column name */
  | 'tempsTablette'
  /** column name */
  | 'tempsTelevision';

/** input type for updating data in table "habitudes" */
export type HabitudesSetInput = {
  heureCoucher?: InputMaybe<Scalars['time']['input']>;
  heureReveil?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  tempsAutreVisionPres?: InputMaybe<Scalars['time']['input']>;
  tempsConduite?: InputMaybe<Scalars['time']['input']>;
  tempsCuisine?: InputMaybe<Scalars['time']['input']>;
  tempsDiscussion?: InputMaybe<Scalars['time']['input']>;
  tempsJeuxSociete?: InputMaybe<Scalars['time']['input']>;
  tempsLecture?: InputMaybe<Scalars['time']['input']>;
  tempsOrdinateur?: InputMaybe<Scalars['time']['input']>;
  tempsSieste?: InputMaybe<Scalars['time']['input']>;
  tempsSmartphone?: InputMaybe<Scalars['time']['input']>;
  tempsTablette?: InputMaybe<Scalars['time']['input']>;
  tempsTelevision?: InputMaybe<Scalars['time']['input']>;
};

/** Streaming cursor of the table "habitudes" */
export type HabitudesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: HabitudesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type HabitudesStreamCursorValueInput = {
  heureCoucher?: InputMaybe<Scalars['time']['input']>;
  heureReveil?: InputMaybe<Scalars['time']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  tempsAutreVisionPres?: InputMaybe<Scalars['time']['input']>;
  tempsConduite?: InputMaybe<Scalars['time']['input']>;
  tempsCuisine?: InputMaybe<Scalars['time']['input']>;
  tempsDiscussion?: InputMaybe<Scalars['time']['input']>;
  tempsJeuxSociete?: InputMaybe<Scalars['time']['input']>;
  tempsLecture?: InputMaybe<Scalars['time']['input']>;
  tempsOrdinateur?: InputMaybe<Scalars['time']['input']>;
  tempsSieste?: InputMaybe<Scalars['time']['input']>;
  tempsSmartphone?: InputMaybe<Scalars['time']['input']>;
  tempsTablette?: InputMaybe<Scalars['time']['input']>;
  tempsTelevision?: InputMaybe<Scalars['time']['input']>;
};

/** update columns of table "habitudes" */
export type HabitudesUpdateColumn =
  /** column name */
  | 'heureCoucher'
  /** column name */
  | 'heureReveil'
  /** column name */
  | 'id'
  /** column name */
  | 'patientId'
  /** column name */
  | 'tempsAutreVisionPres'
  /** column name */
  | 'tempsConduite'
  /** column name */
  | 'tempsCuisine'
  /** column name */
  | 'tempsDiscussion'
  /** column name */
  | 'tempsJeuxSociete'
  /** column name */
  | 'tempsLecture'
  /** column name */
  | 'tempsOrdinateur'
  /** column name */
  | 'tempsSieste'
  /** column name */
  | 'tempsSmartphone'
  /** column name */
  | 'tempsTablette'
  /** column name */
  | 'tempsTelevision';

export type HabitudesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<HabitudesSetInput>;
  /** filter the rows which have to be updated */
  where: HabitudesBoolExp;
};

/** columns and relationships of "help_texts" */
export type HelpTexts = {
  __typename?: 'HelpTexts';
  category?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  chirurgien?: Maybe<Chirurgien>;
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  fieldName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  textEn: Scalars['String']['output'];
  textFr: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "help_texts" */
export type HelpTextsAggregate = {
  __typename?: 'HelpTextsAggregate';
  aggregate?: Maybe<HelpTextsAggregateFields>;
  nodes: Array<HelpTexts>;
};

export type HelpTextsAggregateBoolExp = {
  bool_and?: InputMaybe<HelpTextsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<HelpTextsAggregateBoolExpBool_Or>;
  count?: InputMaybe<HelpTextsAggregateBoolExpCount>;
};

/** aggregate fields of "help_texts" */
export type HelpTextsAggregateFields = {
  __typename?: 'HelpTextsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<HelpTextsMaxFields>;
  min?: Maybe<HelpTextsMinFields>;
};


/** aggregate fields of "help_texts" */
export type HelpTextsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<HelpTextsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "help_texts" */
export type HelpTextsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<HelpTextsMaxOrderBy>;
  min?: InputMaybe<HelpTextsMinOrderBy>;
};

/** input type for inserting array relation for remote table "help_texts" */
export type HelpTextsArrRelInsertInput = {
  data: Array<HelpTextsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<HelpTextsOnConflict>;
};

/** Boolean expression to filter rows from the table "help_texts". All fields are combined with a logical 'AND'. */
export type HelpTextsBoolExp = {
  _and?: InputMaybe<Array<HelpTextsBoolExp>>;
  _not?: InputMaybe<HelpTextsBoolExp>;
  _or?: InputMaybe<Array<HelpTextsBoolExp>>;
  category?: InputMaybe<StringComparisonExp>;
  chirurgien?: InputMaybe<ChirurgienBoolExp>;
  chirurgienId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  createdBy?: InputMaybe<UuidComparisonExp>;
  fieldName?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isDefault?: InputMaybe<BooleanComparisonExp>;
  textEn?: InputMaybe<StringComparisonExp>;
  textFr?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "help_texts" */
export type HelpTextsConstraint =
  /** unique or primary key constraint on columns "field_name", "chirurgien_id" */
  | 'help_text_unique_field_chirurgien'
  /** unique or primary key constraint on columns "field_name", "chirurgien_id" */
  | 'help_texts_field_name_chirurgien_id_key'
  /** unique or primary key constraint on columns "id" */
  | 'help_texts_pkey';

/** input type for inserting data into table "help_texts" */
export type HelpTextsInsertInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chirurgien?: InputMaybe<ChirurgienObjRelInsertInput>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
  textFr?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type HelpTextsMaxFields = {
  __typename?: 'HelpTextsMaxFields';
  category?: Maybe<Scalars['String']['output']>;
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  textFr?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "help_texts" */
export type HelpTextsMaxOrderBy = {
  category?: InputMaybe<OrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  fieldName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  textEn?: InputMaybe<OrderBy>;
  textFr?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type HelpTextsMinFields = {
  __typename?: 'HelpTextsMinFields';
  category?: Maybe<Scalars['String']['output']>;
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['uuid']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  textEn?: Maybe<Scalars['String']['output']>;
  textFr?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "help_texts" */
export type HelpTextsMinOrderBy = {
  category?: InputMaybe<OrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  fieldName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  textEn?: InputMaybe<OrderBy>;
  textFr?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "help_texts" */
export type HelpTextsMutationResponse = {
  __typename?: 'HelpTextsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<HelpTexts>;
};

/** on_conflict condition type for table "help_texts" */
export type HelpTextsOnConflict = {
  constraint: HelpTextsConstraint;
  updateColumns?: Array<HelpTextsUpdateColumn>;
  where?: InputMaybe<HelpTextsBoolExp>;
};

/** Ordering options when selecting data from "help_texts". */
export type HelpTextsOrderBy = {
  category?: InputMaybe<OrderBy>;
  chirurgien?: InputMaybe<ChirurgienOrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  createdBy?: InputMaybe<OrderBy>;
  fieldName?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  isDefault?: InputMaybe<OrderBy>;
  textEn?: InputMaybe<OrderBy>;
  textFr?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: help_texts */
export type HelpTextsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "help_texts" */
export type HelpTextsSelectColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'fieldName'
  /** column name */
  | 'id'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'textEn'
  /** column name */
  | 'textFr'
  /** column name */
  | 'updatedAt';

/** select "helpTextsAggregateBoolExpBool_andArgumentsColumns" columns of table "help_texts" */
export type HelpTextsSelectColumnHelpTextsAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isDefault';

/** select "helpTextsAggregateBoolExpBool_orArgumentsColumns" columns of table "help_texts" */
export type HelpTextsSelectColumnHelpTextsAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isDefault';

/** input type for updating data in table "help_texts" */
export type HelpTextsSetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
  textFr?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "help_texts" */
export type HelpTextsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: HelpTextsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type HelpTextsStreamCursorValueInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['uuid']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  textEn?: InputMaybe<Scalars['String']['input']>;
  textFr?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "help_texts" */
export type HelpTextsUpdateColumn =
  /** column name */
  | 'category'
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'createdBy'
  /** column name */
  | 'fieldName'
  /** column name */
  | 'id'
  /** column name */
  | 'isDefault'
  /** column name */
  | 'textEn'
  /** column name */
  | 'textFr'
  /** column name */
  | 'updatedAt';

export type HelpTextsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<HelpTextsSetInput>;
  /** filter the rows which have to be updated */
  where: HelpTextsBoolExp;
};

/** columns and relationships of "implant" */
export type Implant = {
  __typename?: 'Implant';
  /** An array relationship */
  choixes: Array<Choix>;
  /** An aggregate relationship */
  choixesAggregate: ChoixAggregate;
  correctionOptique: Scalars['String']['output'];
  data: Scalars['json']['output'];
  display: Scalars['String']['output'];
  /** An array relationship */
  favoris: Array<Favoris>;
  /** An aggregate relationship */
  favorisAggregate: FavorisAggregate;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  laboratoire: Laboratoire;
  laboratoireId: Scalars['uuid']['output'];
  materiau: Scalars['String']['output'];
  mb: Scalars['String']['output'];
  methodology?: Maybe<Scalars['String']['output']>;
  n?: Maybe<Scalars['numeric']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


/** columns and relationships of "implant" */
export type ImplantChoixesArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


/** columns and relationships of "implant" */
export type ImplantChoixesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


/** columns and relationships of "implant" */
export type ImplantDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "implant" */
export type ImplantFavorisArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


/** columns and relationships of "implant" */
export type ImplantFavorisAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};

/** aggregated selection of "implant" */
export type ImplantAggregate = {
  __typename?: 'ImplantAggregate';
  aggregate?: Maybe<ImplantAggregateFields>;
  nodes: Array<Implant>;
};

export type ImplantAggregateBoolExp = {
  count?: InputMaybe<ImplantAggregateBoolExpCount>;
};

/** aggregate fields of "implant" */
export type ImplantAggregateFields = {
  __typename?: 'ImplantAggregateFields';
  avg?: Maybe<ImplantAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ImplantMaxFields>;
  min?: Maybe<ImplantMinFields>;
  stddev?: Maybe<ImplantStddevFields>;
  stddevPop?: Maybe<ImplantStddevPopFields>;
  stddevSamp?: Maybe<ImplantStddevSampFields>;
  sum?: Maybe<ImplantSumFields>;
  varPop?: Maybe<ImplantVarPopFields>;
  varSamp?: Maybe<ImplantVarSampFields>;
  variance?: Maybe<ImplantVarianceFields>;
};


/** aggregate fields of "implant" */
export type ImplantAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ImplantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "implant" */
export type ImplantAggregateOrderBy = {
  avg?: InputMaybe<ImplantAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ImplantMaxOrderBy>;
  min?: InputMaybe<ImplantMinOrderBy>;
  stddev?: InputMaybe<ImplantStddevOrderBy>;
  stddevPop?: InputMaybe<ImplantStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ImplantStddevSampOrderBy>;
  sum?: InputMaybe<ImplantSumOrderBy>;
  varPop?: InputMaybe<ImplantVarPopOrderBy>;
  varSamp?: InputMaybe<ImplantVarSampOrderBy>;
  variance?: InputMaybe<ImplantVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "implant" */
export type ImplantArrRelInsertInput = {
  data: Array<ImplantInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ImplantOnConflict>;
};

/** aggregate avg on columns */
export type ImplantAvgFields = {
  __typename?: 'ImplantAvgFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "implant" */
export type ImplantAvgOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "implant". All fields are combined with a logical 'AND'. */
export type ImplantBoolExp = {
  _and?: InputMaybe<Array<ImplantBoolExp>>;
  _not?: InputMaybe<ImplantBoolExp>;
  _or?: InputMaybe<Array<ImplantBoolExp>>;
  choixes?: InputMaybe<ChoixBoolExp>;
  choixesAggregate?: InputMaybe<ChoixAggregateBoolExp>;
  correctionOptique?: InputMaybe<StringComparisonExp>;
  data?: InputMaybe<JsonComparisonExp>;
  display?: InputMaybe<StringComparisonExp>;
  favoris?: InputMaybe<FavorisBoolExp>;
  favorisAggregate?: InputMaybe<FavorisAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  laboratoire?: InputMaybe<LaboratoireBoolExp>;
  laboratoireId?: InputMaybe<UuidComparisonExp>;
  materiau?: InputMaybe<StringComparisonExp>;
  mb?: InputMaybe<StringComparisonExp>;
  methodology?: InputMaybe<StringComparisonExp>;
  n?: InputMaybe<NumericComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  note?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "implant" */
export type ImplantConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'implant_pkey';

/** input type for incrementing numeric columns in table "implant" */
export type ImplantIncInput = {
  n?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "implant" */
export type ImplantInsertInput = {
  choixes?: InputMaybe<ChoixArrRelInsertInput>;
  correctionOptique?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  favoris?: InputMaybe<FavorisArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  laboratoire?: InputMaybe<LaboratoireObjRelInsertInput>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  mb?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  n?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ImplantMaxFields = {
  __typename?: 'ImplantMaxFields';
  correctionOptique?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  laboratoireId?: Maybe<Scalars['uuid']['output']>;
  materiau?: Maybe<Scalars['String']['output']>;
  mb?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  n?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "implant" */
export type ImplantMaxOrderBy = {
  correctionOptique?: InputMaybe<OrderBy>;
  display?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  mb?: InputMaybe<OrderBy>;
  methodology?: InputMaybe<OrderBy>;
  n?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ImplantMinFields = {
  __typename?: 'ImplantMinFields';
  correctionOptique?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  laboratoireId?: Maybe<Scalars['uuid']['output']>;
  materiau?: Maybe<Scalars['String']['output']>;
  mb?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  n?: Maybe<Scalars['numeric']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "implant" */
export type ImplantMinOrderBy = {
  correctionOptique?: InputMaybe<OrderBy>;
  display?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  mb?: InputMaybe<OrderBy>;
  methodology?: InputMaybe<OrderBy>;
  n?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "implant" */
export type ImplantMutationResponse = {
  __typename?: 'ImplantMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Implant>;
};

/** input type for inserting object relation for remote table "implant" */
export type ImplantObjRelInsertInput = {
  data: ImplantInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ImplantOnConflict>;
};

/** on_conflict condition type for table "implant" */
export type ImplantOnConflict = {
  constraint: ImplantConstraint;
  updateColumns?: Array<ImplantUpdateColumn>;
  where?: InputMaybe<ImplantBoolExp>;
};

/** Ordering options when selecting data from "implant". */
export type ImplantOrderBy = {
  choixesAggregate?: InputMaybe<ChoixAggregateOrderBy>;
  correctionOptique?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  display?: InputMaybe<OrderBy>;
  favorisAggregate?: InputMaybe<FavorisAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  laboratoire?: InputMaybe<LaboratoireOrderBy>;
  laboratoireId?: InputMaybe<OrderBy>;
  materiau?: InputMaybe<OrderBy>;
  mb?: InputMaybe<OrderBy>;
  methodology?: InputMaybe<OrderBy>;
  n?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  note?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: implant */
export type ImplantPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "implant" */
export type ImplantSelectColumn =
  /** column name */
  | 'correctionOptique'
  /** column name */
  | 'data'
  /** column name */
  | 'display'
  /** column name */
  | 'id'
  /** column name */
  | 'laboratoireId'
  /** column name */
  | 'materiau'
  /** column name */
  | 'mb'
  /** column name */
  | 'methodology'
  /** column name */
  | 'n'
  /** column name */
  | 'name'
  /** column name */
  | 'note'
  /** column name */
  | 'type';

/** input type for updating data in table "implant" */
export type ImplantSetInput = {
  correctionOptique?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  mb?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  n?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ImplantStddevFields = {
  __typename?: 'ImplantStddevFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "implant" */
export type ImplantStddevOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ImplantStddevPopFields = {
  __typename?: 'ImplantStddevPopFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "implant" */
export type ImplantStddevPopOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ImplantStddevSampFields = {
  __typename?: 'ImplantStddevSampFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "implant" */
export type ImplantStddevSampOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "implant" */
export type ImplantStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ImplantStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ImplantStreamCursorValueInput = {
  correctionOptique?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  display?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  laboratoireId?: InputMaybe<Scalars['uuid']['input']>;
  materiau?: InputMaybe<Scalars['String']['input']>;
  mb?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  n?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ImplantSumFields = {
  __typename?: 'ImplantSumFields';
  n?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "implant" */
export type ImplantSumOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** update columns of table "implant" */
export type ImplantUpdateColumn =
  /** column name */
  | 'correctionOptique'
  /** column name */
  | 'data'
  /** column name */
  | 'display'
  /** column name */
  | 'id'
  /** column name */
  | 'laboratoireId'
  /** column name */
  | 'materiau'
  /** column name */
  | 'mb'
  /** column name */
  | 'methodology'
  /** column name */
  | 'n'
  /** column name */
  | 'name'
  /** column name */
  | 'note'
  /** column name */
  | 'type';

export type ImplantUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ImplantIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ImplantSetInput>;
  /** filter the rows which have to be updated */
  where: ImplantBoolExp;
};

/** aggregate varPop on columns */
export type ImplantVarPopFields = {
  __typename?: 'ImplantVarPopFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "implant" */
export type ImplantVarPopOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ImplantVarSampFields = {
  __typename?: 'ImplantVarSampFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "implant" */
export type ImplantVarSampOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ImplantVarianceFields = {
  __typename?: 'ImplantVarianceFields';
  n?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "implant" */
export type ImplantVarianceOrderBy = {
  n?: InputMaybe<OrderBy>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type JsonComparisonExp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "laboratoire" */
export type Laboratoire = {
  __typename?: 'Laboratoire';
  id: Scalars['uuid']['output'];
  /** An array relationship */
  implants: Array<Implant>;
  /** An aggregate relationship */
  implantsAggregate: ImplantAggregate;
  nom?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "laboratoire" */
export type LaboratoireImplantsArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};


/** columns and relationships of "laboratoire" */
export type LaboratoireImplantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};

/** aggregated selection of "laboratoire" */
export type LaboratoireAggregate = {
  __typename?: 'LaboratoireAggregate';
  aggregate?: Maybe<LaboratoireAggregateFields>;
  nodes: Array<Laboratoire>;
};

/** aggregate fields of "laboratoire" */
export type LaboratoireAggregateFields = {
  __typename?: 'LaboratoireAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<LaboratoireMaxFields>;
  min?: Maybe<LaboratoireMinFields>;
};


/** aggregate fields of "laboratoire" */
export type LaboratoireAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<LaboratoireSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "laboratoire". All fields are combined with a logical 'AND'. */
export type LaboratoireBoolExp = {
  _and?: InputMaybe<Array<LaboratoireBoolExp>>;
  _not?: InputMaybe<LaboratoireBoolExp>;
  _or?: InputMaybe<Array<LaboratoireBoolExp>>;
  id?: InputMaybe<UuidComparisonExp>;
  implants?: InputMaybe<ImplantBoolExp>;
  implantsAggregate?: InputMaybe<ImplantAggregateBoolExp>;
  nom?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "laboratoire" */
export type LaboratoireConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'laboratoire_pkey';

/** input type for inserting data into table "laboratoire" */
export type LaboratoireInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  implants?: InputMaybe<ImplantArrRelInsertInput>;
  nom?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type LaboratoireMaxFields = {
  __typename?: 'LaboratoireMaxFields';
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type LaboratoireMinFields = {
  __typename?: 'LaboratoireMinFields';
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "laboratoire" */
export type LaboratoireMutationResponse = {
  __typename?: 'LaboratoireMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Laboratoire>;
};

/** input type for inserting object relation for remote table "laboratoire" */
export type LaboratoireObjRelInsertInput = {
  data: LaboratoireInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<LaboratoireOnConflict>;
};

/** on_conflict condition type for table "laboratoire" */
export type LaboratoireOnConflict = {
  constraint: LaboratoireConstraint;
  updateColumns?: Array<LaboratoireUpdateColumn>;
  where?: InputMaybe<LaboratoireBoolExp>;
};

/** Ordering options when selecting data from "laboratoire". */
export type LaboratoireOrderBy = {
  id?: InputMaybe<OrderBy>;
  implantsAggregate?: InputMaybe<ImplantAggregateOrderBy>;
  nom?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: laboratoire */
export type LaboratoirePkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "laboratoire" */
export type LaboratoireSelectColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'nom';

/** input type for updating data in table "laboratoire" */
export type LaboratoireSetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "laboratoire" */
export type LaboratoireStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: LaboratoireStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type LaboratoireStreamCursorValueInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "laboratoire" */
export type LaboratoireUpdateColumn =
  /** column name */
  | 'id'
  /** column name */
  | 'nom';

export type LaboratoireUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<LaboratoireSetInput>;
  /** filter the rows which have to be updated */
  where: LaboratoireBoolExp;
};

/** columns and relationships of "moyenne_age_taille_patients" */
export type MoyenneAgeTaillePatients = {
  __typename?: 'MoyenneAgeTaillePatients';
  ageMoyen?: Maybe<Scalars['numeric']['output']>;
  tailleMoyenne?: Maybe<Scalars['numeric']['output']>;
};

export type MoyenneAgeTaillePatientsAggregate = {
  __typename?: 'MoyenneAgeTaillePatientsAggregate';
  aggregate?: Maybe<MoyenneAgeTaillePatientsAggregateFields>;
  nodes: Array<MoyenneAgeTaillePatients>;
};

/** aggregate fields of "moyenne_age_taille_patients" */
export type MoyenneAgeTaillePatientsAggregateFields = {
  __typename?: 'MoyenneAgeTaillePatientsAggregateFields';
  avg?: Maybe<MoyenneAgeTaillePatientsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<MoyenneAgeTaillePatientsMaxFields>;
  min?: Maybe<MoyenneAgeTaillePatientsMinFields>;
  stddev?: Maybe<MoyenneAgeTaillePatientsStddevFields>;
  stddevPop?: Maybe<MoyenneAgeTaillePatientsStddevPopFields>;
  stddevSamp?: Maybe<MoyenneAgeTaillePatientsStddevSampFields>;
  sum?: Maybe<MoyenneAgeTaillePatientsSumFields>;
  varPop?: Maybe<MoyenneAgeTaillePatientsVarPopFields>;
  varSamp?: Maybe<MoyenneAgeTaillePatientsVarSampFields>;
  variance?: Maybe<MoyenneAgeTaillePatientsVarianceFields>;
};


/** aggregate fields of "moyenne_age_taille_patients" */
export type MoyenneAgeTaillePatientsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MoyenneAgeTaillePatientsAvgFields = {
  __typename?: 'MoyenneAgeTaillePatientsAvgFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "moyenne_age_taille_patients". All fields are combined with a logical 'AND'. */
export type MoyenneAgeTaillePatientsBoolExp = {
  _and?: InputMaybe<Array<MoyenneAgeTaillePatientsBoolExp>>;
  _not?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
  _or?: InputMaybe<Array<MoyenneAgeTaillePatientsBoolExp>>;
  ageMoyen?: InputMaybe<NumericComparisonExp>;
  tailleMoyenne?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type MoyenneAgeTaillePatientsMaxFields = {
  __typename?: 'MoyenneAgeTaillePatientsMaxFields';
  ageMoyen?: Maybe<Scalars['numeric']['output']>;
  tailleMoyenne?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type MoyenneAgeTaillePatientsMinFields = {
  __typename?: 'MoyenneAgeTaillePatientsMinFields';
  ageMoyen?: Maybe<Scalars['numeric']['output']>;
  tailleMoyenne?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "moyenne_age_taille_patients". */
export type MoyenneAgeTaillePatientsOrderBy = {
  ageMoyen?: InputMaybe<OrderBy>;
  tailleMoyenne?: InputMaybe<OrderBy>;
};

/** select columns of table "moyenne_age_taille_patients" */
export type MoyenneAgeTaillePatientsSelectColumn =
  /** column name */
  | 'ageMoyen'
  /** column name */
  | 'tailleMoyenne';

/** aggregate stddev on columns */
export type MoyenneAgeTaillePatientsStddevFields = {
  __typename?: 'MoyenneAgeTaillePatientsStddevFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type MoyenneAgeTaillePatientsStddevPopFields = {
  __typename?: 'MoyenneAgeTaillePatientsStddevPopFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type MoyenneAgeTaillePatientsStddevSampFields = {
  __typename?: 'MoyenneAgeTaillePatientsStddevSampFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "moyenne_age_taille_patients" */
export type MoyenneAgeTaillePatientsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: MoyenneAgeTaillePatientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type MoyenneAgeTaillePatientsStreamCursorValueInput = {
  ageMoyen?: InputMaybe<Scalars['numeric']['input']>;
  tailleMoyenne?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type MoyenneAgeTaillePatientsSumFields = {
  __typename?: 'MoyenneAgeTaillePatientsSumFields';
  ageMoyen?: Maybe<Scalars['numeric']['output']>;
  tailleMoyenne?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate varPop on columns */
export type MoyenneAgeTaillePatientsVarPopFields = {
  __typename?: 'MoyenneAgeTaillePatientsVarPopFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type MoyenneAgeTaillePatientsVarSampFields = {
  __typename?: 'MoyenneAgeTaillePatientsVarSampFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MoyenneAgeTaillePatientsVarianceFields = {
  __typename?: 'MoyenneAgeTaillePatientsVarianceFields';
  ageMoyen?: Maybe<Scalars['Float']['output']>;
  tailleMoyenne?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type NumericComparisonExp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "oeil" */
export type Oeil = {
  __typename?: 'Oeil';
  aOperer?: Maybe<Scalars['String']['output']>;
  aberrationOrdreEleve?: Maybe<Scalars['String']['output']>;
  aberrationSpherique?: Maybe<Scalars['String']['output']>;
  ajoutAddon?: Maybe<Scalars['numeric']['output']>;
  antecedantChirurgie?: Maybe<Scalars['String']['output']>;
  antecedantChirurgieCristallin?: Maybe<Scalars['String']['output']>;
  bump?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  choixes: Array<Choix>;
  /** An aggregate relationship */
  choixesAggregate: ChoixAggregate;
  courbeDefocus?: Maybe<Scalars['json']['output']>;
  diametrePupillaire?: Maybe<Scalars['String']['output']>;
  endothelium?: Maybe<Scalars['String']['output']>;
  genererCourbeTypeImplant?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  implantCourant?: Maybe<Implant>;
  implantCourantId?: Maybe<Scalars['uuid']['output']>;
  larmes?: Maybe<Scalars['String']['output']>;
  longueurAxiale?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  patient: Patient;
  patientId: Scalars['uuid']['output'];
  retineNerfOptique?: Maybe<Scalars['String']['output']>;
  side: Scalars['String']['output'];
  typeImplantActuel?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "oeil" */
export type OeilChoixesArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


/** columns and relationships of "oeil" */
export type OeilChoixesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


/** columns and relationships of "oeil" */
export type OeilCourbeDefocusArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "oeil" */
export type OeilAggregate = {
  __typename?: 'OeilAggregate';
  aggregate?: Maybe<OeilAggregateFields>;
  nodes: Array<Oeil>;
};

export type OeilAggregateBoolExp = {
  count?: InputMaybe<OeilAggregateBoolExpCount>;
};

/** aggregate fields of "oeil" */
export type OeilAggregateFields = {
  __typename?: 'OeilAggregateFields';
  avg?: Maybe<OeilAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<OeilMaxFields>;
  min?: Maybe<OeilMinFields>;
  stddev?: Maybe<OeilStddevFields>;
  stddevPop?: Maybe<OeilStddevPopFields>;
  stddevSamp?: Maybe<OeilStddevSampFields>;
  sum?: Maybe<OeilSumFields>;
  varPop?: Maybe<OeilVarPopFields>;
  varSamp?: Maybe<OeilVarSampFields>;
  variance?: Maybe<OeilVarianceFields>;
};


/** aggregate fields of "oeil" */
export type OeilAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OeilSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "oeil" */
export type OeilAggregateOrderBy = {
  avg?: InputMaybe<OeilAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<OeilMaxOrderBy>;
  min?: InputMaybe<OeilMinOrderBy>;
  stddev?: InputMaybe<OeilStddevOrderBy>;
  stddevPop?: InputMaybe<OeilStddevPopOrderBy>;
  stddevSamp?: InputMaybe<OeilStddevSampOrderBy>;
  sum?: InputMaybe<OeilSumOrderBy>;
  varPop?: InputMaybe<OeilVarPopOrderBy>;
  varSamp?: InputMaybe<OeilVarSampOrderBy>;
  variance?: InputMaybe<OeilVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "oeil" */
export type OeilArrRelInsertInput = {
  data: Array<OeilInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<OeilOnConflict>;
};

/** aggregate avg on columns */
export type OeilAvgFields = {
  __typename?: 'OeilAvgFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "oeil" */
export type OeilAvgOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "oeil". All fields are combined with a logical 'AND'. */
export type OeilBoolExp = {
  _and?: InputMaybe<Array<OeilBoolExp>>;
  _not?: InputMaybe<OeilBoolExp>;
  _or?: InputMaybe<Array<OeilBoolExp>>;
  aOperer?: InputMaybe<StringComparisonExp>;
  aberrationOrdreEleve?: InputMaybe<StringComparisonExp>;
  aberrationSpherique?: InputMaybe<StringComparisonExp>;
  ajoutAddon?: InputMaybe<NumericComparisonExp>;
  antecedantChirurgie?: InputMaybe<StringComparisonExp>;
  antecedantChirurgieCristallin?: InputMaybe<StringComparisonExp>;
  bump?: InputMaybe<StringComparisonExp>;
  choixes?: InputMaybe<ChoixBoolExp>;
  choixesAggregate?: InputMaybe<ChoixAggregateBoolExp>;
  courbeDefocus?: InputMaybe<JsonComparisonExp>;
  diametrePupillaire?: InputMaybe<StringComparisonExp>;
  endothelium?: InputMaybe<StringComparisonExp>;
  genererCourbeTypeImplant?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  implantCourant?: InputMaybe<ImplantBoolExp>;
  implantCourantId?: InputMaybe<UuidComparisonExp>;
  larmes?: InputMaybe<StringComparisonExp>;
  longueurAxiale?: InputMaybe<StringComparisonExp>;
  patient?: InputMaybe<PatientBoolExp>;
  patientId?: InputMaybe<UuidComparisonExp>;
  retineNerfOptique?: InputMaybe<StringComparisonExp>;
  side?: InputMaybe<StringComparisonExp>;
  typeImplantActuel?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "oeil" */
export type OeilConstraint =
  /** unique or primary key constraint on columns "patient_id", "side" */
  | 'oeil_patient_id_side_key'
  /** unique or primary key constraint on columns "id" */
  | 'oeil_pkey';

/** input type for incrementing numeric columns in table "oeil" */
export type OeilIncInput = {
  ajoutAddon?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "oeil" */
export type OeilInsertInput = {
  aOperer?: InputMaybe<Scalars['String']['input']>;
  aberrationOrdreEleve?: InputMaybe<Scalars['String']['input']>;
  aberrationSpherique?: InputMaybe<Scalars['String']['input']>;
  ajoutAddon?: InputMaybe<Scalars['numeric']['input']>;
  antecedantChirurgie?: InputMaybe<Scalars['String']['input']>;
  antecedantChirurgieCristallin?: InputMaybe<Scalars['String']['input']>;
  bump?: InputMaybe<Scalars['String']['input']>;
  choixes?: InputMaybe<ChoixArrRelInsertInput>;
  courbeDefocus?: InputMaybe<Scalars['json']['input']>;
  diametrePupillaire?: InputMaybe<Scalars['String']['input']>;
  endothelium?: InputMaybe<Scalars['String']['input']>;
  genererCourbeTypeImplant?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implantCourant?: InputMaybe<ImplantObjRelInsertInput>;
  implantCourantId?: InputMaybe<Scalars['uuid']['input']>;
  larmes?: InputMaybe<Scalars['String']['input']>;
  longueurAxiale?: InputMaybe<Scalars['String']['input']>;
  patient?: InputMaybe<PatientObjRelInsertInput>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  retineNerfOptique?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  typeImplantActuel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type OeilMaxFields = {
  __typename?: 'OeilMaxFields';
  aOperer?: Maybe<Scalars['String']['output']>;
  aberrationOrdreEleve?: Maybe<Scalars['String']['output']>;
  aberrationSpherique?: Maybe<Scalars['String']['output']>;
  ajoutAddon?: Maybe<Scalars['numeric']['output']>;
  antecedantChirurgie?: Maybe<Scalars['String']['output']>;
  antecedantChirurgieCristallin?: Maybe<Scalars['String']['output']>;
  bump?: Maybe<Scalars['String']['output']>;
  diametrePupillaire?: Maybe<Scalars['String']['output']>;
  endothelium?: Maybe<Scalars['String']['output']>;
  genererCourbeTypeImplant?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  implantCourantId?: Maybe<Scalars['uuid']['output']>;
  larmes?: Maybe<Scalars['String']['output']>;
  longueurAxiale?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
  retineNerfOptique?: Maybe<Scalars['String']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  typeImplantActuel?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "oeil" */
export type OeilMaxOrderBy = {
  aOperer?: InputMaybe<OrderBy>;
  aberrationOrdreEleve?: InputMaybe<OrderBy>;
  aberrationSpherique?: InputMaybe<OrderBy>;
  ajoutAddon?: InputMaybe<OrderBy>;
  antecedantChirurgie?: InputMaybe<OrderBy>;
  antecedantChirurgieCristallin?: InputMaybe<OrderBy>;
  bump?: InputMaybe<OrderBy>;
  diametrePupillaire?: InputMaybe<OrderBy>;
  endothelium?: InputMaybe<OrderBy>;
  genererCourbeTypeImplant?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implantCourantId?: InputMaybe<OrderBy>;
  larmes?: InputMaybe<OrderBy>;
  longueurAxiale?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
  retineNerfOptique?: InputMaybe<OrderBy>;
  side?: InputMaybe<OrderBy>;
  typeImplantActuel?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type OeilMinFields = {
  __typename?: 'OeilMinFields';
  aOperer?: Maybe<Scalars['String']['output']>;
  aberrationOrdreEleve?: Maybe<Scalars['String']['output']>;
  aberrationSpherique?: Maybe<Scalars['String']['output']>;
  ajoutAddon?: Maybe<Scalars['numeric']['output']>;
  antecedantChirurgie?: Maybe<Scalars['String']['output']>;
  antecedantChirurgieCristallin?: Maybe<Scalars['String']['output']>;
  bump?: Maybe<Scalars['String']['output']>;
  diametrePupillaire?: Maybe<Scalars['String']['output']>;
  endothelium?: Maybe<Scalars['String']['output']>;
  genererCourbeTypeImplant?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  implantCourantId?: Maybe<Scalars['uuid']['output']>;
  larmes?: Maybe<Scalars['String']['output']>;
  longueurAxiale?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
  retineNerfOptique?: Maybe<Scalars['String']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  typeImplantActuel?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "oeil" */
export type OeilMinOrderBy = {
  aOperer?: InputMaybe<OrderBy>;
  aberrationOrdreEleve?: InputMaybe<OrderBy>;
  aberrationSpherique?: InputMaybe<OrderBy>;
  ajoutAddon?: InputMaybe<OrderBy>;
  antecedantChirurgie?: InputMaybe<OrderBy>;
  antecedantChirurgieCristallin?: InputMaybe<OrderBy>;
  bump?: InputMaybe<OrderBy>;
  diametrePupillaire?: InputMaybe<OrderBy>;
  endothelium?: InputMaybe<OrderBy>;
  genererCourbeTypeImplant?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implantCourantId?: InputMaybe<OrderBy>;
  larmes?: InputMaybe<OrderBy>;
  longueurAxiale?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
  retineNerfOptique?: InputMaybe<OrderBy>;
  side?: InputMaybe<OrderBy>;
  typeImplantActuel?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "oeil" */
export type OeilMutationResponse = {
  __typename?: 'OeilMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Oeil>;
};

/** input type for inserting object relation for remote table "oeil" */
export type OeilObjRelInsertInput = {
  data: OeilInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<OeilOnConflict>;
};

/** on_conflict condition type for table "oeil" */
export type OeilOnConflict = {
  constraint: OeilConstraint;
  updateColumns?: Array<OeilUpdateColumn>;
  where?: InputMaybe<OeilBoolExp>;
};

/** Ordering options when selecting data from "oeil". */
export type OeilOrderBy = {
  aOperer?: InputMaybe<OrderBy>;
  aberrationOrdreEleve?: InputMaybe<OrderBy>;
  aberrationSpherique?: InputMaybe<OrderBy>;
  ajoutAddon?: InputMaybe<OrderBy>;
  antecedantChirurgie?: InputMaybe<OrderBy>;
  antecedantChirurgieCristallin?: InputMaybe<OrderBy>;
  bump?: InputMaybe<OrderBy>;
  choixesAggregate?: InputMaybe<ChoixAggregateOrderBy>;
  courbeDefocus?: InputMaybe<OrderBy>;
  diametrePupillaire?: InputMaybe<OrderBy>;
  endothelium?: InputMaybe<OrderBy>;
  genererCourbeTypeImplant?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  implantCourant?: InputMaybe<ImplantOrderBy>;
  implantCourantId?: InputMaybe<OrderBy>;
  larmes?: InputMaybe<OrderBy>;
  longueurAxiale?: InputMaybe<OrderBy>;
  patient?: InputMaybe<PatientOrderBy>;
  patientId?: InputMaybe<OrderBy>;
  retineNerfOptique?: InputMaybe<OrderBy>;
  side?: InputMaybe<OrderBy>;
  typeImplantActuel?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: oeil */
export type OeilPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "oeil" */
export type OeilSelectColumn =
  /** column name */
  | 'aOperer'
  /** column name */
  | 'aberrationOrdreEleve'
  /** column name */
  | 'aberrationSpherique'
  /** column name */
  | 'ajoutAddon'
  /** column name */
  | 'antecedantChirurgie'
  /** column name */
  | 'antecedantChirurgieCristallin'
  /** column name */
  | 'bump'
  /** column name */
  | 'courbeDefocus'
  /** column name */
  | 'diametrePupillaire'
  /** column name */
  | 'endothelium'
  /** column name */
  | 'genererCourbeTypeImplant'
  /** column name */
  | 'id'
  /** column name */
  | 'implantCourantId'
  /** column name */
  | 'larmes'
  /** column name */
  | 'longueurAxiale'
  /** column name */
  | 'patientId'
  /** column name */
  | 'retineNerfOptique'
  /** column name */
  | 'side'
  /** column name */
  | 'typeImplantActuel';

/** input type for updating data in table "oeil" */
export type OeilSetInput = {
  aOperer?: InputMaybe<Scalars['String']['input']>;
  aberrationOrdreEleve?: InputMaybe<Scalars['String']['input']>;
  aberrationSpherique?: InputMaybe<Scalars['String']['input']>;
  ajoutAddon?: InputMaybe<Scalars['numeric']['input']>;
  antecedantChirurgie?: InputMaybe<Scalars['String']['input']>;
  antecedantChirurgieCristallin?: InputMaybe<Scalars['String']['input']>;
  bump?: InputMaybe<Scalars['String']['input']>;
  courbeDefocus?: InputMaybe<Scalars['json']['input']>;
  diametrePupillaire?: InputMaybe<Scalars['String']['input']>;
  endothelium?: InputMaybe<Scalars['String']['input']>;
  genererCourbeTypeImplant?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implantCourantId?: InputMaybe<Scalars['uuid']['input']>;
  larmes?: InputMaybe<Scalars['String']['input']>;
  longueurAxiale?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  retineNerfOptique?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  typeImplantActuel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OeilStddevFields = {
  __typename?: 'OeilStddevFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "oeil" */
export type OeilStddevOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type OeilStddevPopFields = {
  __typename?: 'OeilStddevPopFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "oeil" */
export type OeilStddevPopOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type OeilStddevSampFields = {
  __typename?: 'OeilStddevSampFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "oeil" */
export type OeilStddevSampOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "oeil" */
export type OeilStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OeilStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OeilStreamCursorValueInput = {
  aOperer?: InputMaybe<Scalars['String']['input']>;
  aberrationOrdreEleve?: InputMaybe<Scalars['String']['input']>;
  aberrationSpherique?: InputMaybe<Scalars['String']['input']>;
  ajoutAddon?: InputMaybe<Scalars['numeric']['input']>;
  antecedantChirurgie?: InputMaybe<Scalars['String']['input']>;
  antecedantChirurgieCristallin?: InputMaybe<Scalars['String']['input']>;
  bump?: InputMaybe<Scalars['String']['input']>;
  courbeDefocus?: InputMaybe<Scalars['json']['input']>;
  diametrePupillaire?: InputMaybe<Scalars['String']['input']>;
  endothelium?: InputMaybe<Scalars['String']['input']>;
  genererCourbeTypeImplant?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  implantCourantId?: InputMaybe<Scalars['uuid']['input']>;
  larmes?: InputMaybe<Scalars['String']['input']>;
  longueurAxiale?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  retineNerfOptique?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  typeImplantActuel?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type OeilSumFields = {
  __typename?: 'OeilSumFields';
  ajoutAddon?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "oeil" */
export type OeilSumOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** update columns of table "oeil" */
export type OeilUpdateColumn =
  /** column name */
  | 'aOperer'
  /** column name */
  | 'aberrationOrdreEleve'
  /** column name */
  | 'aberrationSpherique'
  /** column name */
  | 'ajoutAddon'
  /** column name */
  | 'antecedantChirurgie'
  /** column name */
  | 'antecedantChirurgieCristallin'
  /** column name */
  | 'bump'
  /** column name */
  | 'courbeDefocus'
  /** column name */
  | 'diametrePupillaire'
  /** column name */
  | 'endothelium'
  /** column name */
  | 'genererCourbeTypeImplant'
  /** column name */
  | 'id'
  /** column name */
  | 'implantCourantId'
  /** column name */
  | 'larmes'
  /** column name */
  | 'longueurAxiale'
  /** column name */
  | 'patientId'
  /** column name */
  | 'retineNerfOptique'
  /** column name */
  | 'side'
  /** column name */
  | 'typeImplantActuel';

export type OeilUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<OeilIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OeilSetInput>;
  /** filter the rows which have to be updated */
  where: OeilBoolExp;
};

/** aggregate varPop on columns */
export type OeilVarPopFields = {
  __typename?: 'OeilVarPopFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "oeil" */
export type OeilVarPopOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type OeilVarSampFields = {
  __typename?: 'OeilVarSampFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "oeil" */
export type OeilVarSampOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type OeilVarianceFields = {
  __typename?: 'OeilVarianceFields';
  ajoutAddon?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "oeil" */
export type OeilVarianceOrderBy = {
  ajoutAddon?: InputMaybe<OrderBy>;
};

/** column ordering options */
export type OrderBy =
  /** in ascending order, nulls last */
  | 'ASC'
  /** in ascending order, nulls first */
  | 'ASC_NULLS_FIRST'
  /** in ascending order, nulls last */
  | 'ASC_NULLS_LAST'
  /** in descending order, nulls first */
  | 'DESC'
  /** in descending order, nulls first */
  | 'DESC_NULLS_FIRST'
  /** in descending order, nulls last */
  | 'DESC_NULLS_LAST';

/** columns and relationships of "parametres" */
export type Parametres = {
  __typename?: 'Parametres';
  paramKey: Scalars['String']['output'];
  paramValue?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "parametres" */
export type ParametresAggregate = {
  __typename?: 'ParametresAggregate';
  aggregate?: Maybe<ParametresAggregateFields>;
  nodes: Array<Parametres>;
};

/** aggregate fields of "parametres" */
export type ParametresAggregateFields = {
  __typename?: 'ParametresAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ParametresMaxFields>;
  min?: Maybe<ParametresMinFields>;
};


/** aggregate fields of "parametres" */
export type ParametresAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ParametresSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "parametres". All fields are combined with a logical 'AND'. */
export type ParametresBoolExp = {
  _and?: InputMaybe<Array<ParametresBoolExp>>;
  _not?: InputMaybe<ParametresBoolExp>;
  _or?: InputMaybe<Array<ParametresBoolExp>>;
  paramKey?: InputMaybe<StringComparisonExp>;
  paramValue?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "parametres" */
export type ParametresConstraint =
  /** unique or primary key constraint on columns "param_key" */
  | 'parametres_pkey';

/** input type for inserting data into table "parametres" */
export type ParametresInsertInput = {
  paramKey?: InputMaybe<Scalars['String']['input']>;
  paramValue?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ParametresMaxFields = {
  __typename?: 'ParametresMaxFields';
  paramKey?: Maybe<Scalars['String']['output']>;
  paramValue?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ParametresMinFields = {
  __typename?: 'ParametresMinFields';
  paramKey?: Maybe<Scalars['String']['output']>;
  paramValue?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "parametres" */
export type ParametresMutationResponse = {
  __typename?: 'ParametresMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Parametres>;
};

/** on_conflict condition type for table "parametres" */
export type ParametresOnConflict = {
  constraint: ParametresConstraint;
  updateColumns?: Array<ParametresUpdateColumn>;
  where?: InputMaybe<ParametresBoolExp>;
};

/** Ordering options when selecting data from "parametres". */
export type ParametresOrderBy = {
  paramKey?: InputMaybe<OrderBy>;
  paramValue?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: parametres */
export type ParametresPkColumnsInput = {
  paramKey: Scalars['String']['input'];
};

/** select columns of table "parametres" */
export type ParametresSelectColumn =
  /** column name */
  | 'paramKey'
  /** column name */
  | 'paramValue';

/** input type for updating data in table "parametres" */
export type ParametresSetInput = {
  paramKey?: InputMaybe<Scalars['String']['input']>;
  paramValue?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "parametres" */
export type ParametresStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ParametresStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ParametresStreamCursorValueInput = {
  paramKey?: InputMaybe<Scalars['String']['input']>;
  paramValue?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "parametres" */
export type ParametresUpdateColumn =
  /** column name */
  | 'paramKey'
  /** column name */
  | 'paramValue';

export type ParametresUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ParametresSetInput>;
  /** filter the rows which have to be updated */
  where: ParametresBoolExp;
};

/** columns and relationships of "patient" */
export type Patient = {
  __typename?: 'Patient';
  /** An array relationship */
  activitePreferentielles: Array<ActivitePreferentielle>;
  /** An aggregate relationship */
  activitePreferentiellesAggregate: ActivitePreferentielleAggregate;
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  chirurgien: Chirurgien;
  chirurgienId: Scalars['uuid']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Retourne le statut du dossier patient: GRIS (archivé), VERT (finalisé), ORANGE (en cours) */
  dossierStatus?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  etatControlateral?: Maybe<Scalars['numeric']['output']>;
  glasses?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  habitudes: Array<Habitudes>;
  /** An aggregate relationship */
  habitudesAggregate: HabitudesAggregate;
  id: Scalars['uuid']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  lunettesVI?: Maybe<Scalars['Boolean']['output']>;
  lunettesVL?: Maybe<Scalars['Boolean']['output']>;
  lunettesVP?: Maybe<Scalars['Boolean']['output']>;
  monovision?: Maybe<Scalars['Boolean']['output']>;
  nom: Scalars['String']['output'];
  oeilDominant?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  oeils: Array<Oeil>;
  /** An aggregate relationship */
  oeilsAggregate: OeilAggregate;
  /** An array relationship */
  patientTempTokens: Array<PatientTempTokens>;
  /** An aggregate relationship */
  patientTempTokensAggregate: PatientTempTokensAggregate;
  photicEffect?: Maybe<Scalars['Boolean']['output']>;
  prenom: Scalars['String']['output'];
  sameImplant?: Maybe<Scalars['Boolean']['output']>;
  sameValue?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "patient" */
export type PatientActivitePreferentiellesArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientActivitePreferentiellesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientHabitudesArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientHabitudesAggregateArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientOeilsArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientOeilsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientPatientTempTokensArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


/** columns and relationships of "patient" */
export type PatientPatientTempTokensAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};

/** aggregated selection of "patient" */
export type PatientAggregate = {
  __typename?: 'PatientAggregate';
  aggregate?: Maybe<PatientAggregateFields>;
  nodes: Array<Patient>;
};

export type PatientAggregateBoolExp = {
  bool_and?: InputMaybe<PatientAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PatientAggregateBoolExpBool_Or>;
  count?: InputMaybe<PatientAggregateBoolExpCount>;
};

/** aggregate fields of "patient" */
export type PatientAggregateFields = {
  __typename?: 'PatientAggregateFields';
  avg?: Maybe<PatientAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PatientMaxFields>;
  min?: Maybe<PatientMinFields>;
  stddev?: Maybe<PatientStddevFields>;
  stddevPop?: Maybe<PatientStddevPopFields>;
  stddevSamp?: Maybe<PatientStddevSampFields>;
  sum?: Maybe<PatientSumFields>;
  varPop?: Maybe<PatientVarPopFields>;
  varSamp?: Maybe<PatientVarSampFields>;
  variance?: Maybe<PatientVarianceFields>;
};


/** aggregate fields of "patient" */
export type PatientAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PatientSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "patient" */
export type PatientAggregateOrderBy = {
  avg?: InputMaybe<PatientAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PatientMaxOrderBy>;
  min?: InputMaybe<PatientMinOrderBy>;
  stddev?: InputMaybe<PatientStddevOrderBy>;
  stddevPop?: InputMaybe<PatientStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PatientStddevSampOrderBy>;
  sum?: InputMaybe<PatientSumOrderBy>;
  varPop?: InputMaybe<PatientVarPopOrderBy>;
  varSamp?: InputMaybe<PatientVarSampOrderBy>;
  variance?: InputMaybe<PatientVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "patient" */
export type PatientArrRelInsertInput = {
  data: Array<PatientInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PatientOnConflict>;
};

/** aggregate avg on columns */
export type PatientAvgFields = {
  __typename?: 'PatientAvgFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "patient" */
export type PatientAvgOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "patient". All fields are combined with a logical 'AND'. */
export type PatientBoolExp = {
  _and?: InputMaybe<Array<PatientBoolExp>>;
  _not?: InputMaybe<PatientBoolExp>;
  _or?: InputMaybe<Array<PatientBoolExp>>;
  activitePreferentielles?: InputMaybe<ActivitePreferentielleBoolExp>;
  activitePreferentiellesAggregate?: InputMaybe<ActivitePreferentielleAggregateBoolExp>;
  birthday?: InputMaybe<TimestamptzComparisonExp>;
  chirurgien?: InputMaybe<ChirurgienBoolExp>;
  chirurgienId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dossierStatus?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  etatControlateral?: InputMaybe<NumericComparisonExp>;
  glasses?: InputMaybe<BooleanComparisonExp>;
  habitudes?: InputMaybe<HabitudesBoolExp>;
  habitudesAggregate?: InputMaybe<HabitudesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isArchived?: InputMaybe<BooleanComparisonExp>;
  lunettesVI?: InputMaybe<BooleanComparisonExp>;
  lunettesVL?: InputMaybe<BooleanComparisonExp>;
  lunettesVP?: InputMaybe<BooleanComparisonExp>;
  monovision?: InputMaybe<BooleanComparisonExp>;
  nom?: InputMaybe<StringComparisonExp>;
  oeilDominant?: InputMaybe<StringComparisonExp>;
  oeils?: InputMaybe<OeilBoolExp>;
  oeilsAggregate?: InputMaybe<OeilAggregateBoolExp>;
  patientTempTokens?: InputMaybe<PatientTempTokensBoolExp>;
  patientTempTokensAggregate?: InputMaybe<PatientTempTokensAggregateBoolExp>;
  photicEffect?: InputMaybe<BooleanComparisonExp>;
  prenom?: InputMaybe<StringComparisonExp>;
  sameImplant?: InputMaybe<BooleanComparisonExp>;
  sameValue?: InputMaybe<NumericComparisonExp>;
  sexe?: InputMaybe<NumericComparisonExp>;
  size?: InputMaybe<NumericComparisonExp>;
  telephone?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "patient" */
export type PatientConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'patient_pkey';

/** input type for incrementing numeric columns in table "patient" */
export type PatientIncInput = {
  etatControlateral?: InputMaybe<Scalars['numeric']['input']>;
  sameValue?: InputMaybe<Scalars['numeric']['input']>;
  sexe?: InputMaybe<Scalars['numeric']['input']>;
  size?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "patient" */
export type PatientInsertInput = {
  activitePreferentielles?: InputMaybe<ActivitePreferentielleArrRelInsertInput>;
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  chirurgien?: InputMaybe<ChirurgienObjRelInsertInput>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  etatControlateral?: InputMaybe<Scalars['numeric']['input']>;
  glasses?: InputMaybe<Scalars['Boolean']['input']>;
  habitudes?: InputMaybe<HabitudesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVI?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVL?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVP?: InputMaybe<Scalars['Boolean']['input']>;
  monovision?: InputMaybe<Scalars['Boolean']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  oeilDominant?: InputMaybe<Scalars['String']['input']>;
  oeils?: InputMaybe<OeilArrRelInsertInput>;
  patientTempTokens?: InputMaybe<PatientTempTokensArrRelInsertInput>;
  photicEffect?: InputMaybe<Scalars['Boolean']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  sameImplant?: InputMaybe<Scalars['Boolean']['input']>;
  sameValue?: InputMaybe<Scalars['numeric']['input']>;
  sexe?: InputMaybe<Scalars['numeric']['input']>;
  size?: InputMaybe<Scalars['numeric']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PatientMaxFields = {
  __typename?: 'PatientMaxFields';
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Retourne le statut du dossier patient: GRIS (archivé), VERT (finalisé), ORANGE (en cours) */
  dossierStatus?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  etatControlateral?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  oeilDominant?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  sameValue?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "patient" */
export type PatientMaxOrderBy = {
  birthday?: InputMaybe<OrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  etatControlateral?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  oeilDominant?: InputMaybe<OrderBy>;
  prenom?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PatientMinFields = {
  __typename?: 'PatientMinFields';
  birthday?: Maybe<Scalars['timestamptz']['output']>;
  chirurgienId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Retourne le statut du dossier patient: GRIS (archivé), VERT (finalisé), ORANGE (en cours) */
  dossierStatus?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  etatControlateral?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nom?: Maybe<Scalars['String']['output']>;
  oeilDominant?: Maybe<Scalars['String']['output']>;
  prenom?: Maybe<Scalars['String']['output']>;
  sameValue?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "patient" */
export type PatientMinOrderBy = {
  birthday?: InputMaybe<OrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  etatControlateral?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  oeilDominant?: InputMaybe<OrderBy>;
  prenom?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** columns and relationships of "patient_moyen_par_chirurgiens" */
export type PatientMoyenParChirurgiens = {
  __typename?: 'PatientMoyenParChirurgiens';
  chirurgiensActifs?: Maybe<Scalars['bigint']['output']>;
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['float8']['output']>;
};

export type PatientMoyenParChirurgiensAggregate = {
  __typename?: 'PatientMoyenParChirurgiensAggregate';
  aggregate?: Maybe<PatientMoyenParChirurgiensAggregateFields>;
  nodes: Array<PatientMoyenParChirurgiens>;
};

/** aggregate fields of "patient_moyen_par_chirurgiens" */
export type PatientMoyenParChirurgiensAggregateFields = {
  __typename?: 'PatientMoyenParChirurgiensAggregateFields';
  avg?: Maybe<PatientMoyenParChirurgiensAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PatientMoyenParChirurgiensMaxFields>;
  min?: Maybe<PatientMoyenParChirurgiensMinFields>;
  stddev?: Maybe<PatientMoyenParChirurgiensStddevFields>;
  stddevPop?: Maybe<PatientMoyenParChirurgiensStddevPopFields>;
  stddevSamp?: Maybe<PatientMoyenParChirurgiensStddevSampFields>;
  sum?: Maybe<PatientMoyenParChirurgiensSumFields>;
  varPop?: Maybe<PatientMoyenParChirurgiensVarPopFields>;
  varSamp?: Maybe<PatientMoyenParChirurgiensVarSampFields>;
  variance?: Maybe<PatientMoyenParChirurgiensVarianceFields>;
};


/** aggregate fields of "patient_moyen_par_chirurgiens" */
export type PatientMoyenParChirurgiensAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type PatientMoyenParChirurgiensAvgFields = {
  __typename?: 'PatientMoyenParChirurgiensAvgFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "patient_moyen_par_chirurgiens". All fields are combined with a logical 'AND'. */
export type PatientMoyenParChirurgiensBoolExp = {
  _and?: InputMaybe<Array<PatientMoyenParChirurgiensBoolExp>>;
  _not?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
  _or?: InputMaybe<Array<PatientMoyenParChirurgiensBoolExp>>;
  chirurgiensActifs?: InputMaybe<BigintComparisonExp>;
  mois?: InputMaybe<TimestamptzComparisonExp>;
  nombrePatients?: InputMaybe<BigintComparisonExp>;
  recrutementMoyenParChirurgien?: InputMaybe<Float8ComparisonExp>;
};

/** aggregate max on columns */
export type PatientMoyenParChirurgiensMaxFields = {
  __typename?: 'PatientMoyenParChirurgiensMaxFields';
  chirurgiensActifs?: Maybe<Scalars['bigint']['output']>;
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type PatientMoyenParChirurgiensMinFields = {
  __typename?: 'PatientMoyenParChirurgiensMinFields';
  chirurgiensActifs?: Maybe<Scalars['bigint']['output']>;
  mois?: Maybe<Scalars['timestamptz']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "patient_moyen_par_chirurgiens". */
export type PatientMoyenParChirurgiensOrderBy = {
  chirurgiensActifs?: InputMaybe<OrderBy>;
  mois?: InputMaybe<OrderBy>;
  nombrePatients?: InputMaybe<OrderBy>;
  recrutementMoyenParChirurgien?: InputMaybe<OrderBy>;
};

/** select columns of table "patient_moyen_par_chirurgiens" */
export type PatientMoyenParChirurgiensSelectColumn =
  /** column name */
  | 'chirurgiensActifs'
  /** column name */
  | 'mois'
  /** column name */
  | 'nombrePatients'
  /** column name */
  | 'recrutementMoyenParChirurgien';

/** aggregate stddev on columns */
export type PatientMoyenParChirurgiensStddevFields = {
  __typename?: 'PatientMoyenParChirurgiensStddevFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type PatientMoyenParChirurgiensStddevPopFields = {
  __typename?: 'PatientMoyenParChirurgiensStddevPopFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type PatientMoyenParChirurgiensStddevSampFields = {
  __typename?: 'PatientMoyenParChirurgiensStddevSampFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "patient_moyen_par_chirurgiens" */
export type PatientMoyenParChirurgiensStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PatientMoyenParChirurgiensStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PatientMoyenParChirurgiensStreamCursorValueInput = {
  chirurgiensActifs?: InputMaybe<Scalars['bigint']['input']>;
  mois?: InputMaybe<Scalars['timestamptz']['input']>;
  nombrePatients?: InputMaybe<Scalars['bigint']['input']>;
  recrutementMoyenParChirurgien?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type PatientMoyenParChirurgiensSumFields = {
  __typename?: 'PatientMoyenParChirurgiensSumFields';
  chirurgiensActifs?: Maybe<Scalars['bigint']['output']>;
  nombrePatients?: Maybe<Scalars['bigint']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['float8']['output']>;
};

/** aggregate varPop on columns */
export type PatientMoyenParChirurgiensVarPopFields = {
  __typename?: 'PatientMoyenParChirurgiensVarPopFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type PatientMoyenParChirurgiensVarSampFields = {
  __typename?: 'PatientMoyenParChirurgiensVarSampFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type PatientMoyenParChirurgiensVarianceFields = {
  __typename?: 'PatientMoyenParChirurgiensVarianceFields';
  chirurgiensActifs?: Maybe<Scalars['Float']['output']>;
  nombrePatients?: Maybe<Scalars['Float']['output']>;
  recrutementMoyenParChirurgien?: Maybe<Scalars['Float']['output']>;
};

/** response of any mutation on the table "patient" */
export type PatientMutationResponse = {
  __typename?: 'PatientMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Patient>;
};

/** input type for inserting object relation for remote table "patient" */
export type PatientObjRelInsertInput = {
  data: PatientInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PatientOnConflict>;
};

/** on_conflict condition type for table "patient" */
export type PatientOnConflict = {
  constraint: PatientConstraint;
  updateColumns?: Array<PatientUpdateColumn>;
  where?: InputMaybe<PatientBoolExp>;
};

/** Ordering options when selecting data from "patient". */
export type PatientOrderBy = {
  activitePreferentiellesAggregate?: InputMaybe<ActivitePreferentielleAggregateOrderBy>;
  birthday?: InputMaybe<OrderBy>;
  chirurgien?: InputMaybe<ChirurgienOrderBy>;
  chirurgienId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dossierStatus?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  etatControlateral?: InputMaybe<OrderBy>;
  glasses?: InputMaybe<OrderBy>;
  habitudesAggregate?: InputMaybe<HabitudesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isArchived?: InputMaybe<OrderBy>;
  lunettesVI?: InputMaybe<OrderBy>;
  lunettesVL?: InputMaybe<OrderBy>;
  lunettesVP?: InputMaybe<OrderBy>;
  monovision?: InputMaybe<OrderBy>;
  nom?: InputMaybe<OrderBy>;
  oeilDominant?: InputMaybe<OrderBy>;
  oeilsAggregate?: InputMaybe<OeilAggregateOrderBy>;
  patientTempTokensAggregate?: InputMaybe<PatientTempTokensAggregateOrderBy>;
  photicEffect?: InputMaybe<OrderBy>;
  prenom?: InputMaybe<OrderBy>;
  sameImplant?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
  telephone?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: patient */
export type PatientPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "patient" */
export type PatientSelectColumn =
  /** column name */
  | 'birthday'
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'email'
  /** column name */
  | 'etatControlateral'
  /** column name */
  | 'glasses'
  /** column name */
  | 'id'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'lunettesVI'
  /** column name */
  | 'lunettesVL'
  /** column name */
  | 'lunettesVP'
  /** column name */
  | 'monovision'
  /** column name */
  | 'nom'
  /** column name */
  | 'oeilDominant'
  /** column name */
  | 'photicEffect'
  /** column name */
  | 'prenom'
  /** column name */
  | 'sameImplant'
  /** column name */
  | 'sameValue'
  /** column name */
  | 'sexe'
  /** column name */
  | 'size'
  /** column name */
  | 'telephone'
  /** column name */
  | 'updatedAt';

/** select "patientAggregateBoolExpBool_andArgumentsColumns" columns of table "patient" */
export type PatientSelectColumnPatientAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'glasses'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'lunettesVI'
  /** column name */
  | 'lunettesVL'
  /** column name */
  | 'lunettesVP'
  /** column name */
  | 'monovision'
  /** column name */
  | 'photicEffect'
  /** column name */
  | 'sameImplant';

/** select "patientAggregateBoolExpBool_orArgumentsColumns" columns of table "patient" */
export type PatientSelectColumnPatientAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'glasses'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'lunettesVI'
  /** column name */
  | 'lunettesVL'
  /** column name */
  | 'lunettesVP'
  /** column name */
  | 'monovision'
  /** column name */
  | 'photicEffect'
  /** column name */
  | 'sameImplant';

/** input type for updating data in table "patient" */
export type PatientSetInput = {
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  etatControlateral?: InputMaybe<Scalars['numeric']['input']>;
  glasses?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVI?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVL?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVP?: InputMaybe<Scalars['Boolean']['input']>;
  monovision?: InputMaybe<Scalars['Boolean']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  oeilDominant?: InputMaybe<Scalars['String']['input']>;
  photicEffect?: InputMaybe<Scalars['Boolean']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  sameImplant?: InputMaybe<Scalars['Boolean']['input']>;
  sameValue?: InputMaybe<Scalars['numeric']['input']>;
  sexe?: InputMaybe<Scalars['numeric']['input']>;
  size?: InputMaybe<Scalars['numeric']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PatientStddevFields = {
  __typename?: 'PatientStddevFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "patient" */
export type PatientStddevOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PatientStddevPopFields = {
  __typename?: 'PatientStddevPopFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "patient" */
export type PatientStddevPopOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PatientStddevSampFields = {
  __typename?: 'PatientStddevSampFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "patient" */
export type PatientStddevSampOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "patient" */
export type PatientStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PatientStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PatientStreamCursorValueInput = {
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  etatControlateral?: InputMaybe<Scalars['numeric']['input']>;
  glasses?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVI?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVL?: InputMaybe<Scalars['Boolean']['input']>;
  lunettesVP?: InputMaybe<Scalars['Boolean']['input']>;
  monovision?: InputMaybe<Scalars['Boolean']['input']>;
  nom?: InputMaybe<Scalars['String']['input']>;
  oeilDominant?: InputMaybe<Scalars['String']['input']>;
  photicEffect?: InputMaybe<Scalars['Boolean']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  sameImplant?: InputMaybe<Scalars['Boolean']['input']>;
  sameValue?: InputMaybe<Scalars['numeric']['input']>;
  sexe?: InputMaybe<Scalars['numeric']['input']>;
  size?: InputMaybe<Scalars['numeric']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PatientSumFields = {
  __typename?: 'PatientSumFields';
  etatControlateral?: Maybe<Scalars['numeric']['output']>;
  sameValue?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "patient" */
export type PatientSumOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** columns and relationships of "patient_temp_tokens" */
export type PatientTempTokens = {
  __typename?: 'PatientTempTokens';
  accessCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt: Scalars['timestamptz']['output'];
  formData?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  ipAddresses?: Maybe<Scalars['jsonb']['output']>;
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  lastSavedAt?: Maybe<Scalars['timestamptz']['output']>;
  patientId: Scalars['uuid']['output'];
  /** An object relationship */
  patient_tokens: Patient;
  token: Scalars['String']['output'];
  usedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "patient_temp_tokens" */
export type PatientTempTokensFormDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "patient_temp_tokens" */
export type PatientTempTokensIpAddressesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "patient_temp_tokens" */
export type PatientTempTokensAggregate = {
  __typename?: 'PatientTempTokensAggregate';
  aggregate?: Maybe<PatientTempTokensAggregateFields>;
  nodes: Array<PatientTempTokens>;
};

export type PatientTempTokensAggregateBoolExp = {
  bool_and?: InputMaybe<PatientTempTokensAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PatientTempTokensAggregateBoolExpBool_Or>;
  count?: InputMaybe<PatientTempTokensAggregateBoolExpCount>;
};

/** aggregate fields of "patient_temp_tokens" */
export type PatientTempTokensAggregateFields = {
  __typename?: 'PatientTempTokensAggregateFields';
  avg?: Maybe<PatientTempTokensAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PatientTempTokensMaxFields>;
  min?: Maybe<PatientTempTokensMinFields>;
  stddev?: Maybe<PatientTempTokensStddevFields>;
  stddevPop?: Maybe<PatientTempTokensStddevPopFields>;
  stddevSamp?: Maybe<PatientTempTokensStddevSampFields>;
  sum?: Maybe<PatientTempTokensSumFields>;
  varPop?: Maybe<PatientTempTokensVarPopFields>;
  varSamp?: Maybe<PatientTempTokensVarSampFields>;
  variance?: Maybe<PatientTempTokensVarianceFields>;
};


/** aggregate fields of "patient_temp_tokens" */
export type PatientTempTokensAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "patient_temp_tokens" */
export type PatientTempTokensAggregateOrderBy = {
  avg?: InputMaybe<PatientTempTokensAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PatientTempTokensMaxOrderBy>;
  min?: InputMaybe<PatientTempTokensMinOrderBy>;
  stddev?: InputMaybe<PatientTempTokensStddevOrderBy>;
  stddevPop?: InputMaybe<PatientTempTokensStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PatientTempTokensStddevSampOrderBy>;
  sum?: InputMaybe<PatientTempTokensSumOrderBy>;
  varPop?: InputMaybe<PatientTempTokensVarPopOrderBy>;
  varSamp?: InputMaybe<PatientTempTokensVarSampOrderBy>;
  variance?: InputMaybe<PatientTempTokensVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PatientTempTokensAppendInput = {
  formData?: InputMaybe<Scalars['jsonb']['input']>;
  ipAddresses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "patient_temp_tokens" */
export type PatientTempTokensArrRelInsertInput = {
  data: Array<PatientTempTokensInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PatientTempTokensOnConflict>;
};

/** aggregate avg on columns */
export type PatientTempTokensAvgFields = {
  __typename?: 'PatientTempTokensAvgFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "patient_temp_tokens" */
export type PatientTempTokensAvgOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "patient_temp_tokens". All fields are combined with a logical 'AND'. */
export type PatientTempTokensBoolExp = {
  _and?: InputMaybe<Array<PatientTempTokensBoolExp>>;
  _not?: InputMaybe<PatientTempTokensBoolExp>;
  _or?: InputMaybe<Array<PatientTempTokensBoolExp>>;
  accessCount?: InputMaybe<IntComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  expiresAt?: InputMaybe<TimestamptzComparisonExp>;
  formData?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  ipAddresses?: InputMaybe<JsonbComparisonExp>;
  isUsed?: InputMaybe<BooleanComparisonExp>;
  lastSavedAt?: InputMaybe<TimestamptzComparisonExp>;
  patientId?: InputMaybe<UuidComparisonExp>;
  patient_tokens?: InputMaybe<PatientBoolExp>;
  token?: InputMaybe<StringComparisonExp>;
  usedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "patient_temp_tokens" */
export type PatientTempTokensConstraint =
  /** unique or primary key constraint on columns "id" */
  | 'patient_temp_tokens_pkey'
  /** unique or primary key constraint on columns "token" */
  | 'patient_temp_tokens_token_key';

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PatientTempTokensDeleteAtPathInput = {
  formData?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PatientTempTokensDeleteElemInput = {
  formData?: InputMaybe<Scalars['Int']['input']>;
  ipAddresses?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PatientTempTokensDeleteKeyInput = {
  formData?: InputMaybe<Scalars['String']['input']>;
  ipAddresses?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "patient_temp_tokens" */
export type PatientTempTokensIncInput = {
  accessCount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "patient_temp_tokens" */
export type PatientTempTokensInsertInput = {
  accessCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddresses?: InputMaybe<Scalars['jsonb']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  lastSavedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  patient_tokens?: InputMaybe<PatientObjRelInsertInput>;
  token?: InputMaybe<Scalars['String']['input']>;
  usedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PatientTempTokensMaxFields = {
  __typename?: 'PatientTempTokensMaxFields';
  accessCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSavedAt?: Maybe<Scalars['timestamptz']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  usedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "patient_temp_tokens" */
export type PatientTempTokensMaxOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSavedAt?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  usedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PatientTempTokensMinFields = {
  __typename?: 'PatientTempTokensMinFields';
  accessCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSavedAt?: Maybe<Scalars['timestamptz']['output']>;
  patientId?: Maybe<Scalars['uuid']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  usedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "patient_temp_tokens" */
export type PatientTempTokensMinOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lastSavedAt?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
  token?: InputMaybe<OrderBy>;
  usedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "patient_temp_tokens" */
export type PatientTempTokensMutationResponse = {
  __typename?: 'PatientTempTokensMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PatientTempTokens>;
};

/** on_conflict condition type for table "patient_temp_tokens" */
export type PatientTempTokensOnConflict = {
  constraint: PatientTempTokensConstraint;
  updateColumns?: Array<PatientTempTokensUpdateColumn>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};

/** Ordering options when selecting data from "patient_temp_tokens". */
export type PatientTempTokensOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  expiresAt?: InputMaybe<OrderBy>;
  formData?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  ipAddresses?: InputMaybe<OrderBy>;
  isUsed?: InputMaybe<OrderBy>;
  lastSavedAt?: InputMaybe<OrderBy>;
  patientId?: InputMaybe<OrderBy>;
  patient_tokens?: InputMaybe<PatientOrderBy>;
  token?: InputMaybe<OrderBy>;
  usedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: patient_temp_tokens */
export type PatientTempTokensPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PatientTempTokensPrependInput = {
  formData?: InputMaybe<Scalars['jsonb']['input']>;
  ipAddresses?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "patient_temp_tokens" */
export type PatientTempTokensSelectColumn =
  /** column name */
  | 'accessCount'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'formData'
  /** column name */
  | 'id'
  /** column name */
  | 'ipAddresses'
  /** column name */
  | 'isUsed'
  /** column name */
  | 'lastSavedAt'
  /** column name */
  | 'patientId'
  /** column name */
  | 'token'
  /** column name */
  | 'usedAt';

/** select "patientTempTokensAggregateBoolExpBool_andArgumentsColumns" columns of table "patient_temp_tokens" */
export type PatientTempTokensSelectColumnPatientTempTokensAggregateBoolExpBool_AndArgumentsColumns =
  /** column name */
  | 'isUsed';

/** select "patientTempTokensAggregateBoolExpBool_orArgumentsColumns" columns of table "patient_temp_tokens" */
export type PatientTempTokensSelectColumnPatientTempTokensAggregateBoolExpBool_OrArgumentsColumns =
  /** column name */
  | 'isUsed';

/** input type for updating data in table "patient_temp_tokens" */
export type PatientTempTokensSetInput = {
  accessCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddresses?: InputMaybe<Scalars['jsonb']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  lastSavedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  usedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PatientTempTokensStddevFields = {
  __typename?: 'PatientTempTokensStddevFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "patient_temp_tokens" */
export type PatientTempTokensStddevOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PatientTempTokensStddevPopFields = {
  __typename?: 'PatientTempTokensStddevPopFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "patient_temp_tokens" */
export type PatientTempTokensStddevPopOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PatientTempTokensStddevSampFields = {
  __typename?: 'PatientTempTokensStddevSampFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "patient_temp_tokens" */
export type PatientTempTokensStddevSampOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "patient_temp_tokens" */
export type PatientTempTokensStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PatientTempTokensStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PatientTempTokensStreamCursorValueInput = {
  accessCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  formData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddresses?: InputMaybe<Scalars['jsonb']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  lastSavedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  patientId?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  usedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PatientTempTokensSumFields = {
  __typename?: 'PatientTempTokensSumFields';
  accessCount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "patient_temp_tokens" */
export type PatientTempTokensSumOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** update columns of table "patient_temp_tokens" */
export type PatientTempTokensUpdateColumn =
  /** column name */
  | 'accessCount'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'expiresAt'
  /** column name */
  | 'formData'
  /** column name */
  | 'id'
  /** column name */
  | 'ipAddresses'
  /** column name */
  | 'isUsed'
  /** column name */
  | 'lastSavedAt'
  /** column name */
  | 'patientId'
  /** column name */
  | 'token'
  /** column name */
  | 'usedAt';

export type PatientTempTokensUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PatientTempTokensAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<PatientTempTokensDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<PatientTempTokensDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<PatientTempTokensDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PatientTempTokensIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PatientTempTokensPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PatientTempTokensSetInput>;
  /** filter the rows which have to be updated */
  where: PatientTempTokensBoolExp;
};

/** aggregate varPop on columns */
export type PatientTempTokensVarPopFields = {
  __typename?: 'PatientTempTokensVarPopFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "patient_temp_tokens" */
export type PatientTempTokensVarPopOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PatientTempTokensVarSampFields = {
  __typename?: 'PatientTempTokensVarSampFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "patient_temp_tokens" */
export type PatientTempTokensVarSampOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PatientTempTokensVarianceFields = {
  __typename?: 'PatientTempTokensVarianceFields';
  accessCount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "patient_temp_tokens" */
export type PatientTempTokensVarianceOrderBy = {
  accessCount?: InputMaybe<OrderBy>;
};

/** update columns of table "patient" */
export type PatientUpdateColumn =
  /** column name */
  | 'birthday'
  /** column name */
  | 'chirurgienId'
  /** column name */
  | 'createdAt'
  /** column name */
  | 'email'
  /** column name */
  | 'etatControlateral'
  /** column name */
  | 'glasses'
  /** column name */
  | 'id'
  /** column name */
  | 'isArchived'
  /** column name */
  | 'lunettesVI'
  /** column name */
  | 'lunettesVL'
  /** column name */
  | 'lunettesVP'
  /** column name */
  | 'monovision'
  /** column name */
  | 'nom'
  /** column name */
  | 'oeilDominant'
  /** column name */
  | 'photicEffect'
  /** column name */
  | 'prenom'
  /** column name */
  | 'sameImplant'
  /** column name */
  | 'sameValue'
  /** column name */
  | 'sexe'
  /** column name */
  | 'size'
  /** column name */
  | 'telephone'
  /** column name */
  | 'updatedAt';

export type PatientUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PatientIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PatientSetInput>;
  /** filter the rows which have to be updated */
  where: PatientBoolExp;
};

/** aggregate varPop on columns */
export type PatientVarPopFields = {
  __typename?: 'PatientVarPopFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "patient" */
export type PatientVarPopOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PatientVarSampFields = {
  __typename?: 'PatientVarSampFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "patient" */
export type PatientVarSampOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PatientVarianceFields = {
  __typename?: 'PatientVarianceFields';
  etatControlateral?: Maybe<Scalars['Float']['output']>;
  sameValue?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "patient" */
export type PatientVarianceOrderBy = {
  etatControlateral?: InputMaybe<OrderBy>;
  sameValue?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
  size?: InputMaybe<OrderBy>;
};

/** columns and relationships of "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatients = {
  __typename?: 'RepartitionActivitePreferentiellePatients';
  logmarValue?: Maybe<Scalars['numeric']['output']>;
  nombrePersonnes?: Maybe<Scalars['Int']['output']>;
};

export type RepartitionActivitePreferentiellePatientsAggregate = {
  __typename?: 'RepartitionActivitePreferentiellePatientsAggregate';
  aggregate?: Maybe<RepartitionActivitePreferentiellePatientsAggregateFields>;
  nodes: Array<RepartitionActivitePreferentiellePatients>;
};

/** aggregate fields of "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsAggregateFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsAggregateFields';
  avg?: Maybe<RepartitionActivitePreferentiellePatientsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RepartitionActivitePreferentiellePatientsMaxFields>;
  min?: Maybe<RepartitionActivitePreferentiellePatientsMinFields>;
  stddev?: Maybe<RepartitionActivitePreferentiellePatientsStddevFields>;
  stddevPop?: Maybe<RepartitionActivitePreferentiellePatientsStddevPopFields>;
  stddevSamp?: Maybe<RepartitionActivitePreferentiellePatientsStddevSampFields>;
  sum?: Maybe<RepartitionActivitePreferentiellePatientsSumFields>;
  varPop?: Maybe<RepartitionActivitePreferentiellePatientsVarPopFields>;
  varSamp?: Maybe<RepartitionActivitePreferentiellePatientsVarSampFields>;
  variance?: Maybe<RepartitionActivitePreferentiellePatientsVarianceFields>;
};


/** aggregate fields of "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RepartitionActivitePreferentiellePatientsAvgFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsAvgFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repartition_activite_preferentielle_patients". All fields are combined with a logical 'AND'. */
export type RepartitionActivitePreferentiellePatientsBoolExp = {
  _and?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsBoolExp>>;
  _not?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
  _or?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsBoolExp>>;
  logmarValue?: InputMaybe<NumericComparisonExp>;
  nombrePersonnes?: InputMaybe<IntComparisonExp>;
};

/** input type for incrementing numeric columns in table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsIncInput = {
  logmarValue?: InputMaybe<Scalars['numeric']['input']>;
  nombrePersonnes?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsInsertInput = {
  logmarValue?: InputMaybe<Scalars['numeric']['input']>;
  nombrePersonnes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RepartitionActivitePreferentiellePatientsMaxFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsMaxFields';
  logmarValue?: Maybe<Scalars['numeric']['output']>;
  nombrePersonnes?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type RepartitionActivitePreferentiellePatientsMinFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsMinFields';
  logmarValue?: Maybe<Scalars['numeric']['output']>;
  nombrePersonnes?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsMutationResponse = {
  __typename?: 'RepartitionActivitePreferentiellePatientsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RepartitionActivitePreferentiellePatients>;
};

/** Ordering options when selecting data from "repartition_activite_preferentielle_patients". */
export type RepartitionActivitePreferentiellePatientsOrderBy = {
  logmarValue?: InputMaybe<OrderBy>;
  nombrePersonnes?: InputMaybe<OrderBy>;
};

/** select columns of table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsSelectColumn =
  /** column name */
  | 'logmarValue'
  /** column name */
  | 'nombrePersonnes';

/** input type for updating data in table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsSetInput = {
  logmarValue?: InputMaybe<Scalars['numeric']['input']>;
  nombrePersonnes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type RepartitionActivitePreferentiellePatientsStddevFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsStddevFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RepartitionActivitePreferentiellePatientsStddevPopFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsStddevPopFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RepartitionActivitePreferentiellePatientsStddevSampFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsStddevSampFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "repartition_activite_preferentielle_patients" */
export type RepartitionActivitePreferentiellePatientsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepartitionActivitePreferentiellePatientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepartitionActivitePreferentiellePatientsStreamCursorValueInput = {
  logmarValue?: InputMaybe<Scalars['numeric']['input']>;
  nombrePersonnes?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type RepartitionActivitePreferentiellePatientsSumFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsSumFields';
  logmarValue?: Maybe<Scalars['numeric']['output']>;
  nombrePersonnes?: Maybe<Scalars['Int']['output']>;
};

export type RepartitionActivitePreferentiellePatientsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RepartitionActivitePreferentiellePatientsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RepartitionActivitePreferentiellePatientsSetInput>;
  /** filter the rows which have to be updated */
  where: RepartitionActivitePreferentiellePatientsBoolExp;
};

/** aggregate varPop on columns */
export type RepartitionActivitePreferentiellePatientsVarPopFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsVarPopFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RepartitionActivitePreferentiellePatientsVarSampFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsVarSampFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RepartitionActivitePreferentiellePatientsVarianceFields = {
  __typename?: 'RepartitionActivitePreferentiellePatientsVarianceFields';
  logmarValue?: Maybe<Scalars['Float']['output']>;
  nombrePersonnes?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repartition_implants" */
export type RepartitionImplants = {
  __typename?: 'RepartitionImplants';
  materiau?: Maybe<Scalars['String']['output']>;
  nombreImplants?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RepartitionImplantsAggregate = {
  __typename?: 'RepartitionImplantsAggregate';
  aggregate?: Maybe<RepartitionImplantsAggregateFields>;
  nodes: Array<RepartitionImplants>;
};

/** aggregate fields of "repartition_implants" */
export type RepartitionImplantsAggregateFields = {
  __typename?: 'RepartitionImplantsAggregateFields';
  avg?: Maybe<RepartitionImplantsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RepartitionImplantsMaxFields>;
  min?: Maybe<RepartitionImplantsMinFields>;
  stddev?: Maybe<RepartitionImplantsStddevFields>;
  stddevPop?: Maybe<RepartitionImplantsStddevPopFields>;
  stddevSamp?: Maybe<RepartitionImplantsStddevSampFields>;
  sum?: Maybe<RepartitionImplantsSumFields>;
  varPop?: Maybe<RepartitionImplantsVarPopFields>;
  varSamp?: Maybe<RepartitionImplantsVarSampFields>;
  variance?: Maybe<RepartitionImplantsVarianceFields>;
};


/** aggregate fields of "repartition_implants" */
export type RepartitionImplantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RepartitionImplantsAvgFields = {
  __typename?: 'RepartitionImplantsAvgFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repartition_implants". All fields are combined with a logical 'AND'. */
export type RepartitionImplantsBoolExp = {
  _and?: InputMaybe<Array<RepartitionImplantsBoolExp>>;
  _not?: InputMaybe<RepartitionImplantsBoolExp>;
  _or?: InputMaybe<Array<RepartitionImplantsBoolExp>>;
  materiau?: InputMaybe<StringComparisonExp>;
  nombreImplants?: InputMaybe<BigintComparisonExp>;
  pourcentage?: InputMaybe<NumericComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** aggregate max on columns */
export type RepartitionImplantsMaxFields = {
  __typename?: 'RepartitionImplantsMaxFields';
  materiau?: Maybe<Scalars['String']['output']>;
  nombreImplants?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RepartitionImplantsMinFields = {
  __typename?: 'RepartitionImplantsMinFields';
  materiau?: Maybe<Scalars['String']['output']>;
  nombreImplants?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "repartition_implants". */
export type RepartitionImplantsOrderBy = {
  materiau?: InputMaybe<OrderBy>;
  nombreImplants?: InputMaybe<OrderBy>;
  pourcentage?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** select columns of table "repartition_implants" */
export type RepartitionImplantsSelectColumn =
  /** column name */
  | 'materiau'
  /** column name */
  | 'nombreImplants'
  /** column name */
  | 'pourcentage'
  /** column name */
  | 'type';

/** aggregate stddev on columns */
export type RepartitionImplantsStddevFields = {
  __typename?: 'RepartitionImplantsStddevFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RepartitionImplantsStddevPopFields = {
  __typename?: 'RepartitionImplantsStddevPopFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RepartitionImplantsStddevSampFields = {
  __typename?: 'RepartitionImplantsStddevSampFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "repartition_implants" */
export type RepartitionImplantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepartitionImplantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepartitionImplantsStreamCursorValueInput = {
  materiau?: InputMaybe<Scalars['String']['input']>;
  nombreImplants?: InputMaybe<Scalars['bigint']['input']>;
  pourcentage?: InputMaybe<Scalars['numeric']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RepartitionImplantsSumFields = {
  __typename?: 'RepartitionImplantsSumFields';
  nombreImplants?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate varPop on columns */
export type RepartitionImplantsVarPopFields = {
  __typename?: 'RepartitionImplantsVarPopFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RepartitionImplantsVarSampFields = {
  __typename?: 'RepartitionImplantsVarSampFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RepartitionImplantsVarianceFields = {
  __typename?: 'RepartitionImplantsVarianceFields';
  nombreImplants?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repartition_sexes_patients" */
export type RepartitionSexesPatients = {
  __typename?: 'RepartitionSexesPatients';
  nombre?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
};

export type RepartitionSexesPatientsAggregate = {
  __typename?: 'RepartitionSexesPatientsAggregate';
  aggregate?: Maybe<RepartitionSexesPatientsAggregateFields>;
  nodes: Array<RepartitionSexesPatients>;
};

/** aggregate fields of "repartition_sexes_patients" */
export type RepartitionSexesPatientsAggregateFields = {
  __typename?: 'RepartitionSexesPatientsAggregateFields';
  avg?: Maybe<RepartitionSexesPatientsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RepartitionSexesPatientsMaxFields>;
  min?: Maybe<RepartitionSexesPatientsMinFields>;
  stddev?: Maybe<RepartitionSexesPatientsStddevFields>;
  stddevPop?: Maybe<RepartitionSexesPatientsStddevPopFields>;
  stddevSamp?: Maybe<RepartitionSexesPatientsStddevSampFields>;
  sum?: Maybe<RepartitionSexesPatientsSumFields>;
  varPop?: Maybe<RepartitionSexesPatientsVarPopFields>;
  varSamp?: Maybe<RepartitionSexesPatientsVarSampFields>;
  variance?: Maybe<RepartitionSexesPatientsVarianceFields>;
};


/** aggregate fields of "repartition_sexes_patients" */
export type RepartitionSexesPatientsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RepartitionSexesPatientsAvgFields = {
  __typename?: 'RepartitionSexesPatientsAvgFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repartition_sexes_patients". All fields are combined with a logical 'AND'. */
export type RepartitionSexesPatientsBoolExp = {
  _and?: InputMaybe<Array<RepartitionSexesPatientsBoolExp>>;
  _not?: InputMaybe<RepartitionSexesPatientsBoolExp>;
  _or?: InputMaybe<Array<RepartitionSexesPatientsBoolExp>>;
  nombre?: InputMaybe<BigintComparisonExp>;
  pourcentage?: InputMaybe<NumericComparisonExp>;
  sexe?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type RepartitionSexesPatientsMaxFields = {
  __typename?: 'RepartitionSexesPatientsMaxFields';
  nombre?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type RepartitionSexesPatientsMinFields = {
  __typename?: 'RepartitionSexesPatientsMinFields';
  nombre?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "repartition_sexes_patients". */
export type RepartitionSexesPatientsOrderBy = {
  nombre?: InputMaybe<OrderBy>;
  pourcentage?: InputMaybe<OrderBy>;
  sexe?: InputMaybe<OrderBy>;
};

/** select columns of table "repartition_sexes_patients" */
export type RepartitionSexesPatientsSelectColumn =
  /** column name */
  | 'nombre'
  /** column name */
  | 'pourcentage'
  /** column name */
  | 'sexe';

/** aggregate stddev on columns */
export type RepartitionSexesPatientsStddevFields = {
  __typename?: 'RepartitionSexesPatientsStddevFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RepartitionSexesPatientsStddevPopFields = {
  __typename?: 'RepartitionSexesPatientsStddevPopFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RepartitionSexesPatientsStddevSampFields = {
  __typename?: 'RepartitionSexesPatientsStddevSampFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "repartition_sexes_patients" */
export type RepartitionSexesPatientsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepartitionSexesPatientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepartitionSexesPatientsStreamCursorValueInput = {
  nombre?: InputMaybe<Scalars['bigint']['input']>;
  pourcentage?: InputMaybe<Scalars['numeric']['input']>;
  sexe?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type RepartitionSexesPatientsSumFields = {
  __typename?: 'RepartitionSexesPatientsSumFields';
  nombre?: Maybe<Scalars['bigint']['output']>;
  pourcentage?: Maybe<Scalars['numeric']['output']>;
  sexe?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate varPop on columns */
export type RepartitionSexesPatientsVarPopFields = {
  __typename?: 'RepartitionSexesPatientsVarPopFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RepartitionSexesPatientsVarSampFields = {
  __typename?: 'RepartitionSexesPatientsVarSampFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RepartitionSexesPatientsVarianceFields = {
  __typename?: 'RepartitionSexesPatientsVarianceFields';
  nombre?: Maybe<Scalars['Float']['output']>;
  pourcentage?: Maybe<Scalars['Float']['output']>;
  sexe?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "repartition_vision_patients" */
export type RepartitionVisionPatients = {
  __typename?: 'RepartitionVisionPatients';
  pourcentageVi?: Maybe<Scalars['numeric']['output']>;
  pourcentageVl?: Maybe<Scalars['numeric']['output']>;
  pourcentageVp?: Maybe<Scalars['numeric']['output']>;
};

export type RepartitionVisionPatientsAggregate = {
  __typename?: 'RepartitionVisionPatientsAggregate';
  aggregate?: Maybe<RepartitionVisionPatientsAggregateFields>;
  nodes: Array<RepartitionVisionPatients>;
};

/** aggregate fields of "repartition_vision_patients" */
export type RepartitionVisionPatientsAggregateFields = {
  __typename?: 'RepartitionVisionPatientsAggregateFields';
  avg?: Maybe<RepartitionVisionPatientsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RepartitionVisionPatientsMaxFields>;
  min?: Maybe<RepartitionVisionPatientsMinFields>;
  stddev?: Maybe<RepartitionVisionPatientsStddevFields>;
  stddevPop?: Maybe<RepartitionVisionPatientsStddevPopFields>;
  stddevSamp?: Maybe<RepartitionVisionPatientsStddevSampFields>;
  sum?: Maybe<RepartitionVisionPatientsSumFields>;
  varPop?: Maybe<RepartitionVisionPatientsVarPopFields>;
  varSamp?: Maybe<RepartitionVisionPatientsVarSampFields>;
  variance?: Maybe<RepartitionVisionPatientsVarianceFields>;
};


/** aggregate fields of "repartition_vision_patients" */
export type RepartitionVisionPatientsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RepartitionVisionPatientsAvgFields = {
  __typename?: 'RepartitionVisionPatientsAvgFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "repartition_vision_patients". All fields are combined with a logical 'AND'. */
export type RepartitionVisionPatientsBoolExp = {
  _and?: InputMaybe<Array<RepartitionVisionPatientsBoolExp>>;
  _not?: InputMaybe<RepartitionVisionPatientsBoolExp>;
  _or?: InputMaybe<Array<RepartitionVisionPatientsBoolExp>>;
  pourcentageVi?: InputMaybe<NumericComparisonExp>;
  pourcentageVl?: InputMaybe<NumericComparisonExp>;
  pourcentageVp?: InputMaybe<NumericComparisonExp>;
};

/** aggregate max on columns */
export type RepartitionVisionPatientsMaxFields = {
  __typename?: 'RepartitionVisionPatientsMaxFields';
  pourcentageVi?: Maybe<Scalars['numeric']['output']>;
  pourcentageVl?: Maybe<Scalars['numeric']['output']>;
  pourcentageVp?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate min on columns */
export type RepartitionVisionPatientsMinFields = {
  __typename?: 'RepartitionVisionPatientsMinFields';
  pourcentageVi?: Maybe<Scalars['numeric']['output']>;
  pourcentageVl?: Maybe<Scalars['numeric']['output']>;
  pourcentageVp?: Maybe<Scalars['numeric']['output']>;
};

/** Ordering options when selecting data from "repartition_vision_patients". */
export type RepartitionVisionPatientsOrderBy = {
  pourcentageVi?: InputMaybe<OrderBy>;
  pourcentageVl?: InputMaybe<OrderBy>;
  pourcentageVp?: InputMaybe<OrderBy>;
};

/** select columns of table "repartition_vision_patients" */
export type RepartitionVisionPatientsSelectColumn =
  /** column name */
  | 'pourcentageVi'
  /** column name */
  | 'pourcentageVl'
  /** column name */
  | 'pourcentageVp';

/** aggregate stddev on columns */
export type RepartitionVisionPatientsStddevFields = {
  __typename?: 'RepartitionVisionPatientsStddevFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RepartitionVisionPatientsStddevPopFields = {
  __typename?: 'RepartitionVisionPatientsStddevPopFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RepartitionVisionPatientsStddevSampFields = {
  __typename?: 'RepartitionVisionPatientsStddevSampFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "repartition_vision_patients" */
export type RepartitionVisionPatientsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RepartitionVisionPatientsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RepartitionVisionPatientsStreamCursorValueInput = {
  pourcentageVi?: InputMaybe<Scalars['numeric']['input']>;
  pourcentageVl?: InputMaybe<Scalars['numeric']['input']>;
  pourcentageVp?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type RepartitionVisionPatientsSumFields = {
  __typename?: 'RepartitionVisionPatientsSumFields';
  pourcentageVi?: Maybe<Scalars['numeric']['output']>;
  pourcentageVl?: Maybe<Scalars['numeric']['output']>;
  pourcentageVp?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate varPop on columns */
export type RepartitionVisionPatientsVarPopFields = {
  __typename?: 'RepartitionVisionPatientsVarPopFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RepartitionVisionPatientsVarSampFields = {
  __typename?: 'RepartitionVisionPatientsVarSampFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RepartitionVisionPatientsVarianceFields = {
  __typename?: 'RepartitionVisionPatientsVarianceFields';
  pourcentageVi?: Maybe<Scalars['Float']['output']>;
  pourcentageVl?: Maybe<Scalars['Float']['output']>;
  pourcentageVp?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "time". All fields are combined with logical 'AND'. */
export type TimeComparisonExp = {
  _eq?: InputMaybe<Scalars['time']['input']>;
  _gt?: InputMaybe<Scalars['time']['input']>;
  _gte?: InputMaybe<Scalars['time']['input']>;
  _in?: InputMaybe<Array<Scalars['time']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['time']['input']>;
  _lte?: InputMaybe<Scalars['time']['input']>;
  _neq?: InputMaybe<Scalars['time']['input']>;
  _nin?: InputMaybe<Array<Scalars['time']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type ActivitePreferentielleAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActivitePreferentielleBoolExp>;
  predicate: IntComparisonExp;
};

export type ChoixAggregateBoolExpBool_And = {
  arguments: ChoixSelectColumnChoixAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChoixBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ChoixAggregateBoolExpBool_Or = {
  arguments: ChoixSelectColumnChoixAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChoixBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ChoixAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChoixSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChoixBoolExp>;
  predicate: IntComparisonExp;
};

export type FavorisAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<FavorisSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FavorisBoolExp>;
  predicate: IntComparisonExp;
};

export type GetDistributionAgePatientsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
};

export type GetMoyenneAgeTaillePatientsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
  sexe_param?: InputMaybe<Scalars['Int']['input']>;
};

export type GetPatientMoyenParChirurgiensArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
};

export type GetRepartitionActivitePreferentiellePatientsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
  sexe_param?: InputMaybe<Scalars['Int']['input']>;
};

export type GetRepartitionImplantsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
  sexe_param?: InputMaybe<Scalars['Int']['input']>;
};

export type GetRepartitionSexesPatientsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
};

export type GetRepartitionVisionPatientsArgs = {
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
  sexe_param?: InputMaybe<Scalars['Int']['input']>;
};

export type HabitudesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<HabitudesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HabitudesBoolExp>;
  predicate: IntComparisonExp;
};

export type HelpTextsAggregateBoolExpBool_And = {
  arguments: HelpTextsSelectColumnHelpTextsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HelpTextsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type HelpTextsAggregateBoolExpBool_Or = {
  arguments: HelpTextsSelectColumnHelpTextsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HelpTextsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type HelpTextsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<HelpTextsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<HelpTextsBoolExp>;
  predicate: IntComparisonExp;
};

export type ImplantAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ImplantSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ImplantBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "activitePreferentielle" */
  deleteActivitePreferentielle?: Maybe<ActivitePreferentielleMutationResponse>;
  /** delete single row from the table: "activitePreferentielle" */
  deleteActivitePreferentielleByPk?: Maybe<ActivitePreferentielle>;
  /** delete data from the table: "chirurgien" */
  deleteChirurgien?: Maybe<ChirurgienMutationResponse>;
  /** delete single row from the table: "chirurgien" */
  deleteChirurgienByPk?: Maybe<Chirurgien>;
  /** delete data from the table: "choix" */
  deleteChoix?: Maybe<ChoixMutationResponse>;
  /** delete single row from the table: "choix" */
  deleteChoixByPk?: Maybe<Choix>;
  /** delete data from the table: "favoris" */
  deleteFavoris?: Maybe<FavorisMutationResponse>;
  /** delete single row from the table: "favoris" */
  deleteFavorisByPk?: Maybe<Favoris>;
  /** delete data from the table: "habitudes" */
  deleteHabitudes?: Maybe<HabitudesMutationResponse>;
  /** delete single row from the table: "habitudes" */
  deleteHabitudesByPk?: Maybe<Habitudes>;
  /** delete data from the table: "help_texts" */
  deleteHelpTexts?: Maybe<HelpTextsMutationResponse>;
  /** delete single row from the table: "help_texts" */
  deleteHelpTextsByPk?: Maybe<HelpTexts>;
  /** delete data from the table: "implant" */
  deleteImplant?: Maybe<ImplantMutationResponse>;
  /** delete single row from the table: "implant" */
  deleteImplantByPk?: Maybe<Implant>;
  /** delete data from the table: "laboratoire" */
  deleteLaboratoire?: Maybe<LaboratoireMutationResponse>;
  /** delete single row from the table: "laboratoire" */
  deleteLaboratoireByPk?: Maybe<Laboratoire>;
  /** delete data from the table: "oeil" */
  deleteOeil?: Maybe<OeilMutationResponse>;
  /** delete single row from the table: "oeil" */
  deleteOeilByPk?: Maybe<Oeil>;
  /** delete data from the table: "parametres" */
  deleteParametres?: Maybe<ParametresMutationResponse>;
  /** delete single row from the table: "parametres" */
  deleteParametresByPk?: Maybe<Parametres>;
  /** delete data from the table: "patient" */
  deletePatient?: Maybe<PatientMutationResponse>;
  /** delete single row from the table: "patient" */
  deletePatientByPk?: Maybe<Patient>;
  /** delete data from the table: "patient_temp_tokens" */
  deletePatientTempTokens?: Maybe<PatientTempTokensMutationResponse>;
  /** delete single row from the table: "patient_temp_tokens" */
  deletePatientTempTokensByPk?: Maybe<PatientTempTokens>;
  /** delete data from the table: "repartition_activite_preferentielle_patients" */
  deleteRepartitionActivitePreferentiellePatients?: Maybe<RepartitionActivitePreferentiellePatientsMutationResponse>;
  /** insert data into the table: "activitePreferentielle" */
  insertActivitePreferentielle?: Maybe<ActivitePreferentielleMutationResponse>;
  /** insert a single row into the table: "activitePreferentielle" */
  insertActivitePreferentielleOne?: Maybe<ActivitePreferentielle>;
  /** insert data into the table: "chirurgien" */
  insertChirurgien?: Maybe<ChirurgienMutationResponse>;
  /** insert a single row into the table: "chirurgien" */
  insertChirurgienOne?: Maybe<Chirurgien>;
  /** insert data into the table: "choix" */
  insertChoix?: Maybe<ChoixMutationResponse>;
  /** insert a single row into the table: "choix" */
  insertChoixOne?: Maybe<Choix>;
  /** insert data into the table: "favoris" */
  insertFavoris?: Maybe<FavorisMutationResponse>;
  /** insert a single row into the table: "favoris" */
  insertFavorisOne?: Maybe<Favoris>;
  /** insert data into the table: "habitudes" */
  insertHabitudes?: Maybe<HabitudesMutationResponse>;
  /** insert a single row into the table: "habitudes" */
  insertHabitudesOne?: Maybe<Habitudes>;
  /** insert data into the table: "help_texts" */
  insertHelpTexts?: Maybe<HelpTextsMutationResponse>;
  /** insert a single row into the table: "help_texts" */
  insertHelpTextsOne?: Maybe<HelpTexts>;
  /** insert data into the table: "implant" */
  insertImplant?: Maybe<ImplantMutationResponse>;
  /** insert a single row into the table: "implant" */
  insertImplantOne?: Maybe<Implant>;
  /** insert data into the table: "laboratoire" */
  insertLaboratoire?: Maybe<LaboratoireMutationResponse>;
  /** insert a single row into the table: "laboratoire" */
  insertLaboratoireOne?: Maybe<Laboratoire>;
  /** insert data into the table: "oeil" */
  insertOeil?: Maybe<OeilMutationResponse>;
  /** insert a single row into the table: "oeil" */
  insertOeilOne?: Maybe<Oeil>;
  /** insert data into the table: "parametres" */
  insertParametres?: Maybe<ParametresMutationResponse>;
  /** insert a single row into the table: "parametres" */
  insertParametresOne?: Maybe<Parametres>;
  /** insert data into the table: "patient" */
  insertPatient?: Maybe<PatientMutationResponse>;
  /** insert a single row into the table: "patient" */
  insertPatientOne?: Maybe<Patient>;
  /** insert data into the table: "patient_temp_tokens" */
  insertPatientTempTokens?: Maybe<PatientTempTokensMutationResponse>;
  /** insert a single row into the table: "patient_temp_tokens" */
  insertPatientTempTokensOne?: Maybe<PatientTempTokens>;
  /** insert data into the table: "repartition_activite_preferentielle_patients" */
  insertRepartitionActivitePreferentiellePatients?: Maybe<RepartitionActivitePreferentiellePatientsMutationResponse>;
  /** insert a single row into the table: "repartition_activite_preferentielle_patients" */
  insertRepartitionActivitePreferentiellePatientsOne?: Maybe<RepartitionActivitePreferentiellePatients>;
  /** update data of the table: "activitePreferentielle" */
  updateActivitePreferentielle?: Maybe<ActivitePreferentielleMutationResponse>;
  /** update single row of the table: "activitePreferentielle" */
  updateActivitePreferentielleByPk?: Maybe<ActivitePreferentielle>;
  /** update multiples rows of table: "activitePreferentielle" */
  updateActivitePreferentielleMany?: Maybe<Array<Maybe<ActivitePreferentielleMutationResponse>>>;
  /** update data of the table: "chirurgien" */
  updateChirurgien?: Maybe<ChirurgienMutationResponse>;
  /** update single row of the table: "chirurgien" */
  updateChirurgienByPk?: Maybe<Chirurgien>;
  /** update multiples rows of table: "chirurgien" */
  updateChirurgienMany?: Maybe<Array<Maybe<ChirurgienMutationResponse>>>;
  /** update data of the table: "choix" */
  updateChoix?: Maybe<ChoixMutationResponse>;
  /** update single row of the table: "choix" */
  updateChoixByPk?: Maybe<Choix>;
  /** update multiples rows of table: "choix" */
  updateChoixMany?: Maybe<Array<Maybe<ChoixMutationResponse>>>;
  /** update data of the table: "favoris" */
  updateFavoris?: Maybe<FavorisMutationResponse>;
  /** update single row of the table: "favoris" */
  updateFavorisByPk?: Maybe<Favoris>;
  /** update multiples rows of table: "favoris" */
  updateFavorisMany?: Maybe<Array<Maybe<FavorisMutationResponse>>>;
  /** update data of the table: "habitudes" */
  updateHabitudes?: Maybe<HabitudesMutationResponse>;
  /** update single row of the table: "habitudes" */
  updateHabitudesByPk?: Maybe<Habitudes>;
  /** update multiples rows of table: "habitudes" */
  updateHabitudesMany?: Maybe<Array<Maybe<HabitudesMutationResponse>>>;
  /** update data of the table: "help_texts" */
  updateHelpTexts?: Maybe<HelpTextsMutationResponse>;
  /** update single row of the table: "help_texts" */
  updateHelpTextsByPk?: Maybe<HelpTexts>;
  /** update multiples rows of table: "help_texts" */
  updateHelpTextsMany?: Maybe<Array<Maybe<HelpTextsMutationResponse>>>;
  /** update data of the table: "implant" */
  updateImplant?: Maybe<ImplantMutationResponse>;
  /** update single row of the table: "implant" */
  updateImplantByPk?: Maybe<Implant>;
  /** update multiples rows of table: "implant" */
  updateImplantMany?: Maybe<Array<Maybe<ImplantMutationResponse>>>;
  /** update data of the table: "laboratoire" */
  updateLaboratoire?: Maybe<LaboratoireMutationResponse>;
  /** update single row of the table: "laboratoire" */
  updateLaboratoireByPk?: Maybe<Laboratoire>;
  /** update multiples rows of table: "laboratoire" */
  updateLaboratoireMany?: Maybe<Array<Maybe<LaboratoireMutationResponse>>>;
  /** update data of the table: "oeil" */
  updateOeil?: Maybe<OeilMutationResponse>;
  /** update single row of the table: "oeil" */
  updateOeilByPk?: Maybe<Oeil>;
  /** update multiples rows of table: "oeil" */
  updateOeilMany?: Maybe<Array<Maybe<OeilMutationResponse>>>;
  /** update data of the table: "parametres" */
  updateParametres?: Maybe<ParametresMutationResponse>;
  /** update single row of the table: "parametres" */
  updateParametresByPk?: Maybe<Parametres>;
  /** update multiples rows of table: "parametres" */
  updateParametresMany?: Maybe<Array<Maybe<ParametresMutationResponse>>>;
  /** update data of the table: "patient" */
  updatePatient?: Maybe<PatientMutationResponse>;
  /** update single row of the table: "patient" */
  updatePatientByPk?: Maybe<Patient>;
  /** update multiples rows of table: "patient" */
  updatePatientMany?: Maybe<Array<Maybe<PatientMutationResponse>>>;
  /** update data of the table: "patient_temp_tokens" */
  updatePatientTempTokens?: Maybe<PatientTempTokensMutationResponse>;
  /** update single row of the table: "patient_temp_tokens" */
  updatePatientTempTokensByPk?: Maybe<PatientTempTokens>;
  /** update multiples rows of table: "patient_temp_tokens" */
  updatePatientTempTokensMany?: Maybe<Array<Maybe<PatientTempTokensMutationResponse>>>;
  /** update data of the table: "repartition_activite_preferentielle_patients" */
  updateRepartitionActivitePreferentiellePatients?: Maybe<RepartitionActivitePreferentiellePatientsMutationResponse>;
  /** update multiples rows of table: "repartition_activite_preferentielle_patients" */
  updateRepartitionActivitePreferentiellePatientsMany?: Maybe<Array<Maybe<RepartitionActivitePreferentiellePatientsMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootDeleteActivitePreferentielleArgs = {
  where: ActivitePreferentielleBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteActivitePreferentielleByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChirurgienArgs = {
  where: ChirurgienBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChirurgienByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChoixArgs = {
  where: ChoixBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChoixByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFavorisArgs = {
  where: FavorisBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteFavorisByPkArgs = {
  chirurgienId: Scalars['uuid']['input'];
  implantId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteHabitudesArgs = {
  where: HabitudesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteHabitudesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteHelpTextsArgs = {
  where: HelpTextsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteHelpTextsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteImplantArgs = {
  where: ImplantBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteImplantByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteLaboratoireArgs = {
  where: LaboratoireBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteLaboratoireByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOeilArgs = {
  where: OeilBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOeilByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteParametresArgs = {
  where: ParametresBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteParametresByPkArgs = {
  paramKey: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeletePatientArgs = {
  where: PatientBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePatientByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePatientTempTokensArgs = {
  where: PatientTempTokensBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePatientTempTokensByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRepartitionActivitePreferentiellePatientsArgs = {
  where: RepartitionActivitePreferentiellePatientsBoolExp;
};


/** mutation root */
export type Mutation_RootInsertActivitePreferentielleArgs = {
  objects: Array<ActivitePreferentielleInsertInput>;
  onConflict?: InputMaybe<ActivitePreferentielleOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertActivitePreferentielleOneArgs = {
  object: ActivitePreferentielleInsertInput;
  onConflict?: InputMaybe<ActivitePreferentielleOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChirurgienArgs = {
  objects: Array<ChirurgienInsertInput>;
  onConflict?: InputMaybe<ChirurgienOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChirurgienOneArgs = {
  object: ChirurgienInsertInput;
  onConflict?: InputMaybe<ChirurgienOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChoixArgs = {
  objects: Array<ChoixInsertInput>;
  onConflict?: InputMaybe<ChoixOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChoixOneArgs = {
  object: ChoixInsertInput;
  onConflict?: InputMaybe<ChoixOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFavorisArgs = {
  objects: Array<FavorisInsertInput>;
  onConflict?: InputMaybe<FavorisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertFavorisOneArgs = {
  object: FavorisInsertInput;
  onConflict?: InputMaybe<FavorisOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertHabitudesArgs = {
  objects: Array<HabitudesInsertInput>;
  onConflict?: InputMaybe<HabitudesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertHabitudesOneArgs = {
  object: HabitudesInsertInput;
  onConflict?: InputMaybe<HabitudesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertHelpTextsArgs = {
  objects: Array<HelpTextsInsertInput>;
  onConflict?: InputMaybe<HelpTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertHelpTextsOneArgs = {
  object: HelpTextsInsertInput;
  onConflict?: InputMaybe<HelpTextsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertImplantArgs = {
  objects: Array<ImplantInsertInput>;
  onConflict?: InputMaybe<ImplantOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertImplantOneArgs = {
  object: ImplantInsertInput;
  onConflict?: InputMaybe<ImplantOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLaboratoireArgs = {
  objects: Array<LaboratoireInsertInput>;
  onConflict?: InputMaybe<LaboratoireOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertLaboratoireOneArgs = {
  object: LaboratoireInsertInput;
  onConflict?: InputMaybe<LaboratoireOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOeilArgs = {
  objects: Array<OeilInsertInput>;
  onConflict?: InputMaybe<OeilOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOeilOneArgs = {
  object: OeilInsertInput;
  onConflict?: InputMaybe<OeilOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertParametresArgs = {
  objects: Array<ParametresInsertInput>;
  onConflict?: InputMaybe<ParametresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertParametresOneArgs = {
  object: ParametresInsertInput;
  onConflict?: InputMaybe<ParametresOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPatientArgs = {
  objects: Array<PatientInsertInput>;
  onConflict?: InputMaybe<PatientOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPatientOneArgs = {
  object: PatientInsertInput;
  onConflict?: InputMaybe<PatientOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPatientTempTokensArgs = {
  objects: Array<PatientTempTokensInsertInput>;
  onConflict?: InputMaybe<PatientTempTokensOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPatientTempTokensOneArgs = {
  object: PatientTempTokensInsertInput;
  onConflict?: InputMaybe<PatientTempTokensOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRepartitionActivitePreferentiellePatientsArgs = {
  objects: Array<RepartitionActivitePreferentiellePatientsInsertInput>;
};


/** mutation root */
export type Mutation_RootInsertRepartitionActivitePreferentiellePatientsOneArgs = {
  object: RepartitionActivitePreferentiellePatientsInsertInput;
};


/** mutation root */
export type Mutation_RootUpdateActivitePreferentielleArgs = {
  _inc?: InputMaybe<ActivitePreferentielleIncInput>;
  _set?: InputMaybe<ActivitePreferentielleSetInput>;
  where: ActivitePreferentielleBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateActivitePreferentielleByPkArgs = {
  _inc?: InputMaybe<ActivitePreferentielleIncInput>;
  _set?: InputMaybe<ActivitePreferentielleSetInput>;
  pkColumns: ActivitePreferentiellePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateActivitePreferentielleManyArgs = {
  updates: Array<ActivitePreferentielleUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChirurgienArgs = {
  _set?: InputMaybe<ChirurgienSetInput>;
  where: ChirurgienBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChirurgienByPkArgs = {
  _set?: InputMaybe<ChirurgienSetInput>;
  pkColumns: ChirurgienPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChirurgienManyArgs = {
  updates: Array<ChirurgienUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChoixArgs = {
  _inc?: InputMaybe<ChoixIncInput>;
  _set?: InputMaybe<ChoixSetInput>;
  where: ChoixBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChoixByPkArgs = {
  _inc?: InputMaybe<ChoixIncInput>;
  _set?: InputMaybe<ChoixSetInput>;
  pkColumns: ChoixPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChoixManyArgs = {
  updates: Array<ChoixUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateFavorisArgs = {
  _set?: InputMaybe<FavorisSetInput>;
  where: FavorisBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateFavorisByPkArgs = {
  _set?: InputMaybe<FavorisSetInput>;
  pkColumns: FavorisPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateFavorisManyArgs = {
  updates: Array<FavorisUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateHabitudesArgs = {
  _set?: InputMaybe<HabitudesSetInput>;
  where: HabitudesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateHabitudesByPkArgs = {
  _set?: InputMaybe<HabitudesSetInput>;
  pkColumns: HabitudesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateHabitudesManyArgs = {
  updates: Array<HabitudesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateHelpTextsArgs = {
  _set?: InputMaybe<HelpTextsSetInput>;
  where: HelpTextsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateHelpTextsByPkArgs = {
  _set?: InputMaybe<HelpTextsSetInput>;
  pkColumns: HelpTextsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateHelpTextsManyArgs = {
  updates: Array<HelpTextsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateImplantArgs = {
  _inc?: InputMaybe<ImplantIncInput>;
  _set?: InputMaybe<ImplantSetInput>;
  where: ImplantBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateImplantByPkArgs = {
  _inc?: InputMaybe<ImplantIncInput>;
  _set?: InputMaybe<ImplantSetInput>;
  pkColumns: ImplantPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateImplantManyArgs = {
  updates: Array<ImplantUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateLaboratoireArgs = {
  _set?: InputMaybe<LaboratoireSetInput>;
  where: LaboratoireBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateLaboratoireByPkArgs = {
  _set?: InputMaybe<LaboratoireSetInput>;
  pkColumns: LaboratoirePkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateLaboratoireManyArgs = {
  updates: Array<LaboratoireUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOeilArgs = {
  _inc?: InputMaybe<OeilIncInput>;
  _set?: InputMaybe<OeilSetInput>;
  where: OeilBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOeilByPkArgs = {
  _inc?: InputMaybe<OeilIncInput>;
  _set?: InputMaybe<OeilSetInput>;
  pkColumns: OeilPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOeilManyArgs = {
  updates: Array<OeilUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateParametresArgs = {
  _set?: InputMaybe<ParametresSetInput>;
  where: ParametresBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateParametresByPkArgs = {
  _set?: InputMaybe<ParametresSetInput>;
  pkColumns: ParametresPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateParametresManyArgs = {
  updates: Array<ParametresUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePatientArgs = {
  _inc?: InputMaybe<PatientIncInput>;
  _set?: InputMaybe<PatientSetInput>;
  where: PatientBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePatientByPkArgs = {
  _inc?: InputMaybe<PatientIncInput>;
  _set?: InputMaybe<PatientSetInput>;
  pkColumns: PatientPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePatientManyArgs = {
  updates: Array<PatientUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePatientTempTokensArgs = {
  _append?: InputMaybe<PatientTempTokensAppendInput>;
  _deleteAtPath?: InputMaybe<PatientTempTokensDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PatientTempTokensDeleteElemInput>;
  _deleteKey?: InputMaybe<PatientTempTokensDeleteKeyInput>;
  _inc?: InputMaybe<PatientTempTokensIncInput>;
  _prepend?: InputMaybe<PatientTempTokensPrependInput>;
  _set?: InputMaybe<PatientTempTokensSetInput>;
  where: PatientTempTokensBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePatientTempTokensByPkArgs = {
  _append?: InputMaybe<PatientTempTokensAppendInput>;
  _deleteAtPath?: InputMaybe<PatientTempTokensDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PatientTempTokensDeleteElemInput>;
  _deleteKey?: InputMaybe<PatientTempTokensDeleteKeyInput>;
  _inc?: InputMaybe<PatientTempTokensIncInput>;
  _prepend?: InputMaybe<PatientTempTokensPrependInput>;
  _set?: InputMaybe<PatientTempTokensSetInput>;
  pkColumns: PatientTempTokensPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePatientTempTokensManyArgs = {
  updates: Array<PatientTempTokensUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRepartitionActivitePreferentiellePatientsArgs = {
  _inc?: InputMaybe<RepartitionActivitePreferentiellePatientsIncInput>;
  _set?: InputMaybe<RepartitionActivitePreferentiellePatientsSetInput>;
  where: RepartitionActivitePreferentiellePatientsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRepartitionActivitePreferentiellePatientsManyArgs = {
  updates: Array<RepartitionActivitePreferentiellePatientsUpdates>;
};

export type OeilAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<OeilSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OeilBoolExp>;
  predicate: IntComparisonExp;
};

export type PatientAggregateBoolExpBool_And = {
  arguments: PatientSelectColumnPatientAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PatientAggregateBoolExpBool_Or = {
  arguments: PatientSelectColumnPatientAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PatientAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PatientSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientBoolExp>;
  predicate: IntComparisonExp;
};

export type PatientTempTokensAggregateBoolExpBool_And = {
  arguments: PatientTempTokensSelectColumnPatientTempTokensAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientTempTokensBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PatientTempTokensAggregateBoolExpBool_Or = {
  arguments: PatientTempTokensSelectColumnPatientTempTokensAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientTempTokensBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PatientTempTokensAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PatientTempTokensBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "activitePreferentielle" */
  activitePreferentielle: Array<ActivitePreferentielle>;
  /** fetch aggregated fields from the table: "activitePreferentielle" */
  activitePreferentielleAggregate: ActivitePreferentielleAggregate;
  /** fetch data from the table: "activitePreferentielle" using primary key columns */
  activitePreferentielleByPk?: Maybe<ActivitePreferentielle>;
  /** fetch data from the table: "chirurgien" */
  chirurgien: Array<Chirurgien>;
  /** fetch aggregated fields from the table: "chirurgien" */
  chirurgienAggregate: ChirurgienAggregate;
  /** fetch data from the table: "chirurgien" using primary key columns */
  chirurgienByPk?: Maybe<Chirurgien>;
  /** fetch data from the table: "choix" */
  choix: Array<Choix>;
  /** fetch aggregated fields from the table: "choix" */
  choixAggregate: ChoixAggregate;
  /** fetch data from the table: "choix" using primary key columns */
  choixByPk?: Maybe<Choix>;
  /** fetch data from the table: "distribution_age_patients" */
  distributionAgePatients: Array<DistributionAgePatients>;
  /** fetch aggregated fields from the table: "distribution_age_patients" */
  distributionAgePatientsAggregate: DistributionAgePatientsAggregate;
  /** fetch data from the table: "evolution_chirurgiens" */
  evolutionChirurgiens: Array<EvolutionChirurgiens>;
  /** fetch aggregated fields from the table: "evolution_chirurgiens" */
  evolutionChirurgiensAggregate: EvolutionChirurgiensAggregate;
  /** An array relationship */
  favoris: Array<Favoris>;
  /** An aggregate relationship */
  favorisAggregate: FavorisAggregate;
  /** fetch data from the table: "favoris" using primary key columns */
  favorisByPk?: Maybe<Favoris>;
  /** execute function "get_distribution_age_patients" which returns "distribution_age_patients" */
  getDistributionAgePatients: Array<DistributionAgePatients>;
  /** execute function "get_distribution_age_patients" and query aggregates on result of table type "distribution_age_patients" */
  getDistributionAgePatientsAggregate: DistributionAgePatientsAggregate;
  /** execute function "get_moyenne_age_taille_patients" which returns "moyenne_age_taille_patients" */
  getMoyenneAgeTaillePatients: Array<MoyenneAgeTaillePatients>;
  /** execute function "get_moyenne_age_taille_patients" and query aggregates on result of table type "moyenne_age_taille_patients" */
  getMoyenneAgeTaillePatientsAggregate: MoyenneAgeTaillePatientsAggregate;
  /** execute function "get_patient_moyen_par_chirurgiens" which returns "patient_moyen_par_chirurgiens" */
  getPatientMoyenParChirurgiens: Array<PatientMoyenParChirurgiens>;
  /** execute function "get_patient_moyen_par_chirurgiens" and query aggregates on result of table type "patient_moyen_par_chirurgiens" */
  getPatientMoyenParChirurgiensAggregate: PatientMoyenParChirurgiensAggregate;
  /** execute function "get_repartition_activite_preferentielle_patients" which returns "repartition_activite_preferentielle_patients" */
  getRepartitionActivitePreferentiellePatients: Array<RepartitionActivitePreferentiellePatients>;
  /** execute function "get_repartition_activite_preferentielle_patients" and query aggregates on result of table type "repartition_activite_preferentielle_patients" */
  getRepartitionActivitePreferentiellePatientsAggregate: RepartitionActivitePreferentiellePatientsAggregate;
  /** execute function "get_repartition_implants" which returns "repartition_implants" */
  getRepartitionImplants: Array<RepartitionImplants>;
  /** execute function "get_repartition_implants" and query aggregates on result of table type "repartition_implants" */
  getRepartitionImplantsAggregate: RepartitionImplantsAggregate;
  /** execute function "get_repartition_sexes_patients" which returns "repartition_sexes_patients" */
  getRepartitionSexesPatients: Array<RepartitionSexesPatients>;
  /** execute function "get_repartition_sexes_patients" and query aggregates on result of table type "repartition_sexes_patients" */
  getRepartitionSexesPatientsAggregate: RepartitionSexesPatientsAggregate;
  /** execute function "get_repartition_vision_patients" which returns "repartition_vision_patients" */
  getRepartitionVisionPatients: Array<RepartitionVisionPatients>;
  /** execute function "get_repartition_vision_patients" and query aggregates on result of table type "repartition_vision_patients" */
  getRepartitionVisionPatientsAggregate: RepartitionVisionPatientsAggregate;
  /** An array relationship */
  habitudes: Array<Habitudes>;
  /** An aggregate relationship */
  habitudesAggregate: HabitudesAggregate;
  /** fetch data from the table: "habitudes" using primary key columns */
  habitudesByPk?: Maybe<Habitudes>;
  /** An array relationship */
  helpTexts: Array<HelpTexts>;
  /** An aggregate relationship */
  helpTextsAggregate: HelpTextsAggregate;
  /** fetch data from the table: "help_texts" using primary key columns */
  helpTextsByPk?: Maybe<HelpTexts>;
  /** fetch data from the table: "implant" */
  implant: Array<Implant>;
  /** fetch aggregated fields from the table: "implant" */
  implantAggregate: ImplantAggregate;
  /** fetch data from the table: "implant" using primary key columns */
  implantByPk?: Maybe<Implant>;
  /** fetch data from the table: "laboratoire" */
  laboratoire: Array<Laboratoire>;
  /** fetch aggregated fields from the table: "laboratoire" */
  laboratoireAggregate: LaboratoireAggregate;
  /** fetch data from the table: "laboratoire" using primary key columns */
  laboratoireByPk?: Maybe<Laboratoire>;
  /** fetch data from the table: "moyenne_age_taille_patients" */
  moyenneAgeTaillePatients: Array<MoyenneAgeTaillePatients>;
  /** fetch aggregated fields from the table: "moyenne_age_taille_patients" */
  moyenneAgeTaillePatientsAggregate: MoyenneAgeTaillePatientsAggregate;
  oeil: Array<Oeil>;
  oeilAggregate: OeilAggregate;
  oeilByPk?: Maybe<Oeil>;
  /** fetch data from the table: "parametres" */
  parametres: Array<Parametres>;
  /** fetch aggregated fields from the table: "parametres" */
  parametresAggregate: ParametresAggregate;
  /** fetch data from the table: "parametres" using primary key columns */
  parametresByPk?: Maybe<Parametres>;
  /** fetch data from the table: "patient" */
  patient: Array<Patient>;
  /** fetch aggregated fields from the table: "patient" */
  patientAggregate: PatientAggregate;
  /** fetch data from the table: "patient" using primary key columns */
  patientByPk?: Maybe<Patient>;
  /** fetch data from the table: "patient_moyen_par_chirurgiens" */
  patientMoyenParChirurgiens: Array<PatientMoyenParChirurgiens>;
  /** fetch aggregated fields from the table: "patient_moyen_par_chirurgiens" */
  patientMoyenParChirurgiensAggregate: PatientMoyenParChirurgiensAggregate;
  /** An array relationship */
  patientTempTokens: Array<PatientTempTokens>;
  /** An aggregate relationship */
  patientTempTokensAggregate: PatientTempTokensAggregate;
  /** fetch data from the table: "patient_temp_tokens" using primary key columns */
  patientTempTokensByPk?: Maybe<PatientTempTokens>;
  /** fetch data from the table: "repartition_activite_preferentielle_patients" */
  repartitionActivitePreferentiellePatients: Array<RepartitionActivitePreferentiellePatients>;
  /** fetch aggregated fields from the table: "repartition_activite_preferentielle_patients" */
  repartitionActivitePreferentiellePatientsAggregate: RepartitionActivitePreferentiellePatientsAggregate;
  /** fetch data from the table: "repartition_implants" */
  repartitionImplants: Array<RepartitionImplants>;
  /** fetch aggregated fields from the table: "repartition_implants" */
  repartitionImplantsAggregate: RepartitionImplantsAggregate;
  /** fetch data from the table: "repartition_sexes_patients" */
  repartitionSexesPatients: Array<RepartitionSexesPatients>;
  /** fetch aggregated fields from the table: "repartition_sexes_patients" */
  repartitionSexesPatientsAggregate: RepartitionSexesPatientsAggregate;
  /** fetch data from the table: "repartition_vision_patients" */
  repartitionVisionPatients: Array<RepartitionVisionPatients>;
  /** fetch aggregated fields from the table: "repartition_vision_patients" */
  repartitionVisionPatientsAggregate: RepartitionVisionPatientsAggregate;
};


export type Query_RootActivitePreferentielleArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


export type Query_RootActivitePreferentielleAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


export type Query_RootActivitePreferentielleByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChirurgienArgs = {
  distinctOn?: InputMaybe<Array<ChirurgienSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChirurgienOrderBy>>;
  where?: InputMaybe<ChirurgienBoolExp>;
};


export type Query_RootChirurgienAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChirurgienSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChirurgienOrderBy>>;
  where?: InputMaybe<ChirurgienBoolExp>;
};


export type Query_RootChirurgienByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChoixArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


export type Query_RootChoixAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


export type Query_RootChoixByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDistributionAgePatientsArgs = {
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Query_RootDistributionAgePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Query_RootEvolutionChirurgiensArgs = {
  distinctOn?: InputMaybe<Array<EvolutionChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvolutionChirurgiensOrderBy>>;
  where?: InputMaybe<EvolutionChirurgiensBoolExp>;
};


export type Query_RootEvolutionChirurgiensAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvolutionChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvolutionChirurgiensOrderBy>>;
  where?: InputMaybe<EvolutionChirurgiensBoolExp>;
};


export type Query_RootFavorisArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


export type Query_RootFavorisAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


export type Query_RootFavorisByPkArgs = {
  chirurgienId: Scalars['uuid']['input'];
  implantId: Scalars['uuid']['input'];
};


export type Query_RootGetDistributionAgePatientsArgs = {
  args?: InputMaybe<GetDistributionAgePatientsArgs>;
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Query_RootGetDistributionAgePatientsAggregateArgs = {
  args?: InputMaybe<GetDistributionAgePatientsArgs>;
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Query_RootGetMoyenneAgeTaillePatientsArgs = {
  args?: InputMaybe<GetMoyenneAgeTaillePatientsArgs>;
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Query_RootGetMoyenneAgeTaillePatientsAggregateArgs = {
  args?: InputMaybe<GetMoyenneAgeTaillePatientsArgs>;
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Query_RootGetPatientMoyenParChirurgiensArgs = {
  args?: InputMaybe<GetPatientMoyenParChirurgiensArgs>;
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Query_RootGetPatientMoyenParChirurgiensAggregateArgs = {
  args?: InputMaybe<GetPatientMoyenParChirurgiensArgs>;
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Query_RootGetRepartitionActivitePreferentiellePatientsArgs = {
  args?: InputMaybe<GetRepartitionActivitePreferentiellePatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Query_RootGetRepartitionActivitePreferentiellePatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionActivitePreferentiellePatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Query_RootGetRepartitionImplantsArgs = {
  args?: InputMaybe<GetRepartitionImplantsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Query_RootGetRepartitionImplantsAggregateArgs = {
  args?: InputMaybe<GetRepartitionImplantsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Query_RootGetRepartitionSexesPatientsArgs = {
  args?: InputMaybe<GetRepartitionSexesPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Query_RootGetRepartitionSexesPatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionSexesPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Query_RootGetRepartitionVisionPatientsArgs = {
  args?: InputMaybe<GetRepartitionVisionPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Query_RootGetRepartitionVisionPatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionVisionPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Query_RootHabitudesArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


export type Query_RootHabitudesAggregateArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


export type Query_RootHabitudesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHelpTextsArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


export type Query_RootHelpTextsAggregateArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


export type Query_RootHelpTextsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootImplantArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};


export type Query_RootImplantAggregateArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};


export type Query_RootImplantByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLaboratoireArgs = {
  distinctOn?: InputMaybe<Array<LaboratoireSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaboratoireOrderBy>>;
  where?: InputMaybe<LaboratoireBoolExp>;
};


export type Query_RootLaboratoireAggregateArgs = {
  distinctOn?: InputMaybe<Array<LaboratoireSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaboratoireOrderBy>>;
  where?: InputMaybe<LaboratoireBoolExp>;
};


export type Query_RootLaboratoireByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMoyenneAgeTaillePatientsArgs = {
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Query_RootMoyenneAgeTaillePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Query_RootOeilArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


export type Query_RootOeilAggregateArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


export type Query_RootOeilByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootParametresArgs = {
  distinctOn?: InputMaybe<Array<ParametresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParametresOrderBy>>;
  where?: InputMaybe<ParametresBoolExp>;
};


export type Query_RootParametresAggregateArgs = {
  distinctOn?: InputMaybe<Array<ParametresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParametresOrderBy>>;
  where?: InputMaybe<ParametresBoolExp>;
};


export type Query_RootParametresByPkArgs = {
  paramKey: Scalars['String']['input'];
};


export type Query_RootPatientArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};


export type Query_RootPatientAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};


export type Query_RootPatientByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPatientMoyenParChirurgiensArgs = {
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Query_RootPatientMoyenParChirurgiensAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Query_RootPatientTempTokensArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


export type Query_RootPatientTempTokensAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


export type Query_RootPatientTempTokensByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRepartitionActivitePreferentiellePatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Query_RootRepartitionActivitePreferentiellePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Query_RootRepartitionImplantsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Query_RootRepartitionImplantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Query_RootRepartitionSexesPatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Query_RootRepartitionSexesPatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Query_RootRepartitionVisionPatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Query_RootRepartitionVisionPatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "activitePreferentielle" */
  activitePreferentielle: Array<ActivitePreferentielle>;
  /** fetch aggregated fields from the table: "activitePreferentielle" */
  activitePreferentielleAggregate: ActivitePreferentielleAggregate;
  /** fetch data from the table: "activitePreferentielle" using primary key columns */
  activitePreferentielleByPk?: Maybe<ActivitePreferentielle>;
  /** fetch data from the table in a streaming manner: "activitePreferentielle" */
  activitePreferentielleStream: Array<ActivitePreferentielle>;
  /** fetch data from the table: "chirurgien" */
  chirurgien: Array<Chirurgien>;
  /** fetch aggregated fields from the table: "chirurgien" */
  chirurgienAggregate: ChirurgienAggregate;
  /** fetch data from the table: "chirurgien" using primary key columns */
  chirurgienByPk?: Maybe<Chirurgien>;
  /** fetch data from the table in a streaming manner: "chirurgien" */
  chirurgienStream: Array<Chirurgien>;
  /** fetch data from the table: "choix" */
  choix: Array<Choix>;
  /** fetch aggregated fields from the table: "choix" */
  choixAggregate: ChoixAggregate;
  /** fetch data from the table: "choix" using primary key columns */
  choixByPk?: Maybe<Choix>;
  /** fetch data from the table in a streaming manner: "choix" */
  choixStream: Array<Choix>;
  /** fetch data from the table: "distribution_age_patients" */
  distributionAgePatients: Array<DistributionAgePatients>;
  /** fetch aggregated fields from the table: "distribution_age_patients" */
  distributionAgePatientsAggregate: DistributionAgePatientsAggregate;
  /** fetch data from the table in a streaming manner: "distribution_age_patients" */
  distributionAgePatientsStream: Array<DistributionAgePatients>;
  /** fetch data from the table: "evolution_chirurgiens" */
  evolutionChirurgiens: Array<EvolutionChirurgiens>;
  /** fetch aggregated fields from the table: "evolution_chirurgiens" */
  evolutionChirurgiensAggregate: EvolutionChirurgiensAggregate;
  /** fetch data from the table in a streaming manner: "evolution_chirurgiens" */
  evolutionChirurgiensStream: Array<EvolutionChirurgiens>;
  /** An array relationship */
  favoris: Array<Favoris>;
  /** An aggregate relationship */
  favorisAggregate: FavorisAggregate;
  /** fetch data from the table: "favoris" using primary key columns */
  favorisByPk?: Maybe<Favoris>;
  /** fetch data from the table in a streaming manner: "favoris" */
  favorisStream: Array<Favoris>;
  /** execute function "get_distribution_age_patients" which returns "distribution_age_patients" */
  getDistributionAgePatients: Array<DistributionAgePatients>;
  /** execute function "get_distribution_age_patients" and query aggregates on result of table type "distribution_age_patients" */
  getDistributionAgePatientsAggregate: DistributionAgePatientsAggregate;
  /** execute function "get_moyenne_age_taille_patients" which returns "moyenne_age_taille_patients" */
  getMoyenneAgeTaillePatients: Array<MoyenneAgeTaillePatients>;
  /** execute function "get_moyenne_age_taille_patients" and query aggregates on result of table type "moyenne_age_taille_patients" */
  getMoyenneAgeTaillePatientsAggregate: MoyenneAgeTaillePatientsAggregate;
  /** execute function "get_patient_moyen_par_chirurgiens" which returns "patient_moyen_par_chirurgiens" */
  getPatientMoyenParChirurgiens: Array<PatientMoyenParChirurgiens>;
  /** execute function "get_patient_moyen_par_chirurgiens" and query aggregates on result of table type "patient_moyen_par_chirurgiens" */
  getPatientMoyenParChirurgiensAggregate: PatientMoyenParChirurgiensAggregate;
  /** execute function "get_repartition_activite_preferentielle_patients" which returns "repartition_activite_preferentielle_patients" */
  getRepartitionActivitePreferentiellePatients: Array<RepartitionActivitePreferentiellePatients>;
  /** execute function "get_repartition_activite_preferentielle_patients" and query aggregates on result of table type "repartition_activite_preferentielle_patients" */
  getRepartitionActivitePreferentiellePatientsAggregate: RepartitionActivitePreferentiellePatientsAggregate;
  /** execute function "get_repartition_implants" which returns "repartition_implants" */
  getRepartitionImplants: Array<RepartitionImplants>;
  /** execute function "get_repartition_implants" and query aggregates on result of table type "repartition_implants" */
  getRepartitionImplantsAggregate: RepartitionImplantsAggregate;
  /** execute function "get_repartition_sexes_patients" which returns "repartition_sexes_patients" */
  getRepartitionSexesPatients: Array<RepartitionSexesPatients>;
  /** execute function "get_repartition_sexes_patients" and query aggregates on result of table type "repartition_sexes_patients" */
  getRepartitionSexesPatientsAggregate: RepartitionSexesPatientsAggregate;
  /** execute function "get_repartition_vision_patients" which returns "repartition_vision_patients" */
  getRepartitionVisionPatients: Array<RepartitionVisionPatients>;
  /** execute function "get_repartition_vision_patients" and query aggregates on result of table type "repartition_vision_patients" */
  getRepartitionVisionPatientsAggregate: RepartitionVisionPatientsAggregate;
  /** An array relationship */
  habitudes: Array<Habitudes>;
  /** An aggregate relationship */
  habitudesAggregate: HabitudesAggregate;
  /** fetch data from the table: "habitudes" using primary key columns */
  habitudesByPk?: Maybe<Habitudes>;
  /** fetch data from the table in a streaming manner: "habitudes" */
  habitudesStream: Array<Habitudes>;
  /** An array relationship */
  helpTexts: Array<HelpTexts>;
  /** An aggregate relationship */
  helpTextsAggregate: HelpTextsAggregate;
  /** fetch data from the table: "help_texts" using primary key columns */
  helpTextsByPk?: Maybe<HelpTexts>;
  /** fetch data from the table in a streaming manner: "help_texts" */
  helpTextsStream: Array<HelpTexts>;
  /** fetch data from the table: "implant" */
  implant: Array<Implant>;
  /** fetch aggregated fields from the table: "implant" */
  implantAggregate: ImplantAggregate;
  /** fetch data from the table: "implant" using primary key columns */
  implantByPk?: Maybe<Implant>;
  /** fetch data from the table in a streaming manner: "implant" */
  implantStream: Array<Implant>;
  /** fetch data from the table: "laboratoire" */
  laboratoire: Array<Laboratoire>;
  /** fetch aggregated fields from the table: "laboratoire" */
  laboratoireAggregate: LaboratoireAggregate;
  /** fetch data from the table: "laboratoire" using primary key columns */
  laboratoireByPk?: Maybe<Laboratoire>;
  /** fetch data from the table in a streaming manner: "laboratoire" */
  laboratoireStream: Array<Laboratoire>;
  /** fetch data from the table: "moyenne_age_taille_patients" */
  moyenneAgeTaillePatients: Array<MoyenneAgeTaillePatients>;
  /** fetch aggregated fields from the table: "moyenne_age_taille_patients" */
  moyenneAgeTaillePatientsAggregate: MoyenneAgeTaillePatientsAggregate;
  /** fetch data from the table in a streaming manner: "moyenne_age_taille_patients" */
  moyenneAgeTaillePatientsStream: Array<MoyenneAgeTaillePatients>;
  oeil: Array<Oeil>;
  oeilAggregate: OeilAggregate;
  oeilByPk?: Maybe<Oeil>;
  /** fetch data from the table in a streaming manner: "oeil" */
  oeilStream: Array<Oeil>;
  /** fetch data from the table: "parametres" */
  parametres: Array<Parametres>;
  /** fetch aggregated fields from the table: "parametres" */
  parametresAggregate: ParametresAggregate;
  /** fetch data from the table: "parametres" using primary key columns */
  parametresByPk?: Maybe<Parametres>;
  /** fetch data from the table in a streaming manner: "parametres" */
  parametresStream: Array<Parametres>;
  /** fetch data from the table: "patient" */
  patient: Array<Patient>;
  /** fetch aggregated fields from the table: "patient" */
  patientAggregate: PatientAggregate;
  /** fetch data from the table: "patient" using primary key columns */
  patientByPk?: Maybe<Patient>;
  /** fetch data from the table: "patient_moyen_par_chirurgiens" */
  patientMoyenParChirurgiens: Array<PatientMoyenParChirurgiens>;
  /** fetch aggregated fields from the table: "patient_moyen_par_chirurgiens" */
  patientMoyenParChirurgiensAggregate: PatientMoyenParChirurgiensAggregate;
  /** fetch data from the table in a streaming manner: "patient_moyen_par_chirurgiens" */
  patientMoyenParChirurgiensStream: Array<PatientMoyenParChirurgiens>;
  /** fetch data from the table in a streaming manner: "patient" */
  patientStream: Array<Patient>;
  /** An array relationship */
  patientTempTokens: Array<PatientTempTokens>;
  /** An aggregate relationship */
  patientTempTokensAggregate: PatientTempTokensAggregate;
  /** fetch data from the table: "patient_temp_tokens" using primary key columns */
  patientTempTokensByPk?: Maybe<PatientTempTokens>;
  /** fetch data from the table in a streaming manner: "patient_temp_tokens" */
  patientTempTokensStream: Array<PatientTempTokens>;
  /** fetch data from the table: "repartition_activite_preferentielle_patients" */
  repartitionActivitePreferentiellePatients: Array<RepartitionActivitePreferentiellePatients>;
  /** fetch aggregated fields from the table: "repartition_activite_preferentielle_patients" */
  repartitionActivitePreferentiellePatientsAggregate: RepartitionActivitePreferentiellePatientsAggregate;
  /** fetch data from the table in a streaming manner: "repartition_activite_preferentielle_patients" */
  repartitionActivitePreferentiellePatientsStream: Array<RepartitionActivitePreferentiellePatients>;
  /** fetch data from the table: "repartition_implants" */
  repartitionImplants: Array<RepartitionImplants>;
  /** fetch aggregated fields from the table: "repartition_implants" */
  repartitionImplantsAggregate: RepartitionImplantsAggregate;
  /** fetch data from the table in a streaming manner: "repartition_implants" */
  repartitionImplantsStream: Array<RepartitionImplants>;
  /** fetch data from the table: "repartition_sexes_patients" */
  repartitionSexesPatients: Array<RepartitionSexesPatients>;
  /** fetch aggregated fields from the table: "repartition_sexes_patients" */
  repartitionSexesPatientsAggregate: RepartitionSexesPatientsAggregate;
  /** fetch data from the table in a streaming manner: "repartition_sexes_patients" */
  repartitionSexesPatientsStream: Array<RepartitionSexesPatients>;
  /** fetch data from the table: "repartition_vision_patients" */
  repartitionVisionPatients: Array<RepartitionVisionPatients>;
  /** fetch aggregated fields from the table: "repartition_vision_patients" */
  repartitionVisionPatientsAggregate: RepartitionVisionPatientsAggregate;
  /** fetch data from the table in a streaming manner: "repartition_vision_patients" */
  repartitionVisionPatientsStream: Array<RepartitionVisionPatients>;
};


export type Subscription_RootActivitePreferentielleArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


export type Subscription_RootActivitePreferentielleAggregateArgs = {
  distinctOn?: InputMaybe<Array<ActivitePreferentielleSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActivitePreferentielleOrderBy>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


export type Subscription_RootActivitePreferentielleByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivitePreferentielleStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivitePreferentielleStreamCursorInput>>;
  where?: InputMaybe<ActivitePreferentielleBoolExp>;
};


export type Subscription_RootChirurgienArgs = {
  distinctOn?: InputMaybe<Array<ChirurgienSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChirurgienOrderBy>>;
  where?: InputMaybe<ChirurgienBoolExp>;
};


export type Subscription_RootChirurgienAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChirurgienSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChirurgienOrderBy>>;
  where?: InputMaybe<ChirurgienBoolExp>;
};


export type Subscription_RootChirurgienByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChirurgienStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChirurgienStreamCursorInput>>;
  where?: InputMaybe<ChirurgienBoolExp>;
};


export type Subscription_RootChoixArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


export type Subscription_RootChoixAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChoixSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChoixOrderBy>>;
  where?: InputMaybe<ChoixBoolExp>;
};


export type Subscription_RootChoixByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChoixStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChoixStreamCursorInput>>;
  where?: InputMaybe<ChoixBoolExp>;
};


export type Subscription_RootDistributionAgePatientsArgs = {
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Subscription_RootDistributionAgePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Subscription_RootDistributionAgePatientsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DistributionAgePatientsStreamCursorInput>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Subscription_RootEvolutionChirurgiensArgs = {
  distinctOn?: InputMaybe<Array<EvolutionChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvolutionChirurgiensOrderBy>>;
  where?: InputMaybe<EvolutionChirurgiensBoolExp>;
};


export type Subscription_RootEvolutionChirurgiensAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvolutionChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvolutionChirurgiensOrderBy>>;
  where?: InputMaybe<EvolutionChirurgiensBoolExp>;
};


export type Subscription_RootEvolutionChirurgiensStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvolutionChirurgiensStreamCursorInput>>;
  where?: InputMaybe<EvolutionChirurgiensBoolExp>;
};


export type Subscription_RootFavorisArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


export type Subscription_RootFavorisAggregateArgs = {
  distinctOn?: InputMaybe<Array<FavorisSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FavorisOrderBy>>;
  where?: InputMaybe<FavorisBoolExp>;
};


export type Subscription_RootFavorisByPkArgs = {
  chirurgienId: Scalars['uuid']['input'];
  implantId: Scalars['uuid']['input'];
};


export type Subscription_RootFavorisStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FavorisStreamCursorInput>>;
  where?: InputMaybe<FavorisBoolExp>;
};


export type Subscription_RootGetDistributionAgePatientsArgs = {
  args?: InputMaybe<GetDistributionAgePatientsArgs>;
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Subscription_RootGetDistributionAgePatientsAggregateArgs = {
  args?: InputMaybe<GetDistributionAgePatientsArgs>;
  distinctOn?: InputMaybe<Array<DistributionAgePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DistributionAgePatientsOrderBy>>;
  where?: InputMaybe<DistributionAgePatientsBoolExp>;
};


export type Subscription_RootGetMoyenneAgeTaillePatientsArgs = {
  args?: InputMaybe<GetMoyenneAgeTaillePatientsArgs>;
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Subscription_RootGetMoyenneAgeTaillePatientsAggregateArgs = {
  args?: InputMaybe<GetMoyenneAgeTaillePatientsArgs>;
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Subscription_RootGetPatientMoyenParChirurgiensArgs = {
  args?: InputMaybe<GetPatientMoyenParChirurgiensArgs>;
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Subscription_RootGetPatientMoyenParChirurgiensAggregateArgs = {
  args?: InputMaybe<GetPatientMoyenParChirurgiensArgs>;
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Subscription_RootGetRepartitionActivitePreferentiellePatientsArgs = {
  args?: InputMaybe<GetRepartitionActivitePreferentiellePatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Subscription_RootGetRepartitionActivitePreferentiellePatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionActivitePreferentiellePatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Subscription_RootGetRepartitionImplantsArgs = {
  args?: InputMaybe<GetRepartitionImplantsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Subscription_RootGetRepartitionImplantsAggregateArgs = {
  args?: InputMaybe<GetRepartitionImplantsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Subscription_RootGetRepartitionSexesPatientsArgs = {
  args?: InputMaybe<GetRepartitionSexesPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Subscription_RootGetRepartitionSexesPatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionSexesPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Subscription_RootGetRepartitionVisionPatientsArgs = {
  args?: InputMaybe<GetRepartitionVisionPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Subscription_RootGetRepartitionVisionPatientsAggregateArgs = {
  args?: InputMaybe<GetRepartitionVisionPatientsArgs>;
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Subscription_RootHabitudesArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


export type Subscription_RootHabitudesAggregateArgs = {
  distinctOn?: InputMaybe<Array<HabitudesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HabitudesOrderBy>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


export type Subscription_RootHabitudesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHabitudesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<HabitudesStreamCursorInput>>;
  where?: InputMaybe<HabitudesBoolExp>;
};


export type Subscription_RootHelpTextsArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


export type Subscription_RootHelpTextsAggregateArgs = {
  distinctOn?: InputMaybe<Array<HelpTextsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HelpTextsOrderBy>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


export type Subscription_RootHelpTextsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootHelpTextsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<HelpTextsStreamCursorInput>>;
  where?: InputMaybe<HelpTextsBoolExp>;
};


export type Subscription_RootImplantArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};


export type Subscription_RootImplantAggregateArgs = {
  distinctOn?: InputMaybe<Array<ImplantSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ImplantOrderBy>>;
  where?: InputMaybe<ImplantBoolExp>;
};


export type Subscription_RootImplantByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootImplantStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ImplantStreamCursorInput>>;
  where?: InputMaybe<ImplantBoolExp>;
};


export type Subscription_RootLaboratoireArgs = {
  distinctOn?: InputMaybe<Array<LaboratoireSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaboratoireOrderBy>>;
  where?: InputMaybe<LaboratoireBoolExp>;
};


export type Subscription_RootLaboratoireAggregateArgs = {
  distinctOn?: InputMaybe<Array<LaboratoireSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LaboratoireOrderBy>>;
  where?: InputMaybe<LaboratoireBoolExp>;
};


export type Subscription_RootLaboratoireByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLaboratoireStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<LaboratoireStreamCursorInput>>;
  where?: InputMaybe<LaboratoireBoolExp>;
};


export type Subscription_RootMoyenneAgeTaillePatientsArgs = {
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Subscription_RootMoyenneAgeTaillePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<MoyenneAgeTaillePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MoyenneAgeTaillePatientsOrderBy>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Subscription_RootMoyenneAgeTaillePatientsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MoyenneAgeTaillePatientsStreamCursorInput>>;
  where?: InputMaybe<MoyenneAgeTaillePatientsBoolExp>;
};


export type Subscription_RootOeilArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


export type Subscription_RootOeilAggregateArgs = {
  distinctOn?: InputMaybe<Array<OeilSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OeilOrderBy>>;
  where?: InputMaybe<OeilBoolExp>;
};


export type Subscription_RootOeilByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOeilStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OeilStreamCursorInput>>;
  where?: InputMaybe<OeilBoolExp>;
};


export type Subscription_RootParametresArgs = {
  distinctOn?: InputMaybe<Array<ParametresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParametresOrderBy>>;
  where?: InputMaybe<ParametresBoolExp>;
};


export type Subscription_RootParametresAggregateArgs = {
  distinctOn?: InputMaybe<Array<ParametresSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ParametresOrderBy>>;
  where?: InputMaybe<ParametresBoolExp>;
};


export type Subscription_RootParametresByPkArgs = {
  paramKey: Scalars['String']['input'];
};


export type Subscription_RootParametresStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ParametresStreamCursorInput>>;
  where?: InputMaybe<ParametresBoolExp>;
};


export type Subscription_RootPatientArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};


export type Subscription_RootPatientAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy>>;
  where?: InputMaybe<PatientBoolExp>;
};


export type Subscription_RootPatientByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPatientMoyenParChirurgiensArgs = {
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Subscription_RootPatientMoyenParChirurgiensAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientMoyenParChirurgiensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientMoyenParChirurgiensOrderBy>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Subscription_RootPatientMoyenParChirurgiensStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PatientMoyenParChirurgiensStreamCursorInput>>;
  where?: InputMaybe<PatientMoyenParChirurgiensBoolExp>;
};


export type Subscription_RootPatientStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PatientStreamCursorInput>>;
  where?: InputMaybe<PatientBoolExp>;
};


export type Subscription_RootPatientTempTokensArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


export type Subscription_RootPatientTempTokensAggregateArgs = {
  distinctOn?: InputMaybe<Array<PatientTempTokensSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientTempTokensOrderBy>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


export type Subscription_RootPatientTempTokensByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPatientTempTokensStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PatientTempTokensStreamCursorInput>>;
  where?: InputMaybe<PatientTempTokensBoolExp>;
};


export type Subscription_RootRepartitionActivitePreferentiellePatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Subscription_RootRepartitionActivitePreferentiellePatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionActivitePreferentiellePatientsOrderBy>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Subscription_RootRepartitionActivitePreferentiellePatientsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RepartitionActivitePreferentiellePatientsStreamCursorInput>>;
  where?: InputMaybe<RepartitionActivitePreferentiellePatientsBoolExp>;
};


export type Subscription_RootRepartitionImplantsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Subscription_RootRepartitionImplantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionImplantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionImplantsOrderBy>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Subscription_RootRepartitionImplantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RepartitionImplantsStreamCursorInput>>;
  where?: InputMaybe<RepartitionImplantsBoolExp>;
};


export type Subscription_RootRepartitionSexesPatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Subscription_RootRepartitionSexesPatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionSexesPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionSexesPatientsOrderBy>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Subscription_RootRepartitionSexesPatientsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RepartitionSexesPatientsStreamCursorInput>>;
  where?: InputMaybe<RepartitionSexesPatientsBoolExp>;
};


export type Subscription_RootRepartitionVisionPatientsArgs = {
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Subscription_RootRepartitionVisionPatientsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RepartitionVisionPatientsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RepartitionVisionPatientsOrderBy>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};


export type Subscription_RootRepartitionVisionPatientsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RepartitionVisionPatientsStreamCursorInput>>;
  where?: InputMaybe<RepartitionVisionPatientsBoolExp>;
};

export type DeleteActivitePreferentielleByPatientMutationVariables = Exact<{
  patientId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteActivitePreferentielleByPatientMutation = { __typename?: 'mutation_root', deleteActivitePreferentielle?: { __typename?: 'ActivitePreferentielleMutationResponse', affectedRows: number } | null };

export type InsertActivitePreferentielleMutationVariables = Exact<{
  object?: InputMaybe<ActivitePreferentielleInsertInput>;
}>;


export type InsertActivitePreferentielleMutation = { __typename?: 'mutation_root', insertActivitePreferentielleOne?: { __typename?: 'ActivitePreferentielle', id: any } | null };

export type DeleteChirurgienMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteChirurgienMutation = { __typename?: 'mutation_root', deleteChirurgienByPk?: { __typename?: 'Chirurgien', id: any } | null };

export type UpdateChirurgienMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<ChirurgienSetInput>;
}>;


export type UpdateChirurgienMutation = { __typename?: 'mutation_root', updateChirurgienByPk?: { __typename?: 'Chirurgien', id: any, nom: string, prenom: string, clinique?: string | null, adresse?: string | null, codePostal?: string | null, ville?: string | null, logo?: string | null, titreFr: string, titreEn: string } | null };

export type InsertChoixMutationVariables = Exact<{
  objects?: InputMaybe<Array<ChoixInsertInput> | ChoixInsertInput>;
}>;


export type InsertChoixMutation = { __typename?: 'mutation_root', insertChoix?: { __typename?: 'ChoixMutationResponse', affectedRows: number } | null };

export type DeleteFavorisMutationVariables = Exact<{
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
  implantId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteFavorisMutation = { __typename?: 'mutation_root', deleteFavorisByPk?: { __typename?: 'Favoris', implantId: any, chirurgienId: any } | null };

export type InsertFavorisMutationVariables = Exact<{
  object?: InputMaybe<FavorisInsertInput>;
}>;


export type InsertFavorisMutation = { __typename?: 'mutation_root', insertFavorisOne?: { __typename?: 'Favoris', implantId: any, chirurgienId: any } | null };

export type InsertHabitudesMutationVariables = Exact<{
  object?: InputMaybe<HabitudesInsertInput>;
}>;


export type InsertHabitudesMutation = { __typename?: 'mutation_root', insertHabitudesOne?: { __typename?: 'Habitudes', id: any } | null };

export type DeleteHelpTextMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteHelpTextMutation = { __typename?: 'mutation_root', deleteHelpTextsByPk?: { __typename?: 'HelpTexts', id: any } | null };

export type UpdateHelpTextMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  textFr: Scalars['String']['input'];
  textEn?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateHelpTextMutation = { __typename?: 'mutation_root', updateHelpTextsByPk?: { __typename?: 'HelpTexts', id: any, fieldName: string, textFr: string, textEn: string, isDefault?: boolean | null, updatedAt?: any | null } | null };

export type UpsertHelpTextMutationVariables = Exact<{
  object: HelpTextsInsertInput;
}>;


export type UpsertHelpTextMutation = { __typename?: 'mutation_root', insertHelpTextsOne?: { __typename?: 'HelpTexts', id: any, fieldName: string, textFr: string, textEn: string, isDefault?: boolean | null, updatedAt?: any | null } | null };

export type DeleteImplantMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteImplantMutation = { __typename?: 'mutation_root', deleteImplantByPk?: { __typename?: 'Implant', id: any } | null };

export type InsertImplantMutationVariables = Exact<{
  object?: InputMaybe<ImplantInsertInput>;
}>;


export type InsertImplantMutation = { __typename?: 'mutation_root', insertImplantOne?: { __typename?: 'Implant', id: any, name: string } | null };

export type UpdateImplantMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<ImplantSetInput>;
}>;


export type UpdateImplantMutation = { __typename?: 'mutation_root', updateImplantByPk?: { __typename?: 'Implant', id: any, name: string } | null };

export type DeleteLaboratoireMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeleteLaboratoireMutation = { __typename?: 'mutation_root', deleteLaboratoireByPk?: { __typename?: 'Laboratoire', id: any } | null };

export type InsertLaboratoireMutationVariables = Exact<{
  nom?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertLaboratoireMutation = { __typename?: 'mutation_root', insertLaboratoireOne?: { __typename?: 'Laboratoire', id: any, nom?: string | null } | null };

export type UpdateLaboratoireMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<LaboratoireSetInput>;
}>;


export type UpdateLaboratoireMutation = { __typename?: 'mutation_root', updateLaboratoireByPk?: { __typename?: 'Laboratoire', id: any, nom?: string | null } | null };

export type InsertOeilMutationVariables = Exact<{
  object?: InputMaybe<OeilInsertInput>;
}>;


export type InsertOeilMutation = { __typename?: 'mutation_root', insertOeilOne?: { __typename?: 'Oeil', id: any } | null };

export type UpdateParametresMutationVariables = Exact<{
  objects?: InputMaybe<Array<ParametresInsertInput> | ParametresInsertInput>;
}>;


export type UpdateParametresMutation = { __typename?: 'mutation_root', insertParametres?: { __typename?: 'ParametresMutationResponse', affectedRows: number } | null };

export type FinalizePatientFormMutationVariables = Exact<{
  patientId: Scalars['uuid']['input'];
  patientData: PatientSetInput;
  habitudesData: HabitudesInsertInput;
  activitesPreferentielles: Array<ActivitePreferentielleInsertInput> | ActivitePreferentielleInsertInput;
  tokenId: Scalars['uuid']['input'];
}>;


export type FinalizePatientFormMutation = { __typename?: 'mutation_root', updatePatientByPk?: { __typename?: 'Patient', id: any, nom: string, prenom: string, sexe?: any | null, birthday?: any | null, size?: any | null, photicEffect?: boolean | null, glasses?: boolean | null, updatedAt?: any | null } | null, insertHabitudesOne?: { __typename?: 'Habitudes', id: any, patientId: any } | null, deleteActivitePreferentielle?: { __typename?: 'ActivitePreferentielleMutationResponse', affectedRows: number } | null, insertActivitePreferentielle?: { __typename?: 'ActivitePreferentielleMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'ActivitePreferentielle', id: any, nom: string, distanceMin: any, distanceMax: any }> } | null, updatePatientTempTokensByPk?: { __typename?: 'PatientTempTokens', id: any, isUsed?: boolean | null, usedAt?: any | null } | null };

export type GeneratePatientTokenWithExpiryMutationVariables = Exact<{
  patientId: Scalars['uuid']['input'];
  expiresAt: Scalars['timestamptz']['input'];
}>;


export type GeneratePatientTokenWithExpiryMutation = { __typename?: 'mutation_root', insertPatientTempTokensOne?: { __typename?: 'PatientTempTokens', id: any, token: string, expiresAt: any } | null };

export type UpdatePatientFormDataMutationVariables = Exact<{
  token: Scalars['String']['input'];
  formData: Scalars['jsonb']['input'];
}>;


export type UpdatePatientFormDataMutation = { __typename?: 'mutation_root', updatePatientTempTokens?: { __typename?: 'PatientTempTokensMutationResponse', affectedRows: number, returning: Array<{ __typename?: 'PatientTempTokens', id: any, formData?: any | null, lastSavedAt?: any | null, accessCount?: number | null, expiresAt: any, patientId: any }> } | null };

export type ArchivePatientMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  isArchived: Scalars['Boolean']['input'];
}>;


export type ArchivePatientMutation = { __typename?: 'mutation_root', updatePatientByPk?: { __typename?: 'Patient', id: any, isArchived?: boolean | null } | null };

export type DeletePatientMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DeletePatientMutation = { __typename?: 'mutation_root', deletePatientByPk?: { __typename?: 'Patient', id: any } | null };

export type InsertPatientMutationVariables = Exact<{
  nom?: InputMaybe<Scalars['String']['input']>;
  prenom?: InputMaybe<Scalars['String']['input']>;
  birthday?: InputMaybe<Scalars['timestamptz']['input']>;
  chirurgienId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertPatientMutation = { __typename?: 'mutation_root', insertPatientOne?: { __typename?: 'Patient', birthday?: any | null, id: any, nom: string, prenom: string, chirurgienId: any, createdAt?: any | null, updatedAt?: any | null } | null };

export type UpdatePatientMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  data?: InputMaybe<PatientSetInput>;
}>;


export type UpdatePatientMutation = { __typename?: 'mutation_root', updatePatientByPk?: { __typename?: 'Patient', id: any, nom: string, prenom: string, birthday?: any | null, updatedAt?: any | null } | null };

export type UpdatePatientEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['String']['input'];
}>;


export type UpdatePatientEmailMutation = { __typename?: 'mutation_root', updatePatientByPk?: { __typename?: 'Patient', id: any, email?: string | null } | null };

export type GetChirurgienQueryVariables = Exact<{
  cognitoToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChirurgienQuery = { __typename?: 'query_root', chirurgien: Array<{ __typename?: 'Chirurgien', id: any, nom: string, prenom: string, cognitoToken: string, codePostal?: string | null, clinique?: string | null, adresse?: string | null, logo?: string | null, ville?: string | null, titreFr: string, titreEn: string }> };

export type ListChirurgiensQueryVariables = Exact<{ [key: string]: never; }>;


export type ListChirurgiensQuery = { __typename?: 'query_root', chirurgien: Array<{ __typename?: 'Chirurgien', id: any, nom: string, prenom: string, cognitoToken: string, codePostal?: string | null, clinique?: string | null, adresse?: string | null, logo?: string | null, ville?: string | null, titreFr: string, titreEn: string }> };

export type GetHelpTextByFieldQueryVariables = Exact<{
  fieldName: Scalars['String']['input'];
}>;


export type GetHelpTextByFieldQuery = { __typename?: 'query_root', helpTexts: Array<{ __typename?: 'HelpTexts', id: any, textFr: string, textEn: string, isDefault?: boolean | null }> };

export type GetHelpTextsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHelpTextsQuery = { __typename?: 'query_root', helpTexts: Array<{ __typename?: 'HelpTexts', id: any, fieldName: string, category?: string | null, textFr: string, textEn: string, isDefault?: boolean | null, chirurgienId?: any | null, updatedAt?: any | null }> };

export type GetImplantsQueryVariables = Exact<{
  implantsList?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetImplantsQuery = { __typename?: 'query_root', implant: Array<{ __typename?: 'Implant', id: any, laboratoireId: any, name: string, correctionOptique: string, data: any, display: string, materiau: string, mb: string, methodology?: string | null, n?: any | null, note?: string | null, type: string, laboratoire: { __typename?: 'Laboratoire', id: any, nom?: string | null }, favoris: Array<{ __typename?: 'Favoris', chirurgienId: any }> }> };

export type ListImplantsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ImplantOrderBy> | ImplantOrderBy>;
  where?: InputMaybe<ImplantBoolExp>;
}>;


export type ListImplantsQuery = { __typename?: 'query_root', implant: Array<{ __typename?: 'Implant', id: any, name: string, laboratoire: { __typename?: 'Laboratoire', id: any, nom?: string | null }, favoris: Array<{ __typename?: 'Favoris', chirurgienId: any }> }>, laboratoire: Array<{ __typename?: 'Laboratoire', id: any, nom?: string | null }> };

export type GetLaboratoireQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetLaboratoireQuery = { __typename?: 'query_root', laboratoireByPk?: { __typename?: 'Laboratoire', nom?: string | null } | null };

export type ListLaboratoiresQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LaboratoireOrderBy> | LaboratoireOrderBy>;
  where?: InputMaybe<LaboratoireBoolExp>;
}>;


export type ListLaboratoiresQuery = { __typename?: 'query_root', laboratoire: Array<{ __typename?: 'Laboratoire', id: any, nom?: string | null, label?: string | null, value: any }> };

export type GetParametresQueryVariables = Exact<{
  keyList?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetParametresQuery = { __typename?: 'query_root', parametres: Array<{ __typename?: 'Parametres', paramKey: string, paramValue?: string | null }> };

export type GetExpiredTokenInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetExpiredTokenInfoQuery = { __typename?: 'query_root', patientTempTokens: Array<{ __typename?: 'PatientTempTokens', id: any, patientId: any, token: string, expiresAt: any, isUsed?: boolean | null, usedAt?: any | null, createdAt?: any | null, patient_tokens: { __typename?: 'Patient', id: any, nom: string, prenom: string, email?: string | null, telephone?: string | null, chirurgien: { __typename?: 'Chirurgien', id: any, nom: string, prenom: string, clinique?: string | null, cognitoToken: string } } }> };

export type GetPatientFormDataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetPatientFormDataQuery = { __typename?: 'query_root', patientTempTokens: Array<{ __typename?: 'PatientTempTokens', id: any, patientId: any, token: string, expiresAt: any, formData?: any | null, lastSavedAt?: any | null, accessCount?: number | null, createdAt?: any | null, isUsed?: boolean | null, usedAt?: any | null, patient_tokens: { __typename?: 'Patient', id: any, nom: string, prenom: string, email?: string | null, telephone?: string | null, sexe?: any | null, size?: any | null, birthday?: any | null, photicEffect?: boolean | null, glasses?: boolean | null, habitudes: Array<{ __typename?: 'Habitudes', id: any, patientId: any, heureReveil?: any | null, heureCoucher?: any | null, tempsLecture?: any | null, tempsOrdinateur?: any | null, tempsSmartphone?: any | null, tempsTablette?: any | null, tempsTelevision?: any | null, tempsConduite?: any | null, tempsCuisine?: any | null, tempsDiscussion?: any | null, tempsJeuxSociete?: any | null, tempsAutreVisionPres?: any | null, tempsSieste?: any | null }>, activitePreferentielles: Array<{ __typename?: 'ActivitePreferentielle', id: any, patientId: any, nom: string, distanceMin: any, distanceMax: any }> } }> };

export type ListPatientsWithStatusQueryVariables = Exact<{
  distinctOn?: InputMaybe<Array<PatientSelectColumn> | PatientSelectColumn>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PatientOrderBy> | PatientOrderBy>;
  where?: InputMaybe<PatientBoolExp>;
}>;


export type ListPatientsWithStatusQuery = { __typename?: 'query_root', patient: Array<{ __typename?: 'Patient', id: any, nom: string, prenom: string, birthday?: any | null, createdAt?: any | null, updatedAt?: any | null, isArchived?: boolean | null, oeils: Array<{ __typename?: 'Oeil', id: any, choixes: Array<{ __typename?: 'Choix', id: any, final?: boolean | null }> }> }> };

export type GetPatientQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetPatientQuery = { __typename?: 'query_root', patientByPk?: { __typename?: 'Patient', birthday?: any | null, chirurgienId: any, glasses?: boolean | null, sameValue?: any | null, createdAt?: any | null, updatedAt?: any | null, etatControlateral?: any | null, monovision?: boolean | null, nom: string, oeilDominant?: string | null, photicEffect?: boolean | null, prenom: string, sexe?: any | null, size?: any | null, lunettesVL?: boolean | null, lunettesVI?: boolean | null, lunettesVP?: boolean | null, sameImplant?: boolean | null, activitePreferentielles: Array<{ __typename?: 'ActivitePreferentielle', distanceMax: any, distanceMin: any, id: any, nom: string }>, habitudes: Array<{ __typename?: 'Habitudes', heureCoucher?: any | null, heureReveil?: any | null, id: any, tempsAutreVisionPres?: any | null, tempsConduite?: any | null, tempsCuisine?: any | null, tempsDiscussion?: any | null, tempsJeuxSociete?: any | null, tempsLecture?: any | null, tempsOrdinateur?: any | null, tempsSieste?: any | null, tempsSmartphone?: any | null, tempsTablette?: any | null, tempsTelevision?: any | null }>, oeils: Array<{ __typename?: 'Oeil', aberrationOrdreEleve?: string | null, aberrationSpherique?: string | null, antecedantChirurgie?: string | null, bump?: string | null, diametrePupillaire?: string | null, endothelium?: string | null, id: any, larmes?: string | null, longueurAxiale?: string | null, retineNerfOptique?: string | null, side: string, aOperer?: string | null, antecedantChirurgieCristallin?: string | null, typeImplantActuel?: string | null, ajoutAddon?: any | null, genererCourbeTypeImplant?: string | null, courbeDefocus?: any | null, implantCourantId?: any | null, choixes: Array<{ __typename?: 'Choix', implantId?: any | null, decalage: any, decalageCourbeExistante: any, affichageDefocus?: any | null, type?: string | null, materiau?: string | null, final?: boolean | null, laboratoireId?: any | null, implant?: { __typename?: 'Implant', correctionOptique: string, data: any, display: string, id: any, materiau: string, mb: string, methodology?: string | null, n?: any | null, name: string, note?: string | null, type: string, laboratoire: { __typename?: 'Laboratoire', nom?: string | null, id: any } } | null }>, implantCourant?: { __typename?: 'Implant', correctionOptique: string, data: any, display: string, id: any, materiau: string, mb: string, methodology?: string | null, n?: any | null, name: string, note?: string | null, type: string, laboratoire: { __typename?: 'Laboratoire', nom?: string | null, id: any } } | null }> } | null };

export type GetPatientForLinkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPatientForLinkQuery = { __typename?: 'query_root', patientByPk?: { __typename?: 'Patient', id: any, nom: string, prenom: string, email?: string | null, birthday?: any | null, sexe?: any | null, chirurgien: { __typename?: 'Chirurgien', nom: string, prenom: string } } | null };

export type ListPatientsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<PatientOrderBy> | PatientOrderBy>;
  where?: InputMaybe<PatientBoolExp>;
}>;


export type ListPatientsQuery = { __typename?: 'query_root', patient: Array<{ __typename?: 'Patient', id: any, nom: string, prenom: string, birthday?: any | null, sexe?: any | null, createdAt?: any | null, updatedAt?: any | null }> };

export type StatsParChirurgienQueryVariables = Exact<{
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
  where?: InputMaybe<PatientBoolExp>;
  sexe_param?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StatsParChirurgienQuery = { __typename?: 'query_root', getRepartitionImplants: Array<{ __typename?: 'RepartitionImplants', materiau?: string | null, nombreImplants?: any | null, pourcentage?: any | null, type?: string | null }>, getMoyenneAgeTaillePatients: Array<{ __typename?: 'MoyenneAgeTaillePatients', ageMoyen?: any | null, tailleMoyenne?: any | null }>, getDistributionAgePatients: Array<{ __typename?: 'DistributionAgePatients', trancheAge?: string | null, nombrePatients?: any | null, hommes?: any | null, femmes?: any | null, nonPrecises?: any | null }>, getRepartitionSexesPatients: Array<{ __typename?: 'RepartitionSexesPatients', nombre?: any | null, pourcentage?: any | null, sexe?: any | null }>, patientAggregate: { __typename?: 'PatientAggregate', aggregate?: { __typename?: 'PatientAggregateFields', count: number } | null }, getRepartitionVisionPatients: Array<{ __typename?: 'RepartitionVisionPatients', pourcentageVi?: any | null, pourcentageVl?: any | null, pourcentageVp?: any | null }>, getRepartitionActivitePreferentiellePatients: Array<{ __typename?: 'RepartitionActivitePreferentiellePatients', nombrePersonnes?: number | null, logmarValue?: any | null }> };

export type StatsUtilisationQueryVariables = Exact<{
  chirurgien_id_param?: InputMaybe<Scalars['_uuid']['input']>;
}>;


export type StatsUtilisationQuery = { __typename?: 'query_root', evolutionChirurgiens: Array<{ __typename?: 'EvolutionChirurgiens', mois?: any | null, nombreChirurgiens?: any | null }>, getPatientMoyenParChirurgiens: Array<{ __typename?: 'PatientMoyenParChirurgiens', mois?: any | null, nombrePatients?: any | null, recrutementMoyenParChirurgien?: any | null }>, chirurgienAggregate: { __typename?: 'ChirurgienAggregate', aggregate?: { __typename?: 'ChirurgienAggregateFields', count: number } | null } };

export type SubImplantsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type SubImplantsSubscription = { __typename?: 'subscription_root', implant: Array<{ __typename?: 'Implant', id: any, type: string, materiau: string, name: string, laboratoire: { __typename?: 'Laboratoire', id: any, nom?: string | null }, favoris: Array<{ __typename?: 'Favoris', chirurgienId: any }> }> };

export type SubPatientSubscriptionVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SubPatientSubscription = { __typename?: 'subscription_root', patientByPk?: { __typename?: 'Patient', birthday?: any | null, chirurgienId: any, glasses?: boolean | null, sameValue?: any | null, createdAt?: any | null, etatControlateral?: any | null, monovision?: boolean | null, nom: string, oeilDominant?: string | null, photicEffect?: boolean | null, prenom: string, sexe?: any | null, size?: any | null, lunettesVL?: boolean | null, lunettesVI?: boolean | null, lunettesVP?: boolean | null, sameImplant?: boolean | null, activitePreferentielles: Array<{ __typename?: 'ActivitePreferentielle', distanceMax: any, distanceMin: any, id: any, nom: string }>, habitudes: Array<{ __typename?: 'Habitudes', heureCoucher?: any | null, heureReveil?: any | null, id: any, tempsAutreVisionPres?: any | null, tempsConduite?: any | null, tempsCuisine?: any | null, tempsDiscussion?: any | null, tempsJeuxSociete?: any | null, tempsLecture?: any | null, tempsOrdinateur?: any | null, tempsSieste?: any | null, tempsSmartphone?: any | null, tempsTablette?: any | null, tempsTelevision?: any | null }>, oeils: Array<{ __typename?: 'Oeil', aberrationOrdreEleve?: string | null, aberrationSpherique?: string | null, antecedantChirurgie?: string | null, bump?: string | null, diametrePupillaire?: string | null, endothelium?: string | null, id: any, larmes?: string | null, longueurAxiale?: string | null, retineNerfOptique?: string | null, side: string, aOperer?: string | null, antecedantChirurgieCristallin?: string | null, typeImplantActuel?: string | null, ajoutAddon?: any | null, genererCourbeTypeImplant?: string | null, courbeDefocus?: any | null, implantCourantId?: any | null, choixes: Array<{ __typename?: 'Choix', implantId?: any | null, decalage: any, decalageCourbeExistante: any, affichageDefocus?: any | null, type?: string | null, materiau?: string | null, final?: boolean | null, laboratoireId?: any | null, implant?: { __typename?: 'Implant', correctionOptique: string, data: any, display: string, id: any, materiau: string, mb: string, methodology?: string | null, n?: any | null, name: string, note?: string | null, type: string, laboratoire: { __typename?: 'Laboratoire', nom?: string | null, id: any } } | null }>, implantCourant?: { __typename?: 'Implant', correctionOptique: string, data: any, display: string, id: any, materiau: string, mb: string, methodology?: string | null, n?: any | null, name: string, note?: string | null, type: string, laboratoire: { __typename?: 'Laboratoire', nom?: string | null, id: any } } | null }> } | null };


export const DeleteActivitePreferentielleByPatientDocument = gql`
    mutation deleteActivitePreferentielleByPatient($patientId: uuid = "") {
  deleteActivitePreferentielle(where: {patientId: {_eq: $patientId}}) {
    affectedRows
  }
}
    `;
export type DeleteActivitePreferentielleByPatientMutationFn = Apollo.MutationFunction<DeleteActivitePreferentielleByPatientMutation, DeleteActivitePreferentielleByPatientMutationVariables>;

/**
 * __useDeleteActivitePreferentielleByPatientMutation__
 *
 * To run a mutation, you first call `useDeleteActivitePreferentielleByPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivitePreferentielleByPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivitePreferentielleByPatientMutation, { data, loading, error }] = useDeleteActivitePreferentielleByPatientMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useDeleteActivitePreferentielleByPatientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActivitePreferentielleByPatientMutation, DeleteActivitePreferentielleByPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActivitePreferentielleByPatientMutation, DeleteActivitePreferentielleByPatientMutationVariables>(DeleteActivitePreferentielleByPatientDocument, options);
      }
export type DeleteActivitePreferentielleByPatientMutationHookResult = ReturnType<typeof useDeleteActivitePreferentielleByPatientMutation>;
export type DeleteActivitePreferentielleByPatientMutationResult = Apollo.MutationResult<DeleteActivitePreferentielleByPatientMutation>;
export type DeleteActivitePreferentielleByPatientMutationOptions = Apollo.BaseMutationOptions<DeleteActivitePreferentielleByPatientMutation, DeleteActivitePreferentielleByPatientMutationVariables>;
export const InsertActivitePreferentielleDocument = gql`
    mutation insertActivitePreferentielle($object: ActivitePreferentielleInsertInput = {}) {
  insertActivitePreferentielleOne(object: $object) {
    id
  }
}
    `;
export type InsertActivitePreferentielleMutationFn = Apollo.MutationFunction<InsertActivitePreferentielleMutation, InsertActivitePreferentielleMutationVariables>;

/**
 * __useInsertActivitePreferentielleMutation__
 *
 * To run a mutation, you first call `useInsertActivitePreferentielleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertActivitePreferentielleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertActivitePreferentielleMutation, { data, loading, error }] = useInsertActivitePreferentielleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertActivitePreferentielleMutation(baseOptions?: Apollo.MutationHookOptions<InsertActivitePreferentielleMutation, InsertActivitePreferentielleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertActivitePreferentielleMutation, InsertActivitePreferentielleMutationVariables>(InsertActivitePreferentielleDocument, options);
      }
export type InsertActivitePreferentielleMutationHookResult = ReturnType<typeof useInsertActivitePreferentielleMutation>;
export type InsertActivitePreferentielleMutationResult = Apollo.MutationResult<InsertActivitePreferentielleMutation>;
export type InsertActivitePreferentielleMutationOptions = Apollo.BaseMutationOptions<InsertActivitePreferentielleMutation, InsertActivitePreferentielleMutationVariables>;
export const DeleteChirurgienDocument = gql`
    mutation deleteChirurgien($id: uuid = "") {
  deleteChirurgienByPk(id: $id) {
    id
  }
}
    `;
export type DeleteChirurgienMutationFn = Apollo.MutationFunction<DeleteChirurgienMutation, DeleteChirurgienMutationVariables>;

/**
 * __useDeleteChirurgienMutation__
 *
 * To run a mutation, you first call `useDeleteChirurgienMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChirurgienMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChirurgienMutation, { data, loading, error }] = useDeleteChirurgienMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChirurgienMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChirurgienMutation, DeleteChirurgienMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChirurgienMutation, DeleteChirurgienMutationVariables>(DeleteChirurgienDocument, options);
      }
export type DeleteChirurgienMutationHookResult = ReturnType<typeof useDeleteChirurgienMutation>;
export type DeleteChirurgienMutationResult = Apollo.MutationResult<DeleteChirurgienMutation>;
export type DeleteChirurgienMutationOptions = Apollo.BaseMutationOptions<DeleteChirurgienMutation, DeleteChirurgienMutationVariables>;
export const UpdateChirurgienDocument = gql`
    mutation updateChirurgien($id: uuid = "", $data: ChirurgienSetInput = {}) {
  updateChirurgienByPk(pkColumns: {id: $id}, _set: $data) {
    id
    nom
    prenom
    clinique
    adresse
    codePostal
    ville
    logo
    titreFr
    titreEn
  }
}
    `;
export type UpdateChirurgienMutationFn = Apollo.MutationFunction<UpdateChirurgienMutation, UpdateChirurgienMutationVariables>;

/**
 * __useUpdateChirurgienMutation__
 *
 * To run a mutation, you first call `useUpdateChirurgienMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChirurgienMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChirurgienMutation, { data, loading, error }] = useUpdateChirurgienMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateChirurgienMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChirurgienMutation, UpdateChirurgienMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChirurgienMutation, UpdateChirurgienMutationVariables>(UpdateChirurgienDocument, options);
      }
export type UpdateChirurgienMutationHookResult = ReturnType<typeof useUpdateChirurgienMutation>;
export type UpdateChirurgienMutationResult = Apollo.MutationResult<UpdateChirurgienMutation>;
export type UpdateChirurgienMutationOptions = Apollo.BaseMutationOptions<UpdateChirurgienMutation, UpdateChirurgienMutationVariables>;
export const InsertChoixDocument = gql`
    mutation insertChoix($objects: [ChoixInsertInput!] = {}) {
  insertChoix(
    objects: $objects
    onConflict: {constraint: choix_oeil_id_key, updateColumns: [decalage, implantId, type, materiau, laboratoireId, final, decalageCourbeExistante, affichageDefocus]}
  ) {
    affectedRows
  }
}
    `;
export type InsertChoixMutationFn = Apollo.MutationFunction<InsertChoixMutation, InsertChoixMutationVariables>;

/**
 * __useInsertChoixMutation__
 *
 * To run a mutation, you first call `useInsertChoixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertChoixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertChoixMutation, { data, loading, error }] = useInsertChoixMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertChoixMutation(baseOptions?: Apollo.MutationHookOptions<InsertChoixMutation, InsertChoixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertChoixMutation, InsertChoixMutationVariables>(InsertChoixDocument, options);
      }
export type InsertChoixMutationHookResult = ReturnType<typeof useInsertChoixMutation>;
export type InsertChoixMutationResult = Apollo.MutationResult<InsertChoixMutation>;
export type InsertChoixMutationOptions = Apollo.BaseMutationOptions<InsertChoixMutation, InsertChoixMutationVariables>;
export const DeleteFavorisDocument = gql`
    mutation deleteFavoris($chirurgienId: uuid = "", $implantId: uuid = "") {
  deleteFavorisByPk(chirurgienId: $chirurgienId, implantId: $implantId) {
    implantId
    chirurgienId
  }
}
    `;
export type DeleteFavorisMutationFn = Apollo.MutationFunction<DeleteFavorisMutation, DeleteFavorisMutationVariables>;

/**
 * __useDeleteFavorisMutation__
 *
 * To run a mutation, you first call `useDeleteFavorisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavorisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavorisMutation, { data, loading, error }] = useDeleteFavorisMutation({
 *   variables: {
 *      chirurgienId: // value for 'chirurgienId'
 *      implantId: // value for 'implantId'
 *   },
 * });
 */
export function useDeleteFavorisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavorisMutation, DeleteFavorisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavorisMutation, DeleteFavorisMutationVariables>(DeleteFavorisDocument, options);
      }
export type DeleteFavorisMutationHookResult = ReturnType<typeof useDeleteFavorisMutation>;
export type DeleteFavorisMutationResult = Apollo.MutationResult<DeleteFavorisMutation>;
export type DeleteFavorisMutationOptions = Apollo.BaseMutationOptions<DeleteFavorisMutation, DeleteFavorisMutationVariables>;
export const InsertFavorisDocument = gql`
    mutation insertFavoris($object: FavorisInsertInput = {}) {
  insertFavorisOne(object: $object) {
    implantId
    chirurgienId
  }
}
    `;
export type InsertFavorisMutationFn = Apollo.MutationFunction<InsertFavorisMutation, InsertFavorisMutationVariables>;

/**
 * __useInsertFavorisMutation__
 *
 * To run a mutation, you first call `useInsertFavorisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFavorisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFavorisMutation, { data, loading, error }] = useInsertFavorisMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertFavorisMutation(baseOptions?: Apollo.MutationHookOptions<InsertFavorisMutation, InsertFavorisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFavorisMutation, InsertFavorisMutationVariables>(InsertFavorisDocument, options);
      }
export type InsertFavorisMutationHookResult = ReturnType<typeof useInsertFavorisMutation>;
export type InsertFavorisMutationResult = Apollo.MutationResult<InsertFavorisMutation>;
export type InsertFavorisMutationOptions = Apollo.BaseMutationOptions<InsertFavorisMutation, InsertFavorisMutationVariables>;
export const InsertHabitudesDocument = gql`
    mutation insertHabitudes($object: HabitudesInsertInput = {}) {
  insertHabitudesOne(
    object: $object
    onConflict: {constraint: habitudes_patient_id_key, updateColumns: [heureCoucher, heureReveil, tempsAutreVisionPres, tempsConduite, tempsCuisine, tempsDiscussion, tempsJeuxSociete, tempsLecture, tempsOrdinateur, tempsSieste, tempsSmartphone, tempsTablette, tempsTelevision]}
  ) {
    id
  }
}
    `;
export type InsertHabitudesMutationFn = Apollo.MutationFunction<InsertHabitudesMutation, InsertHabitudesMutationVariables>;

/**
 * __useInsertHabitudesMutation__
 *
 * To run a mutation, you first call `useInsertHabitudesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertHabitudesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertHabitudesMutation, { data, loading, error }] = useInsertHabitudesMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertHabitudesMutation(baseOptions?: Apollo.MutationHookOptions<InsertHabitudesMutation, InsertHabitudesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertHabitudesMutation, InsertHabitudesMutationVariables>(InsertHabitudesDocument, options);
      }
export type InsertHabitudesMutationHookResult = ReturnType<typeof useInsertHabitudesMutation>;
export type InsertHabitudesMutationResult = Apollo.MutationResult<InsertHabitudesMutation>;
export type InsertHabitudesMutationOptions = Apollo.BaseMutationOptions<InsertHabitudesMutation, InsertHabitudesMutationVariables>;
export const DeleteHelpTextDocument = gql`
    mutation DeleteHelpText($id: uuid!) {
  deleteHelpTextsByPk(id: $id) {
    id
  }
}
    `;
export type DeleteHelpTextMutationFn = Apollo.MutationFunction<DeleteHelpTextMutation, DeleteHelpTextMutationVariables>;

/**
 * __useDeleteHelpTextMutation__
 *
 * To run a mutation, you first call `useDeleteHelpTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHelpTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHelpTextMutation, { data, loading, error }] = useDeleteHelpTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHelpTextMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHelpTextMutation, DeleteHelpTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHelpTextMutation, DeleteHelpTextMutationVariables>(DeleteHelpTextDocument, options);
      }
export type DeleteHelpTextMutationHookResult = ReturnType<typeof useDeleteHelpTextMutation>;
export type DeleteHelpTextMutationResult = Apollo.MutationResult<DeleteHelpTextMutation>;
export type DeleteHelpTextMutationOptions = Apollo.BaseMutationOptions<DeleteHelpTextMutation, DeleteHelpTextMutationVariables>;
export const UpdateHelpTextDocument = gql`
    mutation UpdateHelpText($id: uuid!, $textFr: String!, $textEn: String) {
  updateHelpTextsByPk(
    pkColumns: {id: $id}
    _set: {textFr: $textFr, textEn: $textEn, updatedAt: "now()"}
  ) {
    id
    fieldName
    textFr
    textEn
    isDefault
    updatedAt
  }
}
    `;
export type UpdateHelpTextMutationFn = Apollo.MutationFunction<UpdateHelpTextMutation, UpdateHelpTextMutationVariables>;

/**
 * __useUpdateHelpTextMutation__
 *
 * To run a mutation, you first call `useUpdateHelpTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHelpTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHelpTextMutation, { data, loading, error }] = useUpdateHelpTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      textFr: // value for 'textFr'
 *      textEn: // value for 'textEn'
 *   },
 * });
 */
export function useUpdateHelpTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHelpTextMutation, UpdateHelpTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHelpTextMutation, UpdateHelpTextMutationVariables>(UpdateHelpTextDocument, options);
      }
export type UpdateHelpTextMutationHookResult = ReturnType<typeof useUpdateHelpTextMutation>;
export type UpdateHelpTextMutationResult = Apollo.MutationResult<UpdateHelpTextMutation>;
export type UpdateHelpTextMutationOptions = Apollo.BaseMutationOptions<UpdateHelpTextMutation, UpdateHelpTextMutationVariables>;
export const UpsertHelpTextDocument = gql`
    mutation UpsertHelpText($object: HelpTextsInsertInput!) {
  insertHelpTextsOne(
    object: $object
    onConflict: {constraint: help_texts_field_name_chirurgien_id_key, updateColumns: [textFr, textEn, updatedAt]}
  ) {
    id
    fieldName
    textFr
    textEn
    isDefault
    updatedAt
  }
}
    `;
export type UpsertHelpTextMutationFn = Apollo.MutationFunction<UpsertHelpTextMutation, UpsertHelpTextMutationVariables>;

/**
 * __useUpsertHelpTextMutation__
 *
 * To run a mutation, you first call `useUpsertHelpTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertHelpTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertHelpTextMutation, { data, loading, error }] = useUpsertHelpTextMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertHelpTextMutation(baseOptions?: Apollo.MutationHookOptions<UpsertHelpTextMutation, UpsertHelpTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertHelpTextMutation, UpsertHelpTextMutationVariables>(UpsertHelpTextDocument, options);
      }
export type UpsertHelpTextMutationHookResult = ReturnType<typeof useUpsertHelpTextMutation>;
export type UpsertHelpTextMutationResult = Apollo.MutationResult<UpsertHelpTextMutation>;
export type UpsertHelpTextMutationOptions = Apollo.BaseMutationOptions<UpsertHelpTextMutation, UpsertHelpTextMutationVariables>;
export const DeleteImplantDocument = gql`
    mutation deleteImplant($id: uuid = "") {
  deleteImplantByPk(id: $id) {
    id
  }
}
    `;
export type DeleteImplantMutationFn = Apollo.MutationFunction<DeleteImplantMutation, DeleteImplantMutationVariables>;

/**
 * __useDeleteImplantMutation__
 *
 * To run a mutation, you first call `useDeleteImplantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImplantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImplantMutation, { data, loading, error }] = useDeleteImplantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImplantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImplantMutation, DeleteImplantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImplantMutation, DeleteImplantMutationVariables>(DeleteImplantDocument, options);
      }
export type DeleteImplantMutationHookResult = ReturnType<typeof useDeleteImplantMutation>;
export type DeleteImplantMutationResult = Apollo.MutationResult<DeleteImplantMutation>;
export type DeleteImplantMutationOptions = Apollo.BaseMutationOptions<DeleteImplantMutation, DeleteImplantMutationVariables>;
export const InsertImplantDocument = gql`
    mutation insertImplant($object: ImplantInsertInput = {}) {
  insertImplantOne(object: $object) {
    id
    name
  }
}
    `;
export type InsertImplantMutationFn = Apollo.MutationFunction<InsertImplantMutation, InsertImplantMutationVariables>;

/**
 * __useInsertImplantMutation__
 *
 * To run a mutation, you first call `useInsertImplantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertImplantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertImplantMutation, { data, loading, error }] = useInsertImplantMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertImplantMutation(baseOptions?: Apollo.MutationHookOptions<InsertImplantMutation, InsertImplantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertImplantMutation, InsertImplantMutationVariables>(InsertImplantDocument, options);
      }
export type InsertImplantMutationHookResult = ReturnType<typeof useInsertImplantMutation>;
export type InsertImplantMutationResult = Apollo.MutationResult<InsertImplantMutation>;
export type InsertImplantMutationOptions = Apollo.BaseMutationOptions<InsertImplantMutation, InsertImplantMutationVariables>;
export const UpdateImplantDocument = gql`
    mutation updateImplant($id: uuid = "", $data: ImplantSetInput = {}) {
  updateImplantByPk(pkColumns: {id: $id}, _set: $data) {
    id
    name
  }
}
    `;
export type UpdateImplantMutationFn = Apollo.MutationFunction<UpdateImplantMutation, UpdateImplantMutationVariables>;

/**
 * __useUpdateImplantMutation__
 *
 * To run a mutation, you first call `useUpdateImplantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImplantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImplantMutation, { data, loading, error }] = useUpdateImplantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateImplantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateImplantMutation, UpdateImplantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateImplantMutation, UpdateImplantMutationVariables>(UpdateImplantDocument, options);
      }
export type UpdateImplantMutationHookResult = ReturnType<typeof useUpdateImplantMutation>;
export type UpdateImplantMutationResult = Apollo.MutationResult<UpdateImplantMutation>;
export type UpdateImplantMutationOptions = Apollo.BaseMutationOptions<UpdateImplantMutation, UpdateImplantMutationVariables>;
export const DeleteLaboratoireDocument = gql`
    mutation deleteLaboratoire($id: uuid = "") {
  deleteLaboratoireByPk(id: $id) {
    id
  }
}
    `;
export type DeleteLaboratoireMutationFn = Apollo.MutationFunction<DeleteLaboratoireMutation, DeleteLaboratoireMutationVariables>;

/**
 * __useDeleteLaboratoireMutation__
 *
 * To run a mutation, you first call `useDeleteLaboratoireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLaboratoireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLaboratoireMutation, { data, loading, error }] = useDeleteLaboratoireMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLaboratoireMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLaboratoireMutation, DeleteLaboratoireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLaboratoireMutation, DeleteLaboratoireMutationVariables>(DeleteLaboratoireDocument, options);
      }
export type DeleteLaboratoireMutationHookResult = ReturnType<typeof useDeleteLaboratoireMutation>;
export type DeleteLaboratoireMutationResult = Apollo.MutationResult<DeleteLaboratoireMutation>;
export type DeleteLaboratoireMutationOptions = Apollo.BaseMutationOptions<DeleteLaboratoireMutation, DeleteLaboratoireMutationVariables>;
export const InsertLaboratoireDocument = gql`
    mutation insertLaboratoire($nom: String = "") {
  insertLaboratoireOne(object: {nom: $nom}) {
    id
    nom
  }
}
    `;
export type InsertLaboratoireMutationFn = Apollo.MutationFunction<InsertLaboratoireMutation, InsertLaboratoireMutationVariables>;

/**
 * __useInsertLaboratoireMutation__
 *
 * To run a mutation, you first call `useInsertLaboratoireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertLaboratoireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertLaboratoireMutation, { data, loading, error }] = useInsertLaboratoireMutation({
 *   variables: {
 *      nom: // value for 'nom'
 *   },
 * });
 */
export function useInsertLaboratoireMutation(baseOptions?: Apollo.MutationHookOptions<InsertLaboratoireMutation, InsertLaboratoireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertLaboratoireMutation, InsertLaboratoireMutationVariables>(InsertLaboratoireDocument, options);
      }
export type InsertLaboratoireMutationHookResult = ReturnType<typeof useInsertLaboratoireMutation>;
export type InsertLaboratoireMutationResult = Apollo.MutationResult<InsertLaboratoireMutation>;
export type InsertLaboratoireMutationOptions = Apollo.BaseMutationOptions<InsertLaboratoireMutation, InsertLaboratoireMutationVariables>;
export const UpdateLaboratoireDocument = gql`
    mutation updateLaboratoire($id: uuid = "", $data: LaboratoireSetInput = {}) {
  updateLaboratoireByPk(pkColumns: {id: $id}, _set: $data) {
    id
    nom
  }
}
    `;
export type UpdateLaboratoireMutationFn = Apollo.MutationFunction<UpdateLaboratoireMutation, UpdateLaboratoireMutationVariables>;

/**
 * __useUpdateLaboratoireMutation__
 *
 * To run a mutation, you first call `useUpdateLaboratoireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLaboratoireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLaboratoireMutation, { data, loading, error }] = useUpdateLaboratoireMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLaboratoireMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLaboratoireMutation, UpdateLaboratoireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLaboratoireMutation, UpdateLaboratoireMutationVariables>(UpdateLaboratoireDocument, options);
      }
export type UpdateLaboratoireMutationHookResult = ReturnType<typeof useUpdateLaboratoireMutation>;
export type UpdateLaboratoireMutationResult = Apollo.MutationResult<UpdateLaboratoireMutation>;
export type UpdateLaboratoireMutationOptions = Apollo.BaseMutationOptions<UpdateLaboratoireMutation, UpdateLaboratoireMutationVariables>;
export const InsertOeilDocument = gql`
    mutation insertOeil($object: OeilInsertInput = {}) {
  insertOeilOne(
    object: $object
    onConflict: {constraint: oeil_patient_id_side_key, updateColumns: [aberrationOrdreEleve, aberrationSpherique, antecedantChirurgie, bump, diametrePupillaire, endothelium, larmes, longueurAxiale, retineNerfOptique, aOperer, antecedantChirurgieCristallin, typeImplantActuel, ajoutAddon, genererCourbeTypeImplant, courbeDefocus, implantCourantId]}
  ) {
    id
  }
}
    `;
export type InsertOeilMutationFn = Apollo.MutationFunction<InsertOeilMutation, InsertOeilMutationVariables>;

/**
 * __useInsertOeilMutation__
 *
 * To run a mutation, you first call `useInsertOeilMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertOeilMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertOeilMutation, { data, loading, error }] = useInsertOeilMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertOeilMutation(baseOptions?: Apollo.MutationHookOptions<InsertOeilMutation, InsertOeilMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertOeilMutation, InsertOeilMutationVariables>(InsertOeilDocument, options);
      }
export type InsertOeilMutationHookResult = ReturnType<typeof useInsertOeilMutation>;
export type InsertOeilMutationResult = Apollo.MutationResult<InsertOeilMutation>;
export type InsertOeilMutationOptions = Apollo.BaseMutationOptions<InsertOeilMutation, InsertOeilMutationVariables>;
export const UpdateParametresDocument = gql`
    mutation updateParametres($objects: [ParametresInsertInput!] = {}) {
  insertParametres(
    objects: $objects
    onConflict: {constraint: parametres_pkey, updateColumns: paramValue}
  ) {
    affectedRows
  }
}
    `;
export type UpdateParametresMutationFn = Apollo.MutationFunction<UpdateParametresMutation, UpdateParametresMutationVariables>;

/**
 * __useUpdateParametresMutation__
 *
 * To run a mutation, you first call `useUpdateParametresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateParametresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateParametresMutation, { data, loading, error }] = useUpdateParametresMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpdateParametresMutation(baseOptions?: Apollo.MutationHookOptions<UpdateParametresMutation, UpdateParametresMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateParametresMutation, UpdateParametresMutationVariables>(UpdateParametresDocument, options);
      }
export type UpdateParametresMutationHookResult = ReturnType<typeof useUpdateParametresMutation>;
export type UpdateParametresMutationResult = Apollo.MutationResult<UpdateParametresMutation>;
export type UpdateParametresMutationOptions = Apollo.BaseMutationOptions<UpdateParametresMutation, UpdateParametresMutationVariables>;
export const FinalizePatientFormDocument = gql`
    mutation FinalizePatientForm($patientId: uuid!, $patientData: PatientSetInput!, $habitudesData: HabitudesInsertInput!, $activitesPreferentielles: [ActivitePreferentielleInsertInput!]!, $tokenId: uuid!) {
  updatePatientByPk(pkColumns: {id: $patientId}, _set: $patientData) {
    id
    nom
    prenom
    sexe
    birthday
    size
    photicEffect
    glasses
    updatedAt
  }
  insertHabitudesOne(
    object: $habitudesData
    onConflict: {constraint: habitudes_patient_id_key, updateColumns: [heureReveil, heureCoucher, tempsSieste, tempsLecture, tempsTablette, tempsSmartphone, tempsAutreVisionPres, tempsDiscussion, tempsJeuxSociete, tempsOrdinateur, tempsCuisine, tempsConduite, tempsTelevision]}
  ) {
    id
    patientId
  }
  deleteActivitePreferentielle(where: {patientId: {_eq: $patientId}}) {
    affectedRows
  }
  insertActivitePreferentielle(objects: $activitesPreferentielles) {
    affectedRows
    returning {
      id
      nom
      distanceMin
      distanceMax
    }
  }
  updatePatientTempTokensByPk(
    pkColumns: {id: $tokenId}
    _set: {isUsed: true, usedAt: "now()"}
  ) {
    id
    isUsed
    usedAt
  }
}
    `;
export type FinalizePatientFormMutationFn = Apollo.MutationFunction<FinalizePatientFormMutation, FinalizePatientFormMutationVariables>;

/**
 * __useFinalizePatientFormMutation__
 *
 * To run a mutation, you first call `useFinalizePatientFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizePatientFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizePatientFormMutation, { data, loading, error }] = useFinalizePatientFormMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      patientData: // value for 'patientData'
 *      habitudesData: // value for 'habitudesData'
 *      activitesPreferentielles: // value for 'activitesPreferentielles'
 *      tokenId: // value for 'tokenId'
 *   },
 * });
 */
export function useFinalizePatientFormMutation(baseOptions?: Apollo.MutationHookOptions<FinalizePatientFormMutation, FinalizePatientFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizePatientFormMutation, FinalizePatientFormMutationVariables>(FinalizePatientFormDocument, options);
      }
export type FinalizePatientFormMutationHookResult = ReturnType<typeof useFinalizePatientFormMutation>;
export type FinalizePatientFormMutationResult = Apollo.MutationResult<FinalizePatientFormMutation>;
export type FinalizePatientFormMutationOptions = Apollo.BaseMutationOptions<FinalizePatientFormMutation, FinalizePatientFormMutationVariables>;
export const GeneratePatientTokenWithExpiryDocument = gql`
    mutation GeneratePatientTokenWithExpiry($patientId: uuid!, $expiresAt: timestamptz!) {
  insertPatientTempTokensOne(
    object: {patientId: $patientId, expiresAt: $expiresAt, formData: "{}"}
  ) {
    id
    token
    expiresAt
  }
}
    `;
export type GeneratePatientTokenWithExpiryMutationFn = Apollo.MutationFunction<GeneratePatientTokenWithExpiryMutation, GeneratePatientTokenWithExpiryMutationVariables>;

/**
 * __useGeneratePatientTokenWithExpiryMutation__
 *
 * To run a mutation, you first call `useGeneratePatientTokenWithExpiryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePatientTokenWithExpiryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePatientTokenWithExpiryMutation, { data, loading, error }] = useGeneratePatientTokenWithExpiryMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useGeneratePatientTokenWithExpiryMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePatientTokenWithExpiryMutation, GeneratePatientTokenWithExpiryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePatientTokenWithExpiryMutation, GeneratePatientTokenWithExpiryMutationVariables>(GeneratePatientTokenWithExpiryDocument, options);
      }
export type GeneratePatientTokenWithExpiryMutationHookResult = ReturnType<typeof useGeneratePatientTokenWithExpiryMutation>;
export type GeneratePatientTokenWithExpiryMutationResult = Apollo.MutationResult<GeneratePatientTokenWithExpiryMutation>;
export type GeneratePatientTokenWithExpiryMutationOptions = Apollo.BaseMutationOptions<GeneratePatientTokenWithExpiryMutation, GeneratePatientTokenWithExpiryMutationVariables>;
export const UpdatePatientFormDataDocument = gql`
    mutation UpdatePatientFormData($token: String!, $formData: jsonb!) {
  updatePatientTempTokens(
    where: {token: {_eq: $token}, expiresAt: {_gt: "now()"}, isUsed: {_eq: false}}
    _set: {formData: $formData, lastSavedAt: "now()"}
    _inc: {accessCount: 1}
  ) {
    affectedRows
    returning {
      id
      formData
      lastSavedAt
      accessCount
      expiresAt
      patientId
    }
  }
}
    `;
export type UpdatePatientFormDataMutationFn = Apollo.MutationFunction<UpdatePatientFormDataMutation, UpdatePatientFormDataMutationVariables>;

/**
 * __useUpdatePatientFormDataMutation__
 *
 * To run a mutation, you first call `useUpdatePatientFormDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientFormDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientFormDataMutation, { data, loading, error }] = useUpdatePatientFormDataMutation({
 *   variables: {
 *      token: // value for 'token'
 *      formData: // value for 'formData'
 *   },
 * });
 */
export function useUpdatePatientFormDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientFormDataMutation, UpdatePatientFormDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientFormDataMutation, UpdatePatientFormDataMutationVariables>(UpdatePatientFormDataDocument, options);
      }
export type UpdatePatientFormDataMutationHookResult = ReturnType<typeof useUpdatePatientFormDataMutation>;
export type UpdatePatientFormDataMutationResult = Apollo.MutationResult<UpdatePatientFormDataMutation>;
export type UpdatePatientFormDataMutationOptions = Apollo.BaseMutationOptions<UpdatePatientFormDataMutation, UpdatePatientFormDataMutationVariables>;
export const ArchivePatientDocument = gql`
    mutation ArchivePatient($id: uuid!, $isArchived: Boolean!) {
  updatePatientByPk(pkColumns: {id: $id}, _set: {isArchived: $isArchived}) {
    id
    isArchived
  }
}
    `;
export type ArchivePatientMutationFn = Apollo.MutationFunction<ArchivePatientMutation, ArchivePatientMutationVariables>;

/**
 * __useArchivePatientMutation__
 *
 * To run a mutation, you first call `useArchivePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePatientMutation, { data, loading, error }] = useArchivePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isArchived: // value for 'isArchived'
 *   },
 * });
 */
export function useArchivePatientMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePatientMutation, ArchivePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePatientMutation, ArchivePatientMutationVariables>(ArchivePatientDocument, options);
      }
export type ArchivePatientMutationHookResult = ReturnType<typeof useArchivePatientMutation>;
export type ArchivePatientMutationResult = Apollo.MutationResult<ArchivePatientMutation>;
export type ArchivePatientMutationOptions = Apollo.BaseMutationOptions<ArchivePatientMutation, ArchivePatientMutationVariables>;
export const DeletePatientDocument = gql`
    mutation deletePatient($id: uuid = "") {
  deletePatientByPk(id: $id) {
    id
  }
}
    `;
export type DeletePatientMutationFn = Apollo.MutationFunction<DeletePatientMutation, DeletePatientMutationVariables>;

/**
 * __useDeletePatientMutation__
 *
 * To run a mutation, you first call `useDeletePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientMutation, { data, loading, error }] = useDeletePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePatientMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientMutation, DeletePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientMutation, DeletePatientMutationVariables>(DeletePatientDocument, options);
      }
export type DeletePatientMutationHookResult = ReturnType<typeof useDeletePatientMutation>;
export type DeletePatientMutationResult = Apollo.MutationResult<DeletePatientMutation>;
export type DeletePatientMutationOptions = Apollo.BaseMutationOptions<DeletePatientMutation, DeletePatientMutationVariables>;
export const InsertPatientDocument = gql`
    mutation insertPatient($nom: String = "", $prenom: String = "", $birthday: timestamptz = "", $chirurgienId: uuid = "") {
  insertPatientOne(
    object: {birthday: $birthday, nom: $nom, prenom: $prenom, chirurgienId: $chirurgienId}
  ) {
    birthday
    id
    nom
    prenom
    chirurgienId
    createdAt
    updatedAt
  }
}
    `;
export type InsertPatientMutationFn = Apollo.MutationFunction<InsertPatientMutation, InsertPatientMutationVariables>;

/**
 * __useInsertPatientMutation__
 *
 * To run a mutation, you first call `useInsertPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPatientMutation, { data, loading, error }] = useInsertPatientMutation({
 *   variables: {
 *      nom: // value for 'nom'
 *      prenom: // value for 'prenom'
 *      birthday: // value for 'birthday'
 *      chirurgienId: // value for 'chirurgienId'
 *   },
 * });
 */
export function useInsertPatientMutation(baseOptions?: Apollo.MutationHookOptions<InsertPatientMutation, InsertPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPatientMutation, InsertPatientMutationVariables>(InsertPatientDocument, options);
      }
export type InsertPatientMutationHookResult = ReturnType<typeof useInsertPatientMutation>;
export type InsertPatientMutationResult = Apollo.MutationResult<InsertPatientMutation>;
export type InsertPatientMutationOptions = Apollo.BaseMutationOptions<InsertPatientMutation, InsertPatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation updatePatient($id: uuid = "", $data: PatientSetInput = {}) {
  updatePatientByPk(pkColumns: {id: $id}, _set: $data) {
    id
    nom
    prenom
    birthday
    updatedAt
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const UpdatePatientEmailDocument = gql`
    mutation UpdatePatientEmail($id: uuid!, $email: String!) {
  updatePatientByPk(pkColumns: {id: $id}, _set: {email: $email}) {
    id
    email
  }
}
    `;
export type UpdatePatientEmailMutationFn = Apollo.MutationFunction<UpdatePatientEmailMutation, UpdatePatientEmailMutationVariables>;

/**
 * __useUpdatePatientEmailMutation__
 *
 * To run a mutation, you first call `useUpdatePatientEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientEmailMutation, { data, loading, error }] = useUpdatePatientEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUpdatePatientEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientEmailMutation, UpdatePatientEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientEmailMutation, UpdatePatientEmailMutationVariables>(UpdatePatientEmailDocument, options);
      }
export type UpdatePatientEmailMutationHookResult = ReturnType<typeof useUpdatePatientEmailMutation>;
export type UpdatePatientEmailMutationResult = Apollo.MutationResult<UpdatePatientEmailMutation>;
export type UpdatePatientEmailMutationOptions = Apollo.BaseMutationOptions<UpdatePatientEmailMutation, UpdatePatientEmailMutationVariables>;
export const GetChirurgienDocument = gql`
    query getChirurgien($cognitoToken: String = "") {
  chirurgien(where: {cognitoToken: {_eq: $cognitoToken}}) {
    id
    nom
    prenom
    cognitoToken
    codePostal
    clinique
    adresse
    logo
    ville
    titreFr
    titreEn
  }
}
    `;

/**
 * __useGetChirurgienQuery__
 *
 * To run a query within a React component, call `useGetChirurgienQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChirurgienQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChirurgienQuery({
 *   variables: {
 *      cognitoToken: // value for 'cognitoToken'
 *   },
 * });
 */
export function useGetChirurgienQuery(baseOptions?: Apollo.QueryHookOptions<GetChirurgienQuery, GetChirurgienQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChirurgienQuery, GetChirurgienQueryVariables>(GetChirurgienDocument, options);
      }
export function useGetChirurgienLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChirurgienQuery, GetChirurgienQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChirurgienQuery, GetChirurgienQueryVariables>(GetChirurgienDocument, options);
        }
export type GetChirurgienQueryHookResult = ReturnType<typeof useGetChirurgienQuery>;
export type GetChirurgienLazyQueryHookResult = ReturnType<typeof useGetChirurgienLazyQuery>;
export type GetChirurgienQueryResult = Apollo.QueryResult<GetChirurgienQuery, GetChirurgienQueryVariables>;
export const ListChirurgiensDocument = gql`
    query listChirurgiens {
  chirurgien(orderBy: {nom: ASC}) {
    id
    nom
    prenom
    cognitoToken
    codePostal
    clinique
    adresse
    logo
    ville
    titreFr
    titreEn
  }
}
    `;

/**
 * __useListChirurgiensQuery__
 *
 * To run a query within a React component, call `useListChirurgiensQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChirurgiensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChirurgiensQuery({
 *   variables: {
 *   },
 * });
 */
export function useListChirurgiensQuery(baseOptions?: Apollo.QueryHookOptions<ListChirurgiensQuery, ListChirurgiensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListChirurgiensQuery, ListChirurgiensQueryVariables>(ListChirurgiensDocument, options);
      }
export function useListChirurgiensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListChirurgiensQuery, ListChirurgiensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListChirurgiensQuery, ListChirurgiensQueryVariables>(ListChirurgiensDocument, options);
        }
export type ListChirurgiensQueryHookResult = ReturnType<typeof useListChirurgiensQuery>;
export type ListChirurgiensLazyQueryHookResult = ReturnType<typeof useListChirurgiensLazyQuery>;
export type ListChirurgiensQueryResult = Apollo.QueryResult<ListChirurgiensQuery, ListChirurgiensQueryVariables>;
export const GetHelpTextByFieldDocument = gql`
    query GetHelpTextByField($fieldName: String!) {
  helpTexts(
    where: {fieldName: {_eq: $fieldName}}
    orderBy: {isDefault: ASC}
    limit: 1
  ) {
    id
    textFr
    textEn
    isDefault
  }
}
    `;

/**
 * __useGetHelpTextByFieldQuery__
 *
 * To run a query within a React component, call `useGetHelpTextByFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpTextByFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpTextByFieldQuery({
 *   variables: {
 *      fieldName: // value for 'fieldName'
 *   },
 * });
 */
export function useGetHelpTextByFieldQuery(baseOptions: Apollo.QueryHookOptions<GetHelpTextByFieldQuery, GetHelpTextByFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpTextByFieldQuery, GetHelpTextByFieldQueryVariables>(GetHelpTextByFieldDocument, options);
      }
export function useGetHelpTextByFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpTextByFieldQuery, GetHelpTextByFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpTextByFieldQuery, GetHelpTextByFieldQueryVariables>(GetHelpTextByFieldDocument, options);
        }
export type GetHelpTextByFieldQueryHookResult = ReturnType<typeof useGetHelpTextByFieldQuery>;
export type GetHelpTextByFieldLazyQueryHookResult = ReturnType<typeof useGetHelpTextByFieldLazyQuery>;
export type GetHelpTextByFieldQueryResult = Apollo.QueryResult<GetHelpTextByFieldQuery, GetHelpTextByFieldQueryVariables>;
export const GetHelpTextsDocument = gql`
    query GetHelpTexts {
  helpTexts(orderBy: [{isDefault: DESC}, {fieldName: ASC}]) {
    id
    fieldName
    category
    textFr
    textEn
    isDefault
    chirurgienId
    updatedAt
  }
}
    `;

/**
 * __useGetHelpTextsQuery__
 *
 * To run a query within a React component, call `useGetHelpTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelpTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelpTextsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHelpTextsQuery(baseOptions?: Apollo.QueryHookOptions<GetHelpTextsQuery, GetHelpTextsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelpTextsQuery, GetHelpTextsQueryVariables>(GetHelpTextsDocument, options);
      }
export function useGetHelpTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelpTextsQuery, GetHelpTextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelpTextsQuery, GetHelpTextsQueryVariables>(GetHelpTextsDocument, options);
        }
export type GetHelpTextsQueryHookResult = ReturnType<typeof useGetHelpTextsQuery>;
export type GetHelpTextsLazyQueryHookResult = ReturnType<typeof useGetHelpTextsLazyQuery>;
export type GetHelpTextsQueryResult = Apollo.QueryResult<GetHelpTextsQuery, GetHelpTextsQueryVariables>;
export const GetImplantsDocument = gql`
    query getImplants($implantsList: [uuid!] = "") {
  implant(where: {id: {_in: $implantsList}}) {
    id
    laboratoireId
    laboratoire {
      id
      nom
    }
    favoris {
      chirurgienId
    }
    name
    correctionOptique
    data
    display
    materiau
    mb
    methodology
    n
    note
    type
  }
}
    `;

/**
 * __useGetImplantsQuery__
 *
 * To run a query within a React component, call `useGetImplantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImplantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImplantsQuery({
 *   variables: {
 *      implantsList: // value for 'implantsList'
 *   },
 * });
 */
export function useGetImplantsQuery(baseOptions?: Apollo.QueryHookOptions<GetImplantsQuery, GetImplantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImplantsQuery, GetImplantsQueryVariables>(GetImplantsDocument, options);
      }
export function useGetImplantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImplantsQuery, GetImplantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImplantsQuery, GetImplantsQueryVariables>(GetImplantsDocument, options);
        }
export type GetImplantsQueryHookResult = ReturnType<typeof useGetImplantsQuery>;
export type GetImplantsLazyQueryHookResult = ReturnType<typeof useGetImplantsLazyQuery>;
export type GetImplantsQueryResult = Apollo.QueryResult<GetImplantsQuery, GetImplantsQueryVariables>;
export const ListImplantsDocument = gql`
    query listImplants($orderBy: [ImplantOrderBy!] = {laboratoire: {nom: ASC}, name: ASC}, $where: ImplantBoolExp = {}) {
  implant(orderBy: $orderBy, where: $where) {
    id
    laboratoire {
      id
      nom
    }
    favoris {
      chirurgienId
    }
    name
  }
  laboratoire(orderBy: {nom: ASC}) {
    id
    nom
  }
}
    `;

/**
 * __useListImplantsQuery__
 *
 * To run a query within a React component, call `useListImplantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListImplantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListImplantsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListImplantsQuery(baseOptions?: Apollo.QueryHookOptions<ListImplantsQuery, ListImplantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListImplantsQuery, ListImplantsQueryVariables>(ListImplantsDocument, options);
      }
export function useListImplantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListImplantsQuery, ListImplantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListImplantsQuery, ListImplantsQueryVariables>(ListImplantsDocument, options);
        }
export type ListImplantsQueryHookResult = ReturnType<typeof useListImplantsQuery>;
export type ListImplantsLazyQueryHookResult = ReturnType<typeof useListImplantsLazyQuery>;
export type ListImplantsQueryResult = Apollo.QueryResult<ListImplantsQuery, ListImplantsQueryVariables>;
export const GetLaboratoireDocument = gql`
    query getLaboratoire($id: uuid = "") {
  laboratoireByPk(id: $id) {
    nom
  }
}
    `;

/**
 * __useGetLaboratoireQuery__
 *
 * To run a query within a React component, call `useGetLaboratoireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaboratoireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaboratoireQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLaboratoireQuery(baseOptions?: Apollo.QueryHookOptions<GetLaboratoireQuery, GetLaboratoireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaboratoireQuery, GetLaboratoireQueryVariables>(GetLaboratoireDocument, options);
      }
export function useGetLaboratoireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaboratoireQuery, GetLaboratoireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaboratoireQuery, GetLaboratoireQueryVariables>(GetLaboratoireDocument, options);
        }
export type GetLaboratoireQueryHookResult = ReturnType<typeof useGetLaboratoireQuery>;
export type GetLaboratoireLazyQueryHookResult = ReturnType<typeof useGetLaboratoireLazyQuery>;
export type GetLaboratoireQueryResult = Apollo.QueryResult<GetLaboratoireQuery, GetLaboratoireQueryVariables>;
export const ListLaboratoiresDocument = gql`
    query listLaboratoires($orderBy: [LaboratoireOrderBy!] = {nom: ASC}, $where: LaboratoireBoolExp = {}) {
  laboratoire(orderBy: $orderBy, where: $where) {
    label: nom
    value: id
    id
    nom
  }
}
    `;

/**
 * __useListLaboratoiresQuery__
 *
 * To run a query within a React component, call `useListLaboratoiresQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLaboratoiresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLaboratoiresQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListLaboratoiresQuery(baseOptions?: Apollo.QueryHookOptions<ListLaboratoiresQuery, ListLaboratoiresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLaboratoiresQuery, ListLaboratoiresQueryVariables>(ListLaboratoiresDocument, options);
      }
export function useListLaboratoiresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLaboratoiresQuery, ListLaboratoiresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLaboratoiresQuery, ListLaboratoiresQueryVariables>(ListLaboratoiresDocument, options);
        }
export type ListLaboratoiresQueryHookResult = ReturnType<typeof useListLaboratoiresQuery>;
export type ListLaboratoiresLazyQueryHookResult = ReturnType<typeof useListLaboratoiresLazyQuery>;
export type ListLaboratoiresQueryResult = Apollo.QueryResult<ListLaboratoiresQuery, ListLaboratoiresQueryVariables>;
export const GetParametresDocument = gql`
    query getParametres($keyList: [String!] = "") {
  parametres(where: {paramKey: {_in: $keyList}}) {
    paramKey
    paramValue
  }
}
    `;

/**
 * __useGetParametresQuery__
 *
 * To run a query within a React component, call `useGetParametresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParametresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParametresQuery({
 *   variables: {
 *      keyList: // value for 'keyList'
 *   },
 * });
 */
export function useGetParametresQuery(baseOptions?: Apollo.QueryHookOptions<GetParametresQuery, GetParametresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParametresQuery, GetParametresQueryVariables>(GetParametresDocument, options);
      }
export function useGetParametresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParametresQuery, GetParametresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParametresQuery, GetParametresQueryVariables>(GetParametresDocument, options);
        }
export type GetParametresQueryHookResult = ReturnType<typeof useGetParametresQuery>;
export type GetParametresLazyQueryHookResult = ReturnType<typeof useGetParametresLazyQuery>;
export type GetParametresQueryResult = Apollo.QueryResult<GetParametresQuery, GetParametresQueryVariables>;
export const GetExpiredTokenInfoDocument = gql`
    query GetExpiredTokenInfo($token: String!) {
  patientTempTokens(where: {token: {_eq: $token}}, limit: 1) {
    id
    patientId
    token
    expiresAt
    isUsed
    usedAt
    createdAt
    patient_tokens {
      id
      nom
      prenom
      email
      telephone
      chirurgien {
        id
        nom
        prenom
        clinique
        cognitoToken
      }
    }
  }
}
    `;

/**
 * __useGetExpiredTokenInfoQuery__
 *
 * To run a query within a React component, call `useGetExpiredTokenInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpiredTokenInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpiredTokenInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetExpiredTokenInfoQuery(baseOptions: Apollo.QueryHookOptions<GetExpiredTokenInfoQuery, GetExpiredTokenInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpiredTokenInfoQuery, GetExpiredTokenInfoQueryVariables>(GetExpiredTokenInfoDocument, options);
      }
export function useGetExpiredTokenInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpiredTokenInfoQuery, GetExpiredTokenInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpiredTokenInfoQuery, GetExpiredTokenInfoQueryVariables>(GetExpiredTokenInfoDocument, options);
        }
export type GetExpiredTokenInfoQueryHookResult = ReturnType<typeof useGetExpiredTokenInfoQuery>;
export type GetExpiredTokenInfoLazyQueryHookResult = ReturnType<typeof useGetExpiredTokenInfoLazyQuery>;
export type GetExpiredTokenInfoQueryResult = Apollo.QueryResult<GetExpiredTokenInfoQuery, GetExpiredTokenInfoQueryVariables>;
export const GetPatientFormDataDocument = gql`
    query GetPatientFormData($token: String!) {
  patientTempTokens(
    where: {token: {_eq: $token}, expiresAt: {_gt: "now()"}}
    limit: 1
  ) {
    id
    patientId
    token
    expiresAt
    formData
    lastSavedAt
    accessCount
    createdAt
    isUsed
    usedAt
    patient_tokens {
      id
      nom
      prenom
      email
      telephone
      sexe
      size
      birthday
      photicEffect
      glasses
      habitudes {
        id
        patientId
        heureReveil
        heureCoucher
        tempsLecture
        tempsOrdinateur
        tempsSmartphone
        tempsTablette
        tempsTelevision
        tempsConduite
        tempsCuisine
        tempsDiscussion
        tempsJeuxSociete
        tempsAutreVisionPres
        tempsSieste
      }
      activitePreferentielles {
        id
        patientId
        nom
        distanceMin
        distanceMax
      }
    }
  }
}
    `;

/**
 * __useGetPatientFormDataQuery__
 *
 * To run a query within a React component, call `useGetPatientFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientFormDataQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetPatientFormDataQuery(baseOptions: Apollo.QueryHookOptions<GetPatientFormDataQuery, GetPatientFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientFormDataQuery, GetPatientFormDataQueryVariables>(GetPatientFormDataDocument, options);
      }
export function useGetPatientFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientFormDataQuery, GetPatientFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientFormDataQuery, GetPatientFormDataQueryVariables>(GetPatientFormDataDocument, options);
        }
export type GetPatientFormDataQueryHookResult = ReturnType<typeof useGetPatientFormDataQuery>;
export type GetPatientFormDataLazyQueryHookResult = ReturnType<typeof useGetPatientFormDataLazyQuery>;
export type GetPatientFormDataQueryResult = Apollo.QueryResult<GetPatientFormDataQuery, GetPatientFormDataQueryVariables>;
export const ListPatientsWithStatusDocument = gql`
    query ListPatientsWithStatus($distinctOn: [PatientSelectColumn!], $limit: Int, $offset: Int, $orderBy: [PatientOrderBy!] = {updatedAt: DESC}, $where: PatientBoolExp) {
  patient(
    distinctOn: $distinctOn
    limit: $limit
    offset: $offset
    orderBy: $orderBy
    where: $where
  ) {
    id
    nom
    prenom
    birthday
    createdAt
    updatedAt
    isArchived
    oeils {
      id
      choixes {
        id
        final
      }
    }
  }
}
    `;

/**
 * __useListPatientsWithStatusQuery__
 *
 * To run a query within a React component, call `useListPatientsWithStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPatientsWithStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPatientsWithStatusQuery({
 *   variables: {
 *      distinctOn: // value for 'distinctOn'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListPatientsWithStatusQuery(baseOptions?: Apollo.QueryHookOptions<ListPatientsWithStatusQuery, ListPatientsWithStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPatientsWithStatusQuery, ListPatientsWithStatusQueryVariables>(ListPatientsWithStatusDocument, options);
      }
export function useListPatientsWithStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPatientsWithStatusQuery, ListPatientsWithStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPatientsWithStatusQuery, ListPatientsWithStatusQueryVariables>(ListPatientsWithStatusDocument, options);
        }
export type ListPatientsWithStatusQueryHookResult = ReturnType<typeof useListPatientsWithStatusQuery>;
export type ListPatientsWithStatusLazyQueryHookResult = ReturnType<typeof useListPatientsWithStatusLazyQuery>;
export type ListPatientsWithStatusQueryResult = Apollo.QueryResult<ListPatientsWithStatusQuery, ListPatientsWithStatusQueryVariables>;
export const GetPatientDocument = gql`
    query getPatient($id: uuid = "") {
  patientByPk(id: $id) {
    birthday
    chirurgienId
    glasses
    sameValue
    createdAt
    updatedAt
    etatControlateral
    activitePreferentielles {
      distanceMax
      distanceMin
      id
      nom
    }
    habitudes {
      heureCoucher
      heureReveil
      id
      tempsAutreVisionPres
      tempsConduite
      tempsCuisine
      tempsDiscussion
      tempsJeuxSociete
      tempsLecture
      tempsOrdinateur
      tempsSieste
      tempsSmartphone
      tempsTablette
      tempsTelevision
    }
    monovision
    nom
    oeilDominant
    oeils {
      aberrationOrdreEleve
      aberrationSpherique
      antecedantChirurgie
      bump
      choixes {
        implantId
        decalage
        decalageCourbeExistante
        affichageDefocus
        type
        materiau
        final
        laboratoireId
        implant {
          correctionOptique
          data
          display
          id
          laboratoire {
            nom
            id
          }
          materiau
          mb
          methodology
          n
          name
          note
          type
        }
      }
      diametrePupillaire
      endothelium
      id
      larmes
      longueurAxiale
      retineNerfOptique
      side
      aOperer
      antecedantChirurgieCristallin
      typeImplantActuel
      ajoutAddon
      genererCourbeTypeImplant
      courbeDefocus
      implantCourantId
      implantCourant {
        correctionOptique
        data
        display
        id
        laboratoire {
          nom
          id
        }
        materiau
        mb
        methodology
        n
        name
        note
        type
      }
    }
    photicEffect
    prenom
    sexe
    size
    lunettesVL
    lunettesVI
    lunettesVP
    sameImplant
  }
}
    `;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const GetPatientForLinkDocument = gql`
    query GetPatientForLink($id: uuid!) {
  patientByPk(id: $id) {
    id
    nom
    prenom
    email
    birthday
    sexe
    chirurgien {
      nom
      prenom
    }
  }
}
    `;

/**
 * __useGetPatientForLinkQuery__
 *
 * To run a query within a React component, call `useGetPatientForLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientForLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientForLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientForLinkQuery(baseOptions: Apollo.QueryHookOptions<GetPatientForLinkQuery, GetPatientForLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientForLinkQuery, GetPatientForLinkQueryVariables>(GetPatientForLinkDocument, options);
      }
export function useGetPatientForLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientForLinkQuery, GetPatientForLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientForLinkQuery, GetPatientForLinkQueryVariables>(GetPatientForLinkDocument, options);
        }
export type GetPatientForLinkQueryHookResult = ReturnType<typeof useGetPatientForLinkQuery>;
export type GetPatientForLinkLazyQueryHookResult = ReturnType<typeof useGetPatientForLinkLazyQuery>;
export type GetPatientForLinkQueryResult = Apollo.QueryResult<GetPatientForLinkQuery, GetPatientForLinkQueryVariables>;
export const ListPatientsDocument = gql`
    query listPatients($orderBy: [PatientOrderBy!] = {updatedAt: DESC}, $where: PatientBoolExp = {}) {
  patient(orderBy: $orderBy, where: $where) {
    id
    nom
    prenom
    birthday
    sexe
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useListPatientsQuery__
 *
 * To run a query within a React component, call `useListPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPatientsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListPatientsQuery(baseOptions?: Apollo.QueryHookOptions<ListPatientsQuery, ListPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPatientsQuery, ListPatientsQueryVariables>(ListPatientsDocument, options);
      }
export function useListPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPatientsQuery, ListPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPatientsQuery, ListPatientsQueryVariables>(ListPatientsDocument, options);
        }
export type ListPatientsQueryHookResult = ReturnType<typeof useListPatientsQuery>;
export type ListPatientsLazyQueryHookResult = ReturnType<typeof useListPatientsLazyQuery>;
export type ListPatientsQueryResult = Apollo.QueryResult<ListPatientsQuery, ListPatientsQueryVariables>;
export const StatsParChirurgienDocument = gql`
    query statsParChirurgien($chirurgien_id_param: _uuid = null, $where: PatientBoolExp = {}, $sexe_param: Int = null) {
  getRepartitionImplants(
    args: {chirurgien_id_param: $chirurgien_id_param, sexe_param: $sexe_param}
  ) {
    materiau
    nombreImplants
    pourcentage
    type
  }
  getMoyenneAgeTaillePatients(
    args: {chirurgien_id_param: $chirurgien_id_param, sexe_param: $sexe_param}
  ) {
    ageMoyen
    tailleMoyenne
  }
  getDistributionAgePatients(args: {chirurgien_id_param: $chirurgien_id_param}) {
    trancheAge
    nombrePatients
    hommes
    femmes
    nonPrecises
  }
  getRepartitionSexesPatients(args: {chirurgien_id_param: $chirurgien_id_param}) {
    nombre
    pourcentage
    sexe
  }
  patientAggregate(where: $where) {
    aggregate {
      count
    }
  }
  getRepartitionVisionPatients(
    args: {chirurgien_id_param: $chirurgien_id_param, sexe_param: $sexe_param}
  ) {
    pourcentageVi
    pourcentageVl
    pourcentageVp
  }
  getRepartitionActivitePreferentiellePatients(
    args: {chirurgien_id_param: $chirurgien_id_param, sexe_param: $sexe_param}
  ) {
    nombrePersonnes
    logmarValue
  }
}
    `;

/**
 * __useStatsParChirurgienQuery__
 *
 * To run a query within a React component, call `useStatsParChirurgienQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsParChirurgienQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsParChirurgienQuery({
 *   variables: {
 *      chirurgien_id_param: // value for 'chirurgien_id_param'
 *      where: // value for 'where'
 *      sexe_param: // value for 'sexe_param'
 *   },
 * });
 */
export function useStatsParChirurgienQuery(baseOptions?: Apollo.QueryHookOptions<StatsParChirurgienQuery, StatsParChirurgienQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsParChirurgienQuery, StatsParChirurgienQueryVariables>(StatsParChirurgienDocument, options);
      }
export function useStatsParChirurgienLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsParChirurgienQuery, StatsParChirurgienQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsParChirurgienQuery, StatsParChirurgienQueryVariables>(StatsParChirurgienDocument, options);
        }
export type StatsParChirurgienQueryHookResult = ReturnType<typeof useStatsParChirurgienQuery>;
export type StatsParChirurgienLazyQueryHookResult = ReturnType<typeof useStatsParChirurgienLazyQuery>;
export type StatsParChirurgienQueryResult = Apollo.QueryResult<StatsParChirurgienQuery, StatsParChirurgienQueryVariables>;
export const StatsUtilisationDocument = gql`
    query statsUtilisation($chirurgien_id_param: _uuid = "") {
  evolutionChirurgiens {
    mois
    nombreChirurgiens
  }
  getPatientMoyenParChirurgiens(args: {chirurgien_id_param: $chirurgien_id_param}) {
    mois
    nombrePatients
    recrutementMoyenParChirurgien
  }
  chirurgienAggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useStatsUtilisationQuery__
 *
 * To run a query within a React component, call `useStatsUtilisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatsUtilisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatsUtilisationQuery({
 *   variables: {
 *      chirurgien_id_param: // value for 'chirurgien_id_param'
 *   },
 * });
 */
export function useStatsUtilisationQuery(baseOptions?: Apollo.QueryHookOptions<StatsUtilisationQuery, StatsUtilisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatsUtilisationQuery, StatsUtilisationQueryVariables>(StatsUtilisationDocument, options);
      }
export function useStatsUtilisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatsUtilisationQuery, StatsUtilisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatsUtilisationQuery, StatsUtilisationQueryVariables>(StatsUtilisationDocument, options);
        }
export type StatsUtilisationQueryHookResult = ReturnType<typeof useStatsUtilisationQuery>;
export type StatsUtilisationLazyQueryHookResult = ReturnType<typeof useStatsUtilisationLazyQuery>;
export type StatsUtilisationQueryResult = Apollo.QueryResult<StatsUtilisationQuery, StatsUtilisationQueryVariables>;
export const SubImplantsDocument = gql`
    subscription subImplants {
  implant(orderBy: {laboratoire: {nom: ASC}, name: ASC}) {
    id
    type
    materiau
    laboratoire {
      id
      nom
    }
    favoris {
      chirurgienId
    }
    name
  }
}
    `;

/**
 * __useSubImplantsSubscription__
 *
 * To run a query within a React component, call `useSubImplantsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubImplantsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubImplantsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubImplantsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubImplantsSubscription, SubImplantsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubImplantsSubscription, SubImplantsSubscriptionVariables>(SubImplantsDocument, options);
      }
export type SubImplantsSubscriptionHookResult = ReturnType<typeof useSubImplantsSubscription>;
export type SubImplantsSubscriptionResult = Apollo.SubscriptionResult<SubImplantsSubscription>;
export const SubPatientDocument = gql`
    subscription subPatient($id: uuid = "") {
  patientByPk(id: $id) {
    birthday
    chirurgienId
    glasses
    sameValue
    createdAt
    etatControlateral
    activitePreferentielles {
      distanceMax
      distanceMin
      id
      nom
    }
    habitudes {
      heureCoucher
      heureReveil
      id
      tempsAutreVisionPres
      tempsConduite
      tempsCuisine
      tempsDiscussion
      tempsJeuxSociete
      tempsLecture
      tempsOrdinateur
      tempsSieste
      tempsSmartphone
      tempsTablette
      tempsTelevision
    }
    monovision
    nom
    oeilDominant
    oeils {
      aberrationOrdreEleve
      aberrationSpherique
      antecedantChirurgie
      bump
      choixes {
        implantId
        decalage
        decalageCourbeExistante
        affichageDefocus
        type
        materiau
        final
        laboratoireId
        implant {
          correctionOptique
          data
          display
          id
          laboratoire {
            nom
            id
          }
          materiau
          mb
          methodology
          n
          name
          note
          type
        }
      }
      diametrePupillaire
      endothelium
      id
      larmes
      longueurAxiale
      retineNerfOptique
      side
      aOperer
      antecedantChirurgieCristallin
      typeImplantActuel
      ajoutAddon
      genererCourbeTypeImplant
      courbeDefocus
      implantCourantId
      implantCourant {
        correctionOptique
        data
        display
        id
        laboratoire {
          nom
          id
        }
        materiau
        mb
        methodology
        n
        name
        note
        type
      }
    }
    photicEffect
    prenom
    sexe
    size
    lunettesVL
    lunettesVI
    lunettesVP
    sameImplant
  }
}
    `;

/**
 * __useSubPatientSubscription__
 *
 * To run a query within a React component, call `useSubPatientSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubPatientSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubPatientSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubPatientSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubPatientSubscription, SubPatientSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubPatientSubscription, SubPatientSubscriptionVariables>(SubPatientDocument, options);
      }
export type SubPatientSubscriptionHookResult = ReturnType<typeof useSubPatientSubscription>;
export type SubPatientSubscriptionResult = Apollo.SubscriptionResult<SubPatientSubscription>;